import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, isNotNull,messageShow, millisecondToDate,getPlatformName,systemConfig,getZkShopName,getTaoteShopName,debounceOther, fromClassName,getTaoteId  } from '../../utils/http';
import { Input, Select, Button, Pagination, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog,Progress,Popover} from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import TableNavChange from '../../components/tableNavChange/tableNavChange';
import PlatformName from '../../components/platformName/index.jsx';
import $ from 'jquery';
import './orderList.less';
import ShowModal from '../../components/showModal/index.jsx';
import { getLastSyncTime,GetPayUrlRequest,GetPayResultRequest,CancelPurchaseOrderRequest, getZhuKeReqTask,SyncOrderByIdsRequest,batchDistributionRequest,productRequest} from '../../utils/api';
import { purchaseOrderRequest } from '../../utils/api';
import QRCode from 'qrcode.react';
import { MessageBox } from 'element-react/next';
import ChangeProductsModule from '../../components/changeProductsModule/index.jsx';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import SkuMappingsModule from '../../components/skuMappingsModule/index.jsx';
import ChangeProductsModuleV2 from '../../components/changeProductsModuleV2/index.jsx';
import SingleCheckSkuModule from '../../components/singleCheckSkuModule/index.jsx';
import MultiProductSkuMappingModule from '../../components/multiProductSkuMappingModule/index.jsx';
import {Workbook} from 'exceljs';
import { huoyuanLink, huoyuanLinkReport } from '../../utils/index.js';
import { requestNotic} from '../../utils/notic.js';
import { otherClickExposureReport, productExposureReport } from '../../utils/alibabareport.js';

class orderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alibabaPageKey:'order_list',
      orderStatus: [
        { id: 0, value: "", title: "待发货", active: true, num: 0 },
        { id: 1, value: "", title: "已发货", active: false, num: 0 },
        { id: 2, value: "", title: "交易完成", active: false, num: 0 },
        { id: 3, value: "", title: "交易关闭", active: false, num: 0 },
        { id: 4, value: "", title: "退款中", active: false, num: 0 },
        { id: 5, value: "", title: "忽略订单", active: false, num: 0 },
      ],
      orderStatusIndex: 0,
      sourcePlatformList: [
        { id: 1, value: "", title: "全部订单", number: "",isHide:false, active: true },
        { id: 2, value: "AlibabaZhuKe", title: "已关联货源", number: "0",isHide:false, active: false },
        // { id: 3, value: "TaoteZhuKe", title: "非1688货源", number: "0",isHide:false, active: false },
        { id: 4, value: "no_relation", title: "未关联货源", number: "0",isHide:false, active: false },
      ],
      sourcePlatformIndex:0,
      purchaseOrderStatusList: [
        { id: 0, value: "", title: "全部",number:-1, active: false,isHide :true},
        { id: 1, value: "waitpurchase", title: "待采购",number:0, active: true },
        { id: 2, value: "waitbuyerpay", title: "待支付",number:-1, active: false },
        { id: 3, value: "waitsellersend", title: "待发货",number:-1, active: false }
      ],
      purchaseOrderStatusIndex: 1,
      orderProductByType:'ProductID',

      //===================================店铺相关=====================================
      isAuthShop:false,//当前店铺已经授权过期
      shopList:[],//店铺列表
      selectShopPlatformType:null,
      selectShopId: "",//当前登录的店铺id，非阿里的
      selectShopName: '',//列表显示的店铺名称
      selectPlatformType: "WxVideo",//当前登录的店铺类型

      //===================================订单相关=====================================
      orderList: [],//订单
      orderListDto: {//查询订单请求参数
        OrderStatus: 'waitsellersend',//订单状态
      },

      //==================================分页相关======================================
      current:1,//页码
      totals:0,//总记录数
      pagesize: 30,//页数
      
      //=================================加载框=======================================
      isLoading:false,
      loadingTitle:'加载店铺信息...',

      showTaoteFooter:true,//点击非1688货源订单展示是否展示底部通知

      //=================================同步功能相关=======================================
      sysncOrderStatusTaskProgress: 100,//同步进度
      lastSyncTimeByShop: '',//最后同步时间，店铺的维度


      //取消订单跳转后，弹出确认是否需要刷新数据
      isShowModalByCancelExamine: false,
      
      selectOrderList: [],//选择的平台订单
      selectPurchaseOrderList: [],//选择的订单，对应的采购单
      isIgnoreLimitExpressly:0,//是否忽略明文解密，继续操作，1是忽略
      ignorePurchaseEncryptionType:0,//0 默认 验证是否存在不支持密文下单的选项，1 仅支持密文服务订单，2采购所有订单
      isShowModalBynotCategory: false,//提示是否设置规格
      isShowModalBynotCategoryDouble: false,//提示是否设置规格弹窗New,可以未映射，按已映射的下单
      notCategoryList: [],//未匹配的规格数据。
      notCategoryListQu: [],//未匹配的规格数据(去重，没有code)。
      notCategoryListTitle:"",
      notSetProductList: [],//未设置规格，查询的商品列表
      isShowCommonError: false,
      showCommonErrorMessage: '',
      createOrderError:[],
      

      //获取付款方式，提示
      isShowModalBySelectPayment: false,
      showModalByPaymentPaymentMoney: 0,
      isShowAutoPayButton: false,//是否开通了自动代扣

      //获取【付款方式】错误，提示
      isShowModalBySelectPaymentError: false,
      getPaymentErrorFaildOrderList: [],
      getPaymentErrorNotWaitPayIds: [],
      getPaymentErrorPayChannelsList: [],

      isShowModalByPayUrl: false,//手动支付后，弹窗提示是否操作完成


       //获取手动支付，【付款链接】错误，提示
       isShowModalByPayUrlError: false,
       getPayUrlErrorFaildOrderList: [],
       getPayUrlErrorPayChannelsList: [],
 
       //自动代扣失败，提示
       isShowModalByAutoPaymentError: false,
       //自动代扣成功，提示
       isShowModalByAutoPaymentSuccess: false,
       autoPaymentSuccessPayingOrderIds: [],
       autoPaymentSuccessNotWaitPayIds: [],
       autoPaymentSuccessFaildOrderIds: [],


       payModel:{
        PayUrl:'',//支付链接
        Code:'',//回传code
        ExpireTime:0,//支付授权有效期
        qrcodeShow:false,
        timespan:0,//倒计时
        OrderCodes:[],
        skuMappingsTitle:'匹配规格'
      },//淘特支付


      isShowMoreTypePay:false,//多种支付类型弹窗
      aliPayOrderCodeList:[],//阿里采购单支付列表（多支付类型时使用）
      taoTePayOrderCodeList:[],//淘特采购单支付列表（多支付类型时使用）

      isShowWaiSendTopCount:false,//是否显示待发货的数量。（列表查询初始化，通过这个开关不显示。有其他的方法统计）

      multiProductSkuMappingModuleList:[],

      tagEnum:{//订单标记集合
        KsRiskOrder:{
          tagName:"风控订单",
          tagClass:'danger_tag',
          clickContent:this.ksRiskOrderTagClickContent,
        },
        PddRiskOrder:{
          tagName:"风控订单",
          tagClass:'danger_tag',
          clickContent:this.pddRiskOrderTagClickContent,
        },
        KsPriorityDeliveryr:{
          tagName:"优先发货",
          tagClass:'warning_tag',
        },
        KsSpecialRefundPriceProtectTag: {
          tagName: "价保",
          tagClass: 'warning_tag',
        },
        KsSpecialRefundGroupTag: {
          tagName: "万人团",
          tagClass: 'warning_tag',
        },
        PddShipHold:{
          tagName:"暂停发货",
          clickContent:this.pddShipHoldTagClickContent,
          tagClass:'warning_tag',
        },
        KsRemindShipmentSignTag:{
          tagName:"催发货",
          predicate: (order,tag) => { return order.SellerOrder.PlatformStatus == 'waitsellersend' },
          clickContent:(order,tag) =>{ return <div>催发货时间： {tag.TagValue}</div>},
          tagClass:'warning_tag',
        },
        OrderAddressUpdate:{
          tagName:"地址变更",
          style:{zIndex:"10000",maxWidth:"680px"},
          clickContent:this.ksAddressUpdate,
          tagClass:'warning_tag',
        },
        OrderReceiverUpdate:{
          tagName:"地址变更",
          style:{zIndex:"10000",maxWidth:"680px"},
          clickContent:this.ksAddressUpdate,
          tagClass:'warning_tag',
        },
        TouTiaoLogisticsTransitTag:{
          tagName:"偏远中转",
          style:{zIndex:"10000",maxWidth:"680px"},
          clickContent:this.orderLogisticsTransit,
          tagClass:'danger_tag',
        },
        TouTiaoRemoteDerictTag:{
          tagName:"偏远直邮",
          style:{zIndex:"10000",maxWidth:"680px"},
          tagClass:'warning_tag',
        },
        KsLogisticsTransitTag:{
          tagName: "中转订单",
          style: { zIndex: "10000", maxWidth: "680px" },
          clickContent: this.orderKsLogisticsTransit,
          tagClass: 'warning_tag',
        },
        KsShunfengTag:{
          tagName: "顺丰包邮",
          style: { zIndex: "10000", maxWidth: "680px" },
          clickContent: this.orderKsShunfeng,
          tagClass: 'warning_tag',
        },
        KsRecommonedShunfengTag:{
          tagName: "推荐使用顺丰发货",
          style: { zIndex: "10000", maxWidth: "680px" },
          clickContent: this.orderKsRecommonedShunfeng,
          tagClass: 'warning_tag',
        },
        PddHomeDeliveryDoorTag:{
          tagName: "送货上门",
          style: { zIndex: "10000", maxWidth: "680px" },
          clickContent: this.orderPddHomeDeliveryDoor,
          tagClass: 'warning_tag',
        },
        XiaoHongShuHomeDeliveryTag:{
          tagName: "送货上门",
          style: { zIndex: "10000", maxWidth: "680px" },
          clickContent: this.orderXiaoHongShuHomeDelivery,
          tagClass: 'warning_tag',
        },
        PddDirectMailActivityTag: {
          tagName: "直邮活动",
          style: { zIndex: "10000", maxWidth: "680px" },
          clickContent: this.orderPddDirectMailActivity,
          tagClass: 'warning_tag',
        },
        TouTiaoChooseDeliveryTag: {
          tagName: "自选快递",
          clickContent: this.orderTouTiaoChooseDelivery,
          tagClass: 'danger_tag',
        },
        PddLocalDepotTag: {
          tagName: "本地仓订单",
          clickContent:this.orderPddLocalDepotActivity,
          tagClass: 'danger_tag',
        },
        WeixinPresentTag: {
          tagName: "礼物",
          style: { zIndex: "10000", maxWidth: "680px" },
          clickContent: this.orderWeixinPresent,
          tagClass: 'danger_tag',
        },
        TouTiaoRiskTag:
        {
          tagName: "平台风控",
          clickContent: this.touTiaoRiskOrderTagClickContent,
          tagClass: 'danger_tag',
        },
        TouTiaoRiskNoPassTag:
        {
          tagName: "风控不通过",
          clickContent: this.touTiaoRiskNoPassOrderTagClickContent,
          tagClass: 'warning_tag',
        },
        KuaiShouRiskTag:
        {
          tagName: "平台风控",
          clickContent: this.kuaiShouRiskOrderTagClickContent,
          tagClass: 'danger_tag',
        },
        KuaiShouRiskNoPassTag:
        {
          tagName: "风控不通过",
          clickContent: this.kuaiShouRiskNoPassOrderTagClickContent,
          tagClass: 'warning_tag',
        },     
        WxVideoChangeSkuTag:{
          tagName: "换款",
          style: { zIndex: "10000", maxWidth: "680px" },
          clickContent: this.orderWeixinPresentChangeSku,
          tagClass: 'danger_tag',
        }
      },
      purchaseTagEnum:{
        OrderAddressUpdate:{
          tagName:"地址变更",
          style:{zIndex:"10000",maxWidth:"600px"},
          tagClass:'warning_tag',
        },
        OrderReceiverUpdate:{
          tagName:"地址变更",
          style:{zIndex:"10000",maxWidth:"680px"},
          tagClass:'warning_tag',
        }
      },
      allOrderSendChangeAddressDialog:false,
      isShowModalChangeSku:false,
      changeSkuOrderCode:"",
      isFirstOrderQuery:true,
      isChangeSp: false
    };
  }

   //#region 初始化 （折叠）
  componentDidMount() {
     //拼多多的导出标签，加载时，隐藏
     $("#exportByRightId").css({ display: "none" });
     $("#sendErrorByLeftId").css({ display: "none" });
     
    var zhukeToken = getToken();
    var that = this;
    if (zhukeToken != "")
      that.loadData();
    else {

      setTimeout(() => {
        var zhukeTokenTwo = getToken();
        if (zhukeTokenTwo == "") {
          var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
          //var hasZhukeLoginShopTokens = "";//测试。
          if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
            loadZhuKeToken(hasZhukeLoginShopTokens);

            setTimeout(() => {
              var zhukeTokenThree = getToken();
              if (zhukeTokenThree != "")
                that.loadData();
              else
                that.setState({ isShowWarn: true });

            }, 500);
          } else
            that.setState({ isShowWarn: true });
        } else
          that.loadData();
      }, 500);

    }
  }

  changeLeftNav = (name) => {
    this.props.history.replace(name)
  }
  loadData = () => {
    var shopInfo = getLoginShopInfo();
    var that = this;
    this.setState({
      selectShopId: shopInfo.loginShopId,
      selectShopName: shopInfo.loginShopName,
      selectPlatformType: shopInfo.loginShopPlatformType,
    }, () => {
      that.queryButton();
      that.syncOrderByStatus();
      that.loadWaitSendByTopNumberShow();
      that.getExpireAlibabaZhuke();
      //requestNotic(shopInfo.loginShopPlatformType);
    })

  }

  getExpireAlibabaZhuke = () => {
    var data = {
      SystemVersions: 'pc'
    };
    var that = this;
    requests({
      url: "/Common/GetIndexByUserInfo",
      data: data,
      success: (json) => {
        if (json.Success) {
          var result = json.Data;
          var endDay = result.EndDay;
          if (isNotNull(endDay)) {
            var endDayInt = parseInt(endDay);
            if (endDayInt < 8) {
              var hasExpiredShow = localStorage.getItem("hasExpiredShow") || null;
              var todayExpiredShow = "hasExpiredShow" + (new Date().getMonth() - 0 + 1) + new Date().getDay();
              //一天显示一次
              if (hasExpiredShow != todayExpiredShow) {
                var hasDonghua = "hasExpiredShow" + (new Date().getMonth() - 0 + 1) + new Date().getDay();
                localStorage.setItem("hasExpiredShow", hasDonghua);
                MessageBox.msgbox({
                  title: '授权提示',
                  message: <span>1688货源授权即将到期<span style={{ color: "#fa1f07", "fontSize": "16px" }}>剩余7天</span>,请及时续订并授权以免影响您铺货和订单回流</span>,
                  type: 'warning',
                  showCancelButton: false,
                  confirmButtonText: '前往续订并授权'
                }).then((action) => {
                  if (action == 'confirm') {
                    const path = { pathname: '/myAuth', state: { from_action: "alibaba_auth_expire" } }
                    that.props.history.push(path);
                  }
                });
              }
            }
          }
        } else {

        }

      },
      fail: (err) => {

      }
    })


  }

   //#endregion


  //#region 订单列表查询 （折叠）
  loadList = () => {
    if (this.state.isShowWarn) {
      Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
      return;
    }

    this.loadTouTiaoSdkJs();

    let obj = this.loadOrderData();
    //console.log(JSON.stringify(obj));

    this.setState({ isLoading: true, loadingTitle: "加载中...", });
    let that = this;
    requests({
      url: "/Order/ListV2",
      data: obj,
      success: function (res) {
        that.setState({ isLoading: false });
        var orderStatusList = that.state.orderStatus;
        var purchaseOrderStatusList=that.state.purchaseOrderStatusList;
        if (res.Success) {
          var orderList = res.Data.Orders;
          var totals = res.Data.TotalCount;
          that.loadOrderTags(res.Data.Orders,obj.ShopId);
          that.getLogisticsInfo(res.Data.Orders)
          var tempOrders = res.Data.Orders || [];
          if (tempOrders.length == 0)
            that.setState({ isNotList: true });
          else
            that.setState({ isNotList: false });

          if (orderList == null || orderList == undefined)
            orderList = [];
          var reprotid=[];
          var orderStatusIndex = that.state.orderStatusIndex;
          for (let i = 0; i < orderList.length; i++) {
            orderList[i].ShopName = that.state.selectShopName;
            orderList[i].SellerOrder.LastShipTimeValue = "";
            if (isNotNull(orderList[i].SellerOrder.LastShipTime) && (orderStatusIndex == 0 || orderStatusIndex == 1 || orderStatusIndex == 2)) {
              var nowTime = new Date().getTime();
              var LastTime = new Date(orderList[i].SellerOrder.LastShipTime).getTime();
              var LastShipTime = LastTime - nowTime;

              if (LastShipTime < 43200000)//小于12小时都标红色
                orderList[i].SellerOrder.LastShipTimeIsRed = true;

              if (LastShipTime > 0)
                orderList[i].SellerOrder.LastShipTimeValue = millisecondToDate(LastShipTime);
              else {
                orderList[i].SellerOrder.LastShipTimeValue = "已超时 " + millisecondToDate(-LastShipTime);
                orderList[i].SellerOrder.LastShipTimeIsEnd = true;
              }


            }
            for(let orderItem of orderList[i].SellerOrder.OrderItems) {
              orderItem.PlatformType = orderList[i].SellerOrder.PlatformType
              orderItem.OrderCode = orderList[i].SellerOrder.OrderCode
              if(reprotid.includes(orderItem.SupplierProductId) == false && orderItem.SupplierProductId) {
                reprotid.push(orderItem.SupplierProductId);
              }
            }
          }

          productExposureReport(reprotid, that.state.alibabaPageKey);

          if (that.state.isShowWaiSendTopCount == true && that.state.orderStatusIndex != 0)
              orderStatusList.find(x => x.active == true).num = totals;

          if(that.state.orderStatusIndex == 0)
          {
            //{ id: 1, value: "waitpurchase", title: "待采购", number: "0", active: true },
            purchaseOrderStatusList.forEach(x => {
              if(x.active ==true)
                 x.number=totals;
              else 
                 x.number=-1;
            })
          }


          that.setState({ orderList: orderList, totals: totals, orderStatus: orderStatusList });

          that.orderListCheckboxClose();
        } else {
          Message({
            showClose: true,
            message: res.Message,
            type: 'error'
          });
        }
      },
      fail: (err) => { }
    });
  }

  //获取列表，拼接请求数据
  loadOrderData() {
    
    const dto = { };
    var  shopid = this.state.selectShopId;

    const dayas = $("#selectChooseDateId").val();
    const wangwang = $("#supplierWangWangInputId").val();//供应商旺旺
    const orderId = $("#orderListInputOrderId").val();

    const orderStatusList = this.state.orderStatus;
    const indexs = orderStatusList.find(x => x.active == true).id;
    const sourcePlatformStatus = this.state.sourcePlatformList.find(x => x.active).value;

    if (indexs == 0)//待确认
    {
      dto.OrderStatus = "waitsellersend";
      dto.OrderSubState = this.state.orderSubstate;
    }else if(indexs == 1){
      dto.OrderStatus = "waitbuyerreceive";
      dto.OrderSubState = ''
    }else if(indexs == 2){
      dto.OrderStatus = "success";
      dto.OrderSubState = ''
    }
    else if(indexs == 3){
      dto.OrderStatus = "cancel";
      dto.OrderSubState = ''
    }
    else if(indexs == 4){
      dto.OrderStatus = "wait_seller_agree";
      dto.OrderSubState = ''
    }
    else if(indexs == 5){
      dto.OrderStatus = "ignore";
      dto.OrderSubState = ''
    }

    const orderBySort = this.state.orderBySort;//排序
    let orderBy = "desc";
    if (orderBySort != "desc")
      orderBy = "asc";
   
    const orderProductByType = this.state.orderProductByType;
    if (orderProductByType == "ProductID")
      dto.ProductID = $("#orderProductByTypeInputeId").val();//商品id
    else
      dto.ProductSubject = $("#orderProductByTypeInputeId").val();//商品标题

    dto.OrderBy = orderBy;
    dto.PlatformOrderId = orderId;
    dto.PageIndex = this.state.current;
    dto.PageSize = this.state.pagesize;
    dto.SystemVersions = "pc";
    dto.SupplierWangWang = wangwang;
    dto.PlatformType = this.state.selectPlatformType;
    dto.Days = dayas;
    dto.ShopId =""+ shopid +"";
    dto.SourcePlatformStatus = sourcePlatformStatus;
    dto.PurchaseOrderStatus =  this.state.purchaseOrderStatusList.find(x => x.active).value;
    if (this.state.isFirstOrderQuery) {
      dto.IsSync = "1";//查询不触发同步
      this.setState({
        isFirstOrderQuery: false,
      });
    } else {
      dto.IsSync = "0";
    }

    if(indexs == 3){
      if (this.state.refundType == "noRefund")
        dto.PurchaseOrderStatus = "purchase_no_refund";
      else if (this.state.refundType == "refund")
        dto.PurchaseOrderStatus = "purchase_refund";
    }
    return dto;
  }

  searchTradingclose = (e, refundType) => {
    this.setState({
      refundType,
      current: 1, isLoading: true
    }, () => {
      this.loadList();
    })

  }


  queryButton = (isQuery) => {
    if (isQuery) {  //为true 时为搜索调用  current恢复第1页
      this.setState({ current: 1 }, () => {
        this.loadList();
      })
    } else {     //为切换页码时调用
      this.loadList();
    }

  }

  loadTouTiaoSdkJs = () => {
    var platformType = this.state.selectPlatformType;
    var isLoadTouTiaoSdkJs = this.state.isLoadTouTiaoSdkJs;
    if (platformType == "TouTiao" && isLoadTouTiaoSdkJs == false) {
      try {
        const script = document.createElement("script");
        script.src = "https://lf3-open-web-sdk.bytetos.com/obj/open/sdk_v2.js";
        script.async = true;
        document.body.appendChild(script);

        setTimeout(() => {
          try{
            const appkey = '6925303336539309583';//头条应用的appkey
            const ownerCode = this.state.zhukeOwnerCode;
            window.BYTES_OPEN_int({
              accountId: ownerCode,  // 服务商账号体系中的用户唯一id，每个ISV下需要保证唯一，可选格式：1）独立生成的账户唯一标识     
              appKey: appkey,         // 应用创建完成后被分配的key     
              sensUrls: [               // 配置会访问open侧敏感信息的url-path       
                "/PurchaseOrder/CreateOrder.*"         // 可以写完整的url-path，如果url中包含参数，参数部分可以用正则表达式'.*'       
              ],
            })
          }catch(ee){
            console.log("初始化头条sdk错误22：" + ee);
          }
         
        }, 2000);

        this.setState({ isLoadTouTiaoSdkJs: true });
      } catch (e) {
        console.log("初始化头条sdk错误：" + e);
      }
    }
  }


  changeCurrent = (current) => {
    this.setState({
      current,
      checkAll: false
    }, () => {
      this.queryButton();
    })
  }
  changePageSize = (size) => {
    this.setState({
      pagesize: size,
      current: 1,
    }, () => {
      this.queryButton();
    })
  }

  //切换时间
  changeSelect = (name, value) => {
    this.setState({
      [name]: value
    })
  }
  onChangeInput = (name, value) => {
    let obj = {};
    obj[name] = value.trim();
    this.setState(obj);
  }


  //订单状态切换
  changeNav = (item) => {
    if (item.title == "交易关闭") {
      $("#searchWarn").css({ display: "flex" })
    } else {
      $("#searchWarn").css({ display: "none" })
    }


    if (item.title == "待确认" || item.title == "待付款" || item.title == "待发货") {
      $("#waitingSendExportId").css({ display: "flex" });
    } else
      $("#waitingSendExportId").css({ display: "none" });

    if (item.title == "待确认")
      $("#mergeOrderByLeftId").css({ display: "flex" });
    else
      $("#mergeOrderByLeftId").css({ display: "none" });

    var selectShopPlatformType = this.state.selectPlatformType;
    //隐藏，由于二级状态默认是全部，这里先不显示。。切换二级状态会显示
    // if (item.title == "待发货" && selectShopPlatformType !="Pinduoduo" )
    //   $("#sendErrorByLeftId").css({ display: "flex" });
    // else
    //   $("#sendErrorByLeftId").css({ display: "none" });

    if (item.title == "待发货" && selectShopPlatformType == "Pinduoduo" && this.state.purchaseOrderStatusIndex ==3)
    {
      $("#exportByRightId").css({ display: "flex" });
    }
    else
     {
      $("#exportByRightId").css({ display: "none" });
     }
    


      

    this.substateCheckboxEmpty();//清空子状态勾选


    var orderStatus = this.state.orderStatus;
    for (var i = 0; i < orderStatus.length; i++) {
      if (orderStatus[i].id == item.id)
        orderStatus[i].active = true;
      else
        orderStatus[i].active = false;
    }


    var purchaseOrderStatusIndex=this.state.purchaseOrderStatusIndex; 
    var purchaseOrderStatusList = this.state.purchaseOrderStatusList;
    var sourcePlatformList = this.state.sourcePlatformList;
     var isShowWaiSendTopCount = this.state.isShowWaiSendTopCount;
    if (item.id != 0)//不是在待发货的状态下，采购单选择重置
    {
      purchaseOrderStatusList.forEach(x => x.active = false)
      purchaseOrderStatusList[0].active = true;//0是全部
      purchaseOrderStatusIndex = 0;

      sourcePlatformList.forEach(x => {
        x.active = false;
        x.isHide = false;
      })
      sourcePlatformList[0].active = true;//0是全部
    } else {
      purchaseOrderStatusList.forEach(x => x.active = false)
      purchaseOrderStatusList[1].active = true;//1是待采购
      purchaseOrderStatusIndex = 1;

      sourcePlatformList.forEach(x => {
        x.active = false;
        x.isHide = false;
      })
      sourcePlatformList[0].active = true;//0是全部
      isShowWaiSendTopCount = false;
    }
      

    this.setState({ 
      orderStatus: orderStatus, 
      orderStatusIndex: item.id,
      purchaseOrderStatusIndex:purchaseOrderStatusIndex, 
      purchaseOrderStatusList:purchaseOrderStatusList,
      sourcePlatformList:sourcePlatformList,
      isShowWaiSendTopCount:isShowWaiSendTopCount,
      refundType: "", 
      orderSubstate: "" 
     }, () => {
      this.queryButton(true);
    })
   }

     //切换货源平台
     changeSourcePlatform(item){
      const current = this.state.sourcePlatformList.find(x => x.active);
      if(current.id == item.id) return;
      if(item.value == 'TaoteZhuKe' && localStorage.getItem('orderList_hasChangeTaoteSourcePlatform') != '1')
      {
        localStorage.setItem('orderList_hasChangeTaoteSourcePlatform','1')
        this.setState({'taoteCanNotOperateDailog':true})
      }
      this.state.current = 1
      this.state.refundType = '';
      this.state.sourcePlatformList.forEach(x => x.active = false)
      item.active = true
      this.state.sourcePlatformIndex = item.id;
      this.setState({ isLoading:true},()=>{ this.loadList() })
    }
  
   //切换采购单状态
   changePurchaseOrderStatus(item){
    const current = this.state.purchaseOrderStatusList.find(x => x.active);
    if(current.id == item.id) return;
    this.state.refundType = '';
    this.state.current = 1
    this.state.purchaseOrderStatusList.forEach(x => x.active = false)
    item.active = true;
  
    
    this.setState({ isLoading:true,purchaseOrderStatusIndex:item.id},()=>{ this.ziOrderStatus() })
   }

   //子状态按钮显示
  ziOrderStatus(){
    var selectShopPlatformType = this.state.selectPlatformType;
    var purchaseOrderStatusIndex=this.state.purchaseOrderStatusIndex;
    if (purchaseOrderStatusIndex ==3  &&selectShopPlatformType !="Pinduoduo" )
    $("#sendErrorByLeftId").css({ display: "flex" });
    else
    $("#sendErrorByLeftId").css({ display: "none" });


    if(purchaseOrderStatusIndex ==3  && selectShopPlatformType == "Pinduoduo")
      $("#exportByRightId").css({ display: "flex" });
    else
      $("#exportByRightId").css({ display: "none" });

      
    var sourcePlatformList=this.state.sourcePlatformList;

    sourcePlatformList.forEach(x => x.active = false)
    sourcePlatformList[0].active = true;
    if(purchaseOrderStatusIndex ==2  || purchaseOrderStatusIndex ==3)
    {
      //如果选择的就是隐藏的未关联货源。由于需要影响，把设置改下
      // const sourcePlatformStatusIndex = sourcePlatformList.find(x => x.active).value;
      // if(sourcePlatformStatusIndex == "no_relation")
      // {
      //   sourcePlatformList[1].active=true;
      //   sourcePlatformList[3].active=false;
      // }

      sourcePlatformList[0].isHide=true;
      sourcePlatformList[1].isHide=true;
      sourcePlatformList[2].isHide=true;
    }
    else {

      sourcePlatformList[0].isHide=false;
      sourcePlatformList[1].isHide=false;
      sourcePlatformList[2].isHide=false;
    }
       

    //console.log("sourcePlatformList:"+JSON.stringify(sourcePlatformList))
    this.setState({sourcePlatformList:sourcePlatformList},()=>{this.loadList()});
  }



   //关闭状态下的子状态
  searchTradingclose = (e, refundType) => {
    this.setState({
      refundType,
      current: 1, isLoading: true
    }, () => {
      this.loadList();
    })

  }

  //子状态查询
  substateByCheckbox = (types) => {

    var isTrue = $("#" + types + "_checkboxId").is(':checked');

    var checkList = $("input[name='checkboxNameByOrderStatus']");
    for (let i = 0; i < checkList.length; i++) {
      var ck = $(checkList[i]);
      if (ck.val() == types) {
        ck.prop({ checked: isTrue });
      }
      else
        ck.prop({ checked: false });
    }

    if (!isTrue)
      types = "";


    


    this.setState({ isLoading: true, current: 1, refundType: "", orderSubstate: types }, () => {
      this.loadList();
    });

  }

  //清空子状态勾选
  substateCheckboxEmpty = () => {
    var checkList = $("input[name='checkboxNameByOrderStatus']");
    for (let i = 0; i < checkList.length; i++) {
      var ck = $(checkList[i]);
      ck.prop({ checked: false });
    }
  }

  //订单编号输入框，输入后，其他的输入框就不会有效。
  orderInputOnClick = () => {
    var orderId = $("#orderListInputOrderId").val();
    if (orderId != "" && orderId != null && orderId != undefined) {
      $("#supplierWangWangInputId").attr("disabled", "disabled");
      $("#orderProductByTypeInputeId").attr("disabled", "disabled");
    } else {
      $("#supplierWangWangInputId").removeAttr('disabled');
      $("#orderProductByTypeInputeId").removeAttr('disabled');
    }
  }


  //查询一次待发货下的总数量，以及不同货源下的数量显示
  loadWaitSendByTopNumberShow=()=>{
    let that = this;
    var obj={
      Days:$("#selectChooseDateId").val(),
      ShopId:this.state.selectShopId,
      PlatformType:this.state.selectPlatformType
    }
    requests({
      url: "/Common/GetWaitSendByTopNumberShow",
      data: obj,
      success: function (res) {
        that.setState({isShowWaiSendTopCount:true});
        if (res.Success) {
          var waiSendCount = res.Data.WaiSendCount;
          var waiSendAliProductCount = res.Data.WaiSendAliProductCount;
          var waitSendNotAliProductCount = res.Data.WaitSendNotAliProductCount;
          var waitSendNotProductCount = res.Data.WaitSendNotProductCount;

          var sourcePlatformList= that.state.sourcePlatformList;
          for (let index = 0; index < sourcePlatformList.length; index++) {
              if(sourcePlatformList[index].value=="AlibabaZhuKe")
                  sourcePlatformList[index].number =waiSendAliProductCount;
              else if(sourcePlatformList[index].value=="TaoteZhuKe")
                  sourcePlatformList[index].number =waitSendNotAliProductCount;
              else if(sourcePlatformList[index].value=="no_relation")
                  sourcePlatformList[index].number =waitSendNotProductCount;
          }


           var orderStatusList=that.state.orderStatus;
            for (var i = 0; i < orderStatusList.length; i++) {
              if (orderStatusList[i].active == true && orderStatusList[i].title == "待发货") {
                orderStatusList[i].num = waiSendCount;
                break;
              }
            }
          
           that.setState({sourcePlatformList:sourcePlatformList,orderStatusList:orderStatusList});
        } 
      },
      fail: (err) => {
        that.setState({isShowWaiSendTopCount:true});
      }
    });


  }


  //#endregion

  //#region 确认采购单（折叠） 

   //继续解密下单
   confirmOrderByContinue=()=>{
     this.setState({noEncryptErrorDialog:false});
     this.confirmOrder(null,null,1);
   }

   confirmOrderByExistEncryptionProduct=(existEncryptionProductType)=>{
     this.setState({existPurchaseEncryptionProductDialog:false});
     this.confirmOrder(null,null,0,existEncryptionProductType);
   }


  //确认采购订单--按钮
  confirmOrder = (orderCode,itemData,isIgnoreLimit,existEncryptionProductType) => {
    var sellerOrder = null;
    if (itemData != undefined && itemData != null)
      sellerOrder = itemData.SellerOrder;

    var orderList = this.state.orderList;
    var selectOrderList = [];
    if (isNotNull(orderCode) ==false)
      selectOrderList = this.state.selectOrderList;
    else
      selectOrderList.push(orderCode);
    if(isIgnoreLimit == 1)
       this.setState({isIgnoreLimitExpressly:1});
    else
       this.setState({isIgnoreLimitExpressly:0});
    if(existEncryptionProductType==1)
        this.setState({ignorePurchaseEncryptionType:1});
    else if(existEncryptionProductType==2)
        this.setState({ignorePurchaseEncryptionType:2});
    else 
      this.setState({ignorePurchaseEncryptionType:0});


     var isTrue = $("#no_encrypt_error_check").is(':checked');
     if(isTrue&&isIgnoreLimit == 1)
     {
         localStorage.setItem("isIgnoreLimitExpressly_"+this.state.selectShopId,"1");
        //this.setState({isIgnoreLimitExpresslyWindows:1});
     }else{
       var token = localStorage.getItem("isIgnoreLimitExpressly_"+this.state.selectShopId) || null;
       if (token != null && token != undefined&&token=="1") {
         this.setState({isIgnoreLimitExpressly:1});
       }
     }

    if (selectOrderList.length == 0) {
      messageShow("请选择订单!", "warning");
      return;
    }
    if (sellerOrder && sellerOrder.IsPddLocalDepotTag == true) {
      this.setState({pddLocalDepotTagDailog:true});
      return;
    }

    var notCategoryList = [];
    var notCategoryListTitle = "";
    var notCategoryListTitleNumber = 0;
    var mapListByOrderList = [];
    for (let i = 0; i < orderList.length; i++) {
      for (let j = 0; j < selectOrderList.length; j++) {
        if (orderList[i].SellerOrder.OrderCode == selectOrderList[j]) {
          var orderItemList = orderList[i].SellerOrder.OrderItems;
          for (let k = 0; k < orderItemList.length; k++) {
            if (orderItemList[k].IsFenXiao == true && orderItemList[k].IsMapping == false)//临时注释，为了有数据做跳转，这个验证需要有
            //if (orderItemList[k].IsFenXiao == true)//临时注释，为了有数据做跳转，这个验证需要有
            {
              var listJson = {
                ShopId: orderItemList[k].ShopId,
                ProductID: orderItemList[k].ProductID,
                SkuID: orderItemList[k].SkuID,
                SupplierProductId: orderItemList[k].SupplierProductId,
                SupplierProductCode: orderItemList[k].SupplierProductCode,
              }
              notCategoryList.push({ orderCode: orderList[i].SellerOrder.OrderCode, ListJson: listJson });
              if (notCategoryListTitleNumber == 3)
                notCategoryListTitle += "...";
              if (notCategoryListTitleNumber < 3)
                notCategoryListTitle += orderItemList[k].ProductSubject + "；";

              notCategoryListTitleNumber++;
            }else if(orderItemList[k].IsFenXiao == true && orderItemList[k].IsMapping == true)
                mapListByOrderList.push(orderList[i].SellerOrder.OrderCode);

          }
        }
      }
    }

    const notRelateOrders = orderList.filter(s => selectOrderList.includes(s.SellerOrder.OrderCode)).filter(s => !s.BuyerOrders || s.BuyerOrders.length == 0);
    //批量勾选时，不显示这个，因为有可能包含已经映射的
    if (orderCode != null && orderCode != undefined && orderCode != "" && notRelateOrders.length > 0) {
      messageShow("所选订单有商品未关联货源，请先关联货源并匹配规格后再下单!")
      return;
    }

    if (mapListByOrderList.length ==0 && notCategoryList.length > 0) {
      this.setState({ notCategoryList: notCategoryList, notCategoryListTitle: notCategoryListTitle, isShowModalBynotCategory: true });
      return;
    }else if(mapListByOrderList.length > 0 && notCategoryList.length > 0)
    {
      this.setState({ notCategoryList: notCategoryList, notCategoryListTitle: notCategoryListTitle, isShowModalBynotCategoryDouble: true,mapListByOrderList:mapListByOrderList });
      return;
    }


    this.setState({ selectOrderList: selectOrderList }, () => {
      this.createPurchaseOrder();
    });


    var data = {
      OrderCodeList: this.state.selectOrderList,
      ShopId: this.state.selectShopId
    }

  }

  
  //未匹配规格，弹框操作--确认按钮
  notCategoryByShowModalByOk = () => {
    this.setState({});//关闭提示操作的弹框

    var lists = this.state.notCategoryList;
    var listJsons = [];
    for (let i = 0; i < lists.length; i++) {
      var jsons = lists[i].ListJson;

      //去重
      var isE = false;
      for (let j = 0; j < listJsons.length; j++) {
        if (jsons.ProductID == listJsons[j].ProductID)
          isE = true;
      }
      if (isE == false)
        listJsons.push(lists[i].ListJson);
    }
    
    for(const item of lists){
      const listItem = listJsons.find(x => x.ProductID == item.ListJson.ProductID);
      if(listItem){
        listItem.SkuIds = listItem.SkuIds || []
        listItem.SkuIds.push(item.ListJson.SkuID);
      }
    }
    
    var notCategoryListQu = [];

    this.setState({
      isShowModalBynotCategory: false,
      notCategoryListQu: notCategoryListQu
    });

    
    //this.relevanceProductList(listJsons);
    const debounceOtherTemp = debounceOther(()=>{
      this.setState({isLoading:false})
    },800);//防抖函数，用于最后一次更新
    if(listJsons.length > 0){
      this.state.multiProductSkuMappingModuleList = []
      this.setState({isLoading:true})
      listJsons.forEach(async apiData =>{
        const res = await productRequest.LoadProductSkuMappingV2(apiData);
        debounceOtherTemp()
        if(res.Success)
        {
          res.Data.filterSkuIds = apiData.SkuIds
          this.state.multiProductSkuMappingModuleList.push(res.Data)
        }
      })
      setTimeout(()=>{
        this.showProductMapping();
      },500)
    }
  }

  //未匹配规格，提示操作--关闭事件
  cancelNotCategoryByShowModal = () => {
    this.setState({ isShowModalBynotCategory: false, notCategoryList: [], notCategoryListTitle: '' });
  }

  showProductMapping = () => {
    $("#productMappingDailog").css({
      right: 0
    })
    this.setState({multiProductSkuMappingModuleDailog:true})
  }
  closeProductMapping = () => {
    $("#productMappingDailog").css({
      right: "-1000px"
    })
    this.setState({ multiProductSkuMappingModuleList:[],multiProductSkuMappingModuleDailog:false})
  }
  multiProductSkuMappingSaveSure= async (data)=>{
    const apiData = {}
    apiData.TargetShopId = data.TargetShopId;
    apiData.TargetShopPt = data.TargetShopPt;
    apiData.Relations = data.Relations;
    this.setState({isLoading:true})
    const res = await batchDistributionRequest.RelateProductV2(apiData);
    this.setState({isLoading:false})
    this.closeProductMapping();

    if(!res.Success){
      messageShow(res.Message,'error');
      return;
    }
    messageShow("关联成功", 'success');
    this.loadList();
  }




  //批量忽略订单--按钮
  ignoreOrder = (ignoreType, orderCode) => {

    var selectOrderList = [];
    if (orderCode == null || orderCode == undefined || orderCode == "")
      selectOrderList = this.state.selectOrderList;
    else
      selectOrderList.push(orderCode);

    if (selectOrderList.length == 0) {
      messageShow("请选择订单!", "warning");
      return;
    }

    var data = {
      IgnoreOrderCodes: selectOrderList,
      IgnoreType: ignoreType,
      ShopId: this.state.selectShopId
    }

    this.setState({ isLoading: true, loadingTitle: '处理中...', selectOrderList: selectOrderList });
    var that = this;
    requests({
      url: "/PurchaseOrder/BatchIgnoreOrder",
      data: data,
      success: (res) => {
        that.setState({ isLoading: false });
        if (res.Success) {
          if (ignoreType == 1)
            messageShow("忽略采购单成功。", "success");
          else
            messageShow("已取消忽略采购单。", "success");

          that.succeedOrderCodeList();
        } else
          messageShow("错误信息：" + res.Message, "error");
      },
      fail: (err) => { }
    })

  }



  //处理完成后，需要列表移除的调用这个方法
  succeedOrderCodeList = (platformOrderIdOrCode) => {
    var selectList = [];
    if (platformOrderIdOrCode != null && platformOrderIdOrCode != "" && platformOrderIdOrCode != undefined)
      selectList.push(platformOrderIdOrCode);
    else
      selectList = this.state.selectOrderList;

    var orderList = this.state.orderList;
    var newOrderList = [];
    for (let i = 0; i < orderList.length; i++) {
      var isE = false;
      for (let j = 0; j < selectList.length; j++) {
        //订单code或者订单编号
        if (orderList[i].SellerOrder.OrderCode == selectList[j] || orderList[i].SellerOrder.PlatformOrderId == selectList[j])
          isE = true;
      }

      if (!isE)//不存在
        newOrderList.push(orderList[i]);
    }


    this.orderListCheckboxClose();//清楚勾选

    //刷新页面
    if (newOrderList.length == 0)
      this.loadList();
    else {
      var orderStatus = this.state.orderStatus;
      for (let i = 0; i < orderStatus.length; i++) {
        if (orderStatus[i].active == true) {
          var number = orderStatus[i].num;
          orderStatus[i].num = number - (orderList.length - newOrderList.length);
          break;
        }
      }

      this.setState({
        orderList: newOrderList,
        selectOrderList: [],
        selectPurchaseOrderList: [],
        orderStatus: orderStatus
      });//从页面中移除
    }

  }

  //清除勾选
  orderListCheckboxClose = () => {
    $("#orderList_table tr input[type=checkbox]").prop('checked', false);


    $("#allCheck_id_Below").prop("checked", false);//下面的按钮点击
    $("#allCheck_id_Above").prop("checked", false);//上面的按钮点击

    this.setState({ selectOrderList: [] });
  }



 //局部更新单个订单
 UpdateSingleOrder = (productId) => {
  var shopid = this.state.selectShopId;
  let obj = this.loadOrderData(shopid);
  obj.PlatformOrderId = this.state.tempPlatformOrderId;

  var that = this;
  var shopName = this.state.selectShopName;;
  requests({
      url: "/PurchaseOrder/GetSingleOrder",
      data: obj,
      success: (res) => {
          that.setState({ isLoading: false });
          if (res.Success) {
              var orderList = that.state.orderList;
              var productID = productId || that.state.TempSelectProduct.PlatformId;
              var orderStatusIndex=that.state.orderStatusIndex;
              res.Data.ShopName = shopName;
              res.Data.SellerOrder.LastShipTimeValue="";

              if (isNotNull(res.Data.SellerOrder.LastShipTime) && (orderStatusIndex == 0))  {
                var nowTime = new Date().getTime();
                var LastTime = new Date(res.Data.SellerOrder.LastShipTime).getTime();
                var LastShipTime = LastTime - nowTime;

                if (LastShipTime < 43200000)//小于12小时都标红色
                res.Data.SellerOrder.LastShipTimeIsRed = true;

                if (LastShipTime > 0)
                res.Data.SellerOrder.LastShipTimeValue = millisecondToDate(LastShipTime);
                else
                {
                  res.Data.SellerOrder.LastShipTimeValue ="已超时 " + millisecondToDate(-LastShipTime);
                  res.Data.SellerOrder.LastShipTimeIsEnd=true;
                }
              }

              for(let n = 0; n < orderList.length; n++) {
                if(orderList[n].SellerOrder.PlatformOrderId == that.state.tempPlatformOrderId && orderList[n].SellerOrder.OrderItems[0].ProductID == productID){
                  orderList[n] = res.Data;
                }
              }

              that.setState({ orderList: orderList });
          } else {
              messageShow("局部更新订单失败：" + res.Message, 'error');
          }
      }
  });
}


  //确认采购单  --请求接口
  createPurchaseOrder() {
    var data = {
      OrderCodeList: this.state.selectOrderList,
      ShopId: this.state.selectShopId,
      IsNewVersion:true,
      IsIgnoreLimitExpressly:this.state.isIgnoreLimitExpressly,
      IgnorePurchaseEncryptionType:this.state.ignorePurchaseEncryptionType
    }

    this.setState({ isLoading: true, loadingTitle: '处理中...' });
    var that = this;

    requests({
      url: "/PurchaseOrder/CreateOrder",
      data: data,
      success: (res) => {
        if (res.Success) {
          var taskCode = res.Data;
          var createOrderTaskCode = { TaskCode: taskCode, Ratio: 0 };
          that.setState({ createOrderTaskCode: createOrderTaskCode });

          setTimeout(() => {
            that.createOrderTask();
          }, 1000);
        }
        else {
          messageShow("错误信息：" + res.Message, "error");
          that.setState({ isLoading: false });
        }
      },
      fail: (err) => {
        messageShow("请求异常（确认采购单）", "error");
        that.setState({ isLoading: false });
      }
    })

  }


  createOrderTask = () => {

    var createOrderTaskCode = this.state.createOrderTaskCode;
    var taskCode = createOrderTaskCode.TaskCode;

    var that = this;
    requests({
      url: "/Common/GetZhuKeReqTask",
      data: { TaskCode: taskCode },
      success: (res) => {
        if (res.Success) {
          var dates = res.Data;
          if (dates.FinishedTime != null && dates.FinishedTime != "" && dates.FinishedTime != undefined) {
            that.setState({ isLoading: false, createOrderTaskCode: { TaskCode: '', Ratio: 0 } });
            var selectShopPlatformType = this.state.selectPlatformType;
            if (dates.Status == "Error" && isNotNull(dates.ErrorMsg)) 
            {
              if ( selectShopPlatformType == 'XiaoHongShu'&& dates.RspContent== "NoEncryptError") {
                //that.setState({ noEncryptErrorDialog: true, encryErrorMessage: dates.ErrorMsg });
                that.loadList();
              }
              else if (selectShopPlatformType == 'TouTiao'&& dates.RspContent== "NoEncryptError") {
                var token = localStorage.getItem("isIgnoreLimitExpressly_"+that.state.selectShopId) || null;
                if (token == null && token == undefined) {
                   that.setState({ noEncryptErrorDialog: true, encryErrorMessage: dates.ErrorMsg });
                }else{
                   that.loadList();
                }
                //
              }
              else if (selectShopPlatformType == 'TouTiao'
                && (dates.ErrorMsg.includes('请停止非必要的解密，12小时内自动回复') || dates.ErrorMsg.includes('额度') || dates.ErrorMsg.includes('环境安全风险'))) {
                that.setState({ encryFialdDialog: true, encryErrorMessage: dates.ErrorMsg });
              }
              else if (selectShopPlatformType == 'KuaiShou' && (dates.ErrorMsg.includes('额度') || dates.ErrorMsg.includes('解密'))) {
                //that.setState({ encryFialdDialog: true, encryErrorMessage: dates.ErrorMsg });
                that.loadList();
              }
              else if(selectShopPlatformType == 'TouTiao' && (dates.ErrorMsg.includes('中转订单') && dates.ErrorMsg.includes('密文')))
              {  
                  that.setState({ encryFialdDialogByZhongZhuan: true, encryErrorMessage: dates.ErrorMsg });  
              }
              else if(selectShopPlatformType == 'KuaiShou' && (dates.ErrorMsg.includes('中转订单') && dates.ErrorMsg.includes('密文')))
              {
                  that.setState({ encryFialdDialogByZhongZhuan: true, encryErrorMessage: dates.ErrorMsg });
              }
              else if(dates.RspContent== "ExistPurchaseEncryptionProductError")
              {
                 that.setState({ existPurchaseEncryptionProductDialog:true });
              }
              else if(dates.RspContent== "NoEncryptError"||dates.RspContent=="AllExistPurchaseEncryptionProductError")
              {
                 that.loadList();
              }
              else {
                that.setState({ isShowCommonError: true, showCommonErrorMessage: dates.ErrorMsg });//统一用弹窗
              }
            }
            else if (dates.Status == "Error" && dates.RspContent == null) {
              messageShow("确认采购单任务已处理，失败原因:RspConten is null", "error");

            } else {
              var rspContentJson = JSON.parse(dates.RspContent);
              var list = rspContentJson.DataList;
              var isOpen = rspContentJson.IsOpen;
              if (list == null || list == undefined)
                list = [];

              var errorList = [];//全部成功
              var successList = [];
              for (let i = 0; i < list.length; i++) {
                var resJson = list[i];
                if (resJson.IsSuccess == false)
                  errorList.push(resJson);
                else
                  successList.push(resJson);
              }

              //优先显示错误列表，其次再显示  自动代扣的检测
              if (errorList.length > 0) {
                that.loadList();
                // messageShow(
                //   <div>
                //     成功<span className='defColor'>{successList.length}</span>笔，
                //     失败<span className='dangerColor'>{errorList.length}</span>笔。
                //     失败的可在订单列表查看原因，然后单独确认采购单
                //   </div>
                // )
                that.setState({ createOrderResultDailog: true, createOrderResult: { successList,errorList } });
                // that.setState({ isShowModalByCreateOrderError: true, createOrderError: errorList });
                return;
              }

              //成功后，从列表中移除,不管有没有开通
              //that.succeedOrderCodeList();

              that.loadList();//刷新页面,确认采购单，不用that.succeedOrderCodeList()，因为确认采购单后，订单还在当前页面，只是刷新页面即可

              messageShow("采购单创建成功。", "success");

              //没有错误的列表(errorList) ，没有开通自动代扣(isOpen),没有点击【不再提醒】
              // if (errorList.length == 0 && isOpen == false && that.state.isRemindOpen < 8)
              //   that.setState({ isShowModalByNotOpen: true, isRemindOpen: that.state.isRemindOpen + 1 });

            }
          } else {
            //任务未执行完，继续轮训
            setTimeout(() => {
              that.createOrderTask();
            }, 1000);
          }
        } else {
          that.setState({ isShowCommonError: true, showCommonErrorMessage: res.Message });

          that.setState({ isLoading: false, createOrderTaskCode: { TaskCode: '', Ratio: 0 } });
        }
      },
      fail: (err) => {
        messageShow("请求异常（确认采购单）", "error");
        that.setState({ isLoading: false });
      }
    })

  }

  //确认采购单，错误提示弹框  确认关闭按钮
  createOrderErrorShowModalByConfirm = () => {
    this.setState({ isShowModalByCreateOrderError: false, createOrderError: [] });
  }

  //#endregion

  //#region 订单详情页面（官方） （折叠）
  //订单详情页面（官方）
  async orderDetailLink(buyerOrder, isInspect, buyerPlatformOrderId, buyerPlatformOrderCode, sellerOrderId){
    let orderId = buyerOrder.PlatformOrderId;
    if(buyerOrder && buyerOrder.PlatformType == "TaoteZhuKe")
    {
      if (isInspect == true) {
        var that = this;
        setTimeout(() => {
          that.setState({
            isShowModalByCancelExamine: true,
            buyerPlatformOrder: buyerOrder,
            buyerPlatformOrderId: buyerPlatformOrderId,
            buyerPlatformOrderCode: buyerPlatformOrderCode,
            detailsPlatformOrderId: sellerOrderId
          });
        }, 1000);
      }
      var taoteurl = 'https://trade.taobao.com/trade/detail/trade_order_detail.htm?biz_order_id='+orderId;
      window.open(taoteurl);
      return;
    }else if(buyerOrder && buyerOrder.IsPifatuan == true && isInspect == true){
      this.cancelPurchaseOrder(buyerPlatformOrderCode);
      return;
    }

    if (isInspect == true) {
      var that = this;
      setTimeout(() => {
        that.setState({
          isShowModalByCancelExamine: true,
          buyerPlatformOrderId: buyerPlatformOrderId,
          buyerPlatformOrder: buyerOrder,
          buyerPlatformOrderCode: buyerPlatformOrderCode,
          detailsPlatformOrderId: sellerOrderId
        });
      }, 1000);
    }
    var url = "https://trade.1688.com/order/new_step_order_detail.htm?orderId=" + orderId;

    window.open(url);
  }

  //已取消  --点击确认
  cancelExamineShowModalByConfirm = () => {
    this.setState({ isShowModalByCancelExamine: false, isLoading: true });
    //this.loadList();
    this.syncOneOrder("buyer", "cancelButton");
  }

   //#endregion

   //#region 取消采购单 （折叠）
  async cancelPurchaseOrder(orderCode)
  {
    this.setState({isLoading:true});
    const data = { OrderCodes:[orderCode] }
    const res = await CancelPurchaseOrderRequest(data);
    if(!res.Success){
      messageShow('服务异常：'+res.Message,'error');
      return;
    }
    const taskCode = res.Data;
    setTimeout(()=>{ this.zhukeReqTaskPoll(taskCode); },1000)
  }
  async zhukeReqTaskPoll(taskCode){
    var res = await getZhuKeReqTask({TaskCode :taskCode});
    if (res.Success) {
      var dates = res.Data;
      if (dates.FinishedTime != null && dates.FinishedTime != "" && dates.FinishedTime != undefined) {
        this.setState({ isLoading: false, createOrderTaskCode: { TaskCode: '', Ratio: 0 } });
        if (dates.Status == "Error" && dates.ErrorMsg != null && dates.ErrorMsg != undefined && dates.ErrorMsg != "")
        {
          messageShow(dates.ErrorMsg,"error");
        }
        else if (dates.Status == "Error" && dates.RspContent == null) 
        {
          messageShow("取消订单失败:RspConten is null","error");
        } else {
          if(dates.RspContent){
            const rspContent = JSON.parse(dates.RspContent);
            var failResult =rspContent.filter(s => s.Success == false);
            var successResult =rspContent.filter(s => s.Success == true);
            if(failResult.length > 0)
            {
              MessageBox.alert(<div>
                <p>有订单取消失败：</p>
                {
                  failResult.map(s => {
                    return <p>订单：{s.PurchaseOrderId}，原因：{s.ErrorMessage}</p>
                  })
                }
              </div>)
            }else{
              messageShow("取消订单成功","success");
            }
            this.loadList()
          }else{
            messageShow("取消订单成功","success");
          }
          
        }
      } else {
        //任务未执行完，继续轮训
        setTimeout(() => {
          this.zhukeReqTaskPoll(taskCode);
        }, 1000);
      }
    } else {
      this.setState({isShowCommonError:true,showCommonErrorMessage:res.Message});
      this.setState({ isLoading: false, createOrderTaskCode: { TaskCode: '', Ratio: 0 } });
    }
  }
 //已取消  --关闭
 cancelExamineShowModalByClose = () => {
    this.setState({ isShowModalByCancelExamine: false });
  }


  //切换规格  --关闭
 changeSKUShowModalByClose = () => {
  this.setState({ isShowModalChangeSku: false });
}

  //切换规格  --点击确认
  changeSKUShowModalByConfirm = () => {
    this.setState({ isShowModalChangeSku: false });
    //this.loadList();
    this.orderPayment(this.state.changeSkuOrderCode);
  }

  //#endregion
  
  //#region 平台订单--商品列表页面 （折叠）
  //平台订单商品列表页面
  renderSellerOrderTr = (item, itemSellerSkuList, index, sellerOrderLength) => {
    return (
      <tr style={{ padding: "1px 5px" }} className={index > 1 ? "hideTr tr" + index : "tr" + index}>
        <td style={{ width: "360px" }}>
          <div class="productShow">
            <div class="productShow-imgWrap">
              <img src={itemSellerSkuList.ProductImgUrl}
                alt="" />

              {itemSellerSkuList.IsFenXiao == false ?
                <span class="product-status">未分销</span>
                : null
              }
              {itemSellerSkuList.IsFenXiao == true && itemSellerSkuList.RefundStatus != "" && itemSellerSkuList.RefundStatus != null && itemSellerSkuList.RefundStatus != "REFUND_SUCCESS" && itemSellerSkuList.RefundStatus != "REFUND_CLOSE" ?
                <span class="product-status warnBackColor">退款中</span>
                : null
              }
              {itemSellerSkuList.IsFenXiao == true && itemSellerSkuList.RefundStatus != "" && itemSellerSkuList.RefundStatus != null && itemSellerSkuList.RefundStatus == "REFUND_SUCCESS" ?
                <span class="product-status warnBackColor">退款完成</span>
                : null
              }
              {itemSellerSkuList.IsFenXiao == true && (itemSellerSkuList.RefundStatus == "" || itemSellerSkuList.RefundStatus == null || itemSellerSkuList.RefundStatus == 'REFUND_CLOSE')
                && itemSellerSkuList.Status == "waitbuyerreceive" ?
                <span class="product-status">已发货</span>
                : null
              }

            </div>
            <ul>
              <li title="商品标题">{itemSellerSkuList.ProductSubject}</li>
              <li>
                <span>商家规格:</span>
                <span class="spgg mainColor">{itemSellerSkuList.Color}{itemSellerSkuList.Size}</span>
              </li>
              {
                itemSellerSkuList.IsFenXiao == true && itemSellerSkuList.IsMapping == false ?
                  <li>
                    <span class="order-seller-skuStats-orange">规格未匹配</span>
                    <span class="defColor hover" onClick={() => { this.showSkuMapping(itemSellerSkuList) }}> 去匹配</span>
                  </li>
                  : null
              }
              {
                itemSellerSkuList.IsFenXiao == true && itemSellerSkuList.IsSendFaild == true ?
                  <li>
                    <span class="order-seller-skuStats-red" >自动发货失败，请手动重新发货</span>
                    <span onClick={() => this.onlineSendErrorMsg(item.SellerOrder.PlatformOrderId, itemSellerSkuList.OrderItemCode)} className="dangerColor hover">查看原因</span>
                  </li>
                  : null
              }
              {
                itemSellerSkuList.IsFenXiao == true && this.state.orderStatusIndex == 0 && itemSellerSkuList.IsMapping == true ?
                  <li style={{ display:'flex',gap:'8px'}}>
               
                    <span class="defColor hover" onClick={() => this.showSkuMapping(itemSellerSkuList, true)}>更换货源规格</span>
                    {/* <span class="defColor hover" onClick={() => this.relevanceProduct(itemSellerSkuList, 1,item)}>替换货源</span> */}
                    
                  </li>
                  : null
              }
            </ul>
            <div class="productNum mainColor">
              <span>￥{itemSellerSkuList.ItemAmount}</span>
              <span>x{itemSellerSkuList.Count}</span>
            </div>
          </div>
        </td>
        {
          index == 0 ?
            <td rowspan={sellerOrderLength > 1 ? 2 : sellerOrderLength} style={{ textAlign: "center" }} className="hebin">
              <div style={{ marginBottom: "8px" }}>
                <span class="mainColor">{item.SellerOrder.ProductCount}种商品共计{item.SellerOrder.ProductItemCount}件</span>
              </div>
              <div style={{ marginBottom: "8px" }}>
                <span>金额:(含运费:￥{item.SellerOrder.ShippingFee}) ￥{item.SellerOrder.TotalAmount}</span>
              </div>
              {
                this.state.orderStatusIndex == 0 ?
                  <div>
                    {
                      <span class="defColor hover" onClick={() => this.ignoreOrder(1, item.SellerOrder.OrderCode)}>忽略订单 </span>
                    }
                    {
                      this.state.purchaseOrderStatusIndex == 1?
                      <span class="defColor hover" onClick={() => this.confirmOrder(item.SellerOrder.OrderCode,item)}>确认采购单</span>:null
                    }
                  </div> : null
              }
              {
                this.state.orderStatusIndex == 5 ?
                  <div>
                    {
                      <span class="defColor hover" onClick={() => this.ignoreOrder(0, item.SellerOrder.OrderCode)}>取消忽略</span>
                    }
                  </div> : null
              }
            </td> : null
        }
      </tr>
    )
  }
  //#endregion

   //#region 采购单，订单信息页面 （折叠）
  // 采购订单信息页面
  renderBuyerOrderTr = (itemBuyList, itemBuySkuList, index, itemBuySkuListLength, item) => {
    return (
      <tr style={{ padding: "1px 5px" }} className={index > 1 ? "hideTr tr" + index : "tr" + index}>
        <td style={{ width: "360px" }}>
          <div class="productShow">
            <div class="productShow-imgWrap">
              <img src={itemBuySkuList.ProductImgUrl}
                alt="" />
              {
                itemBuySkuList.RefundStatus != "" && itemBuySkuList.RefundStatus != null && itemBuySkuList.RefundStatus != "REFUND_SUCCESS" ?
                  <span className="product-status" style={{ backgroundColor: "#fe6f4f" }}>退款中</span> : null
              }
              {
                itemBuySkuList.RefundStatus != "" && itemBuySkuList.RefundStatus != null && itemBuySkuList.RefundStatus == "REFUND_SUCCESS" ?
                  <span className="product-status" style={{ backgroundColor: "#fe6f4f" }}>退款完成</span> : null
              }
              {
                (itemBuySkuList.RefundStatus == "" || itemBuySkuList.RefundStatus == null) && itemBuySkuList.Status == "waitbuyerreceive" ?
                  <span className="product-status" style={{ backgroundColor: "#3aadff" }}>已发货</span> : null
              }
            </div>
            <ul>
              <li title="商品标题" className={
                fromClassName({
                  hover:true,
                  defColor:itemBuySkuList.IsMapping || itemBuyList.BuyerOrder.PlatformOrderId
                })
              } onClick={()=>{ this.tohuoyuanLink(itemBuySkuList,itemBuyList)}}>
                {itemBuySkuList.ProductSubject}
                {
                  itemBuyList.BuyerOrder.PlatformType == "TaoteZhuKe" ?
                    <Tag type='warning'>淘特</Tag>:null
                }
                {
                  itemBuyList.BuyerOrder.PlatformType == "AlibabaZhuKe" ?
                  <Tag type='warning'>1688</Tag>:null
                }
              </li>
              {
                  itemBuyList.BuyerOrder.PlatformType == "TaoteZhuKe" && !itemBuyList.BuyerOrder.PlatformOrderId?
                    <li><span className='dangerColor'>! 已不支持淘特货源分销，请更换1688货源</span></li>:
              <li>
                <span>商家规格:</span>
                <span class="spgg mainColor">{itemBuySkuList.Color} {itemBuySkuList.Size}</span>
                {
                  !itemBuySkuList.SubItemID && itemBuySkuList.SkuID?
                  <span style={{marginLeft:'4px'}}><i className='iconfont icon-piliangbianji hover defColor' onClick={()=>{ this.showEditSkuMapping(itemBuySkuList,item.SellerOrder)}}></i></span>
                  :null
                }
                {
                  itemBuySkuList.IsProductRelation ?
                  <span className='tarTxt tarTxt07'>临时</span>:null
                }
              </li>
              
              }
              { 
                itemBuySkuList.PickupAssr ? 
                  <li>
                    <span style={{backgroundColor: '#ec808d',alignItems: 'center',fontSize: '12px',height: '21px', borderRadius: '4px'}} className='productShow-content-sku-tag'>{itemBuySkuList.PickupAssr}h晚揽必赔</span>
                  </li>
                  :null
              }

            </ul>
            <div class="productNum mainColor">
              <span>￥{itemBuySkuList.ItemAmount}</span>
              <span>x{itemBuySkuList.Count}</span>
              {/* <span className='hover defColor' onClick={()=>{ this.showChangeProductV2(itemBuySkuList,item.SellerOrder) }}>更换货源</span> */}
            </div>
          </div>
        </td>

        {index == 0 ?
          <td rowspan={itemBuySkuListLength > 1 ? 2 : itemBuySkuListLength} style={{ textAlign: "center" }} className="hebin">
            {
              itemBuyList.BuyerOrder != null ?
                <div style={{ marginBottom: "8px", display: "flex", flexDirection: "column" }}>
                  <span class="mainColor" style={{ marginBottom: "8px" }}>{itemBuyList.BuyerOrder.ProductCount}种商品共计{itemBuyList.BuyerOrder.ProductItemCount}件</span>
                  {itemBuyList.BuyerOrder.TotalAmount != null ? <span>金额:(含运费:￥{itemBuyList.BuyerOrder.ShippingFee}) ￥{itemBuyList.BuyerOrder.TotalAmount}</span> : null}
                </div>
                : null
            }
            <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>

              {
                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != null && itemBuyList.BuyerOrder.PlatformStatus != "" ?
                  <div style={{ marginRight: "5px" }} onClick={() => this.orderDetailLink(itemBuyList.BuyerOrder)}>
                    <span className="defColor hover">订单详情</span>
                  </div> : null
              }

              {
                itemBuyList.BuyerOrder != null && itemBuyList.IsSendFaild == true ?
                  <div style={{ marginRight: "5px" }} onClick={() => this.reOnlineSend(item.SellerOrder.OrderCode, item.SellerOrder.PlatformOrderId, itemBuyList.BuyerOrder.OrderCode, itemBuyList.BuyerOrder.PlatformOrderId,itemBuyList.BuyerOrder)}>
                    <span className="dangerColor hover">重新发货</span>
                  </div> : null
              }
              {
                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != null && itemBuyList.BuyerOrder.PlatformStatus == "waitbuyerpay" ?
                  <div style={{ marginRight: "5px" }} onClick={() => this.orderDetailLink(itemBuyList.BuyerOrder, true, itemBuyList.BuyerOrder.PlatformOrderId, itemBuyList.BuyerOrder.OrderCode, item.SellerOrder.PlatformOrderId)}>
                    <span className="dangerColor hover" data-logger-action-type="dgj_action_order_cancel">取消订单</span>
                  </div> : null
              }

              {
                itemBuyList.BuyerOrder.PlatformType != "TaoteZhuKe" && itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != null && itemBuyList.BuyerOrder.PlatformStatus == "waitbuyerpay" ?
                  <div >
                    <span className="defColor hover" onClick={() => this.checkOrderPay(item.SellerOrder.OrderCode,item.SellerOrder.PlatformOrderId)}>向供应商付款</span>
                  </div> : null
              }
              {
                itemBuyList.BuyerOrder.PlatformType == "TaoteZhuKe" && itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != null && itemBuyList.BuyerOrder.PlatformStatus == "waitbuyerpay" ?
                  <div >
                    <span className="defColor hover" onClick={() => this.orderDetailLink(itemBuyList.BuyerOrder)}>向供应商付款</span>
                  </div> : null
              }
            </div>
          </td> : null
        }
      </tr>

    )
  }

  renderOrderErrorMessageDialog=(errorMessage)=>
  {  
      return   <div>
      <div className='popoverCommon' style={{'display':'inline-block',marginLeft:'10px'}}>
          <span className='dangerColor hover' style={{'whiteSpace':'nowrap','overflow':'hidden','textOverflow':'ellipsis','width':'200px','display':'inline-block'}}>下单失败：{errorMessage}</span>
          <div className='popoverCommon-warn' style={{width:'max-content',maxWidth:'560px',lineHeight:'25px',color:'#333'}}>
              {errorMessage}
          </div>
      </div>
      <a className='defColor hover' target='_blank' href='https://tzdcbolvez.feishu.cn/wiki/QctVwFnsYiIIAVkyCm3csQ6On4c?from=from_copylink'>查看帮助&gt;&gt;</a>
    </div>;
  }
  //#endregion

  //#region 展开按钮 （折叠）
  moreShowProduct(e, len) {
    let eleName = e.target.nodeName.toUpperCase();
    let ele = null;
    if (eleName == "SPAN") {
      ele = $(e.target);
    } else {
      ele = $(e.target).closest("span");
    }
    if (ele.hasClass("moreTrShow")) {
      ele.removeClass("moreTrShow").closest("tr").prevAll(".hideTr").css({ display: "none" });
      ele.find("s").text("展开更多");
      ele.closest("tr").prevAll(".tr0").find(".hebin").attr("rowspan", 2);
    } else {
      ele.addClass("moreTrShow").closest("tr").prevAll(".hideTr").css({ display: "table-row" });
      ele.find("s").text("收起商品");
      ele.closest("tr").prevAll(".tr0").find(".hebin").attr("rowspan", len);

    }
  }

  //#endregion



  

  //#region 单个订单同步一次 （折叠）
  //同步订单后，再查一次。商品详情页面
  syncOneOrder = (orderType, operation) => {
    var buyerPlatformOrderId = this.state.buyerPlatformOrderId;//平台订id
    var buyerPlatformOrder = this.state.buyerPlatformOrder;//平台订id
    var buyerPlatformOrderCode = this.state.buyerPlatformOrderCode;//平台订单code
    var detailsPlatformOrderId = this.state.detailsPlatformOrderId;//采购单
    var data = { PlatformOrderIds: '', ShopId: '', PurchaseOrderCode: '', PurchaseOrderId: '' };
    var url = "";
    if (orderType == "buyer") {
      data.ShopId = buyerPlatformOrder.ShopId;
      data.PurchaseOrderId = buyerPlatformOrderId;
      data.PurchaseOrderCode = buyerPlatformOrderCode;
      url = "/PurchaseOrder/CancelPurchaseOrderConfirm"
    } else {
      data.PlatformOrderIds = detailsPlatformOrderId;
      data.ShopId = this.state.selectShopId;
      url = "/Order/SyncSingleOrder";
    }
    this.setState({ isLoading: true, loadingTitle: '检测订单...' });
    var that = this;
    requests({
      url: url,
      data: data,
      success: function (res) {

        //关闭动画
        that.setState({ isLoading: false });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          return;

        if (res.Success) {
          var list = res.Data;
          if (list != null && list.length > 0) {
            var order = list[0];
            //说明取消成功，重新查询，（取消成功后会变成待确认）
            if (operation == "cancelButton") {
              if (order.PlatformStatus == "cancel") {
                messageShow("取消成功，准备刷新页面", "success");
                setTimeout(() => {
                  that.orderStatusChangeNav(0);
                }, 1000);
              } else
                messageShow("订单没有取消成功！", "info");
            }

            //重新发货的操作
            if (operation == "reOnlineSendButton") {
              //发货成功后，触发查询按钮即可，不触发切换的导航栏
              if (order.PlatformStatus == "waitbuyerreceive") {
                that.queryButton(true);
              }
            }

          }

        } else
          messageShow("错误信息：" + res.Message,'error');
      },
    });
  }

  orderStatusChangeNav(id) {
    var orderStatus = this.state.orderStatus;
    var item = null;
    for (var i = 0; i < orderStatus.length; i++) {
      if (orderStatus[i].id == id) {
        orderStatus[i].active = true;
        item = orderStatus[i];
      } else {
        orderStatus[i].active = false;
      }
    }
    this.substateCheckboxEmpty();//清空子状态勾选

    this.setState({
      orderStatus: orderStatus,
      orderStatusIndex: id,
      refundType: "",
      orderSubstate: ""
    }, () => {
      this.changeNav(item);//触发切换导航事件
    })

    
  }


  async syncSingleOrder(item){
    if(!item || !item.PlatformOrderId) return;
    const data={ PlatformOrderIds: item.PlatformOrderId, ShopId:item.ShopId }
    await SyncOrderByIdsRequest(data);
  }

  //#endregion

 //#region 单选，多选按钮 （折叠）
  //单选事件
  orderChange = (e, sellerOrderCode) => {
    var isChecked = $("#" + sellerOrderCode + "_Id").prop("checked");

    var list = this.state.orderList;
    var selectOrderList = this.state.selectOrderList;

    //当前选中订单
    const selectOrder = list.find(o => o.SellerOrder.OrderCode == sellerOrderCode);
    if (selectOrder && selectOrder.SellerOrder.IsRisk == true) {
      messageShow("选择的订单中包含平台风控订单，默认不选中；（平台标记去除前不支持处理此类订单）！", "warning");

      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
      return;
    }
    if(selectOrder && selectOrder.SellerOrder.IsOrderLogisticsTransitTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))
    {
      messageShow("选择的订单中包含了中转订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
      return;
    }
    if (selectOrder && selectOrder.SellerOrder.IsOrderKsLogisticsTransitTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))
    {
      messageShow("选择的订单中包含了中转订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
      return;
    }
    if (selectOrder && selectOrder.SellerOrder.IsOrderKsShunfengTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))
      {
        messageShow("选择的订单中包含了顺丰包邮，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
        setTimeout(() => {
          $("#" + sellerOrderCode + "_Id").prop("checked", false);
        }, 500);
        return;
      }
    if (selectOrder && selectOrder.SellerOrder.IsPddHomeDeliveryDoorTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1)) 
    {
      messageShow("选择的订单中包含了送货上门订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
      return;
    }
    if (selectOrder && selectOrder.SellerOrder.IsTouTiaoChooseDeliveryTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1)) 
    {
        messageShow("选择的订单中包含自选快递服务订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
        setTimeout(() => {
          $("#" + sellerOrderCode + "_Id").prop("checked", false);
        }, 500);
        return;
    }
    if (selectOrder && selectOrder.SellerOrder.IsTouTiaoRiskTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1)) 
    {
          messageShow("选择的订单中包含风控订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
          setTimeout(() => {
            $("#" + sellerOrderCode + "_Id").prop("checked", false);
          }, 500);
          return;
    }
    if (selectOrder && selectOrder.SellerOrder.IsKuaiShouRiskTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1)) 
      {
            messageShow("选择的订单中包含风控订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
            setTimeout(() => {
              $("#" + sellerOrderCode + "_Id").prop("checked", false);
            }, 500);
            return;
      }
    if (selectOrder && selectOrder.SellerOrder.IsPddLocalDepotTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1)) 
      {
          messageShow("选择的订单中包含拼多多本地仓订单，默认不选中，此类订单不支持采购下单！", "warning");
          setTimeout(() => {
            $("#" + sellerOrderCode + "_Id").prop("checked", false);
          }, 500);
          return;
      }
      if (selectOrder && selectOrder.SellerOrder.IsWxVideoChangeSkuTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1|| this.state.purchaseOrderStatusIndex ==2)) 
        {
            if(this.state.purchaseOrderStatusIndex==2)
            {
              messageShow("选择的订单中包含微信换款订单，默认不选中，请确认后点击【向供应商付款】单独进行支付！", "warning");
            }
            else{
             messageShow("选择的订单中包含微信换款订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
            }
            setTimeout(() => {
              $("#" + sellerOrderCode + "_Id").prop("checked", false);
            }, 500);
            return;
        }
    if (selectOrder && selectOrder.SellerOrder.IsXiaoHongShuHomeDeliveryTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1)) 
    {
      messageShow("选择的订单中包含了送货上门订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
      return;
    }
    if (selectOrder && selectOrder.SellerOrder.IsXiaoHongShuHomeDeliveryTag == true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1)) 
    {
        messageShow("选择的订单中包含自选快递服务订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
        setTimeout(() => {
          $("#" + sellerOrderCode + "_Id").prop("checked", false);
        }, 500);
        return;
    }

    var isRefund = false;
    for (let i = 0; i < list.length; i++) {
      if (list[i].SellerOrder.OrderCode == sellerOrderCode) {
        if (list[i].SellerOrder.RefundStatus != null && list[i].SellerOrder.RefundStatus != "" && list[i].SellerOrder.RefundStatus != "REFUND_CLOSE")
          isRefund = true;

        break;
      }
    }


    let isHas = false; //是否已经存在了
    for (let j = 0; j < selectOrderList.length; j++) {
      if (selectOrderList[j] == sellerOrderCode) {
        selectOrderList.splice(j, 1);
        isHas = true;  //点之前已经存在了
      }
    }


    //待发货状态下 正常未发货的商品不选中
    let normal = false;
    if (this.state.orderStatusIndex == 2) {
      let order = list.find(o => o.SellerOrder.OrderCode == sellerOrderCode);
      if (order) {
        //没有发货失败且没有退款
        if (order.SellerOrder.OrderItems.find(item => item.IsSendFaild == false) && isRefund == false) {
          normal = true;
        }
      }
      if (!isHas && isRefund == false && normal == false) {
        selectOrderList.push(sellerOrderCode);
      }
    } else if (!isHas && isRefund == false) {//codeId 之前没有存在的，添加进去  //&& isRefund==false 临时
      selectOrderList.push(sellerOrderCode);
    }

    if (isChecked && isRefund) {
      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
    } else if (this.state.orderStatusIndex == 2 && normal == true && isChecked) {
      setTimeout(() => {
        $("#" + sellerOrderCode + "_Id").prop("checked", false);
      }, 500);
    }

    //去掉单选时，全选默认去掉
    if (!isChecked) {
      $("#allCheck_id_Below").prop("checked", false);//上面的按钮点击，下面的全选跟着变化
      $("#allCheck_id_Above").prop("checked", false);//下面的按钮点击，上面的全选跟着变化
    } else {
      if (selectOrderList.length == list.length) {
        $("#allCheck_id_Below").prop("checked", true);//上面的按钮点击，下面的全选跟着变化
        $("#allCheck_id_Above").prop("checked", true);//下面的按钮点击，上面的全选跟着变化
      }

    }

    var buyerCodeList = this.getListPurchaseOrderCode(selectOrderList, false);
    if (isRefund && isChecked)
      messageShow('选中的商品包含了退款,批量操作会过滤，请到订单【右边的按钮】!', "warning");
    else if (normal && this.state.orderStatusIndex == 2 && isChecked)
      messageShow('当前订单对应的采购单还未发货，不支持手动发货!', "warning");
    else {
      if (buyerCodeList.length > 50)
        messageShow('已选择超过50条，手动支付会限制。', "warning");
    }


    this.setState({ selectOrderList: selectOrderList, orderList: list, selectPurchaseOrderList: buyerCodeList });


  }


  //全部，选择商品事件
  allCheckbox(types) {
    var isCheck = false;

    if (types == "above")
      isCheck = $("#allCheck_id_Above").prop("checked");//上面的按钮
    else
      isCheck = $("#allCheck_id_Below").prop("checked");//下面的按钮


    var selectOrderList = this.state.selectOrderList;
    var list = this.state.orderList;
    var isRefundNumber = 0;
    var isRiskOrderCount = 0;
    var isOrderLogisticsTransitCount = 0;
    var isOrderShunfengCount = 0;
    var isPddHomeDeliveryDoorTagCount=0;
    var isTouTiaoChooseDeliveryTagCount=0;
    var isTouTiaoRiskTagCount=0;
    var isKuaiShouRiskTagCount=0;
    var isPddLocalDepotTagCount=0;
    var isWxVideoChangeSkuTagCount=0;
    var isXiaoHongShuHomeDeliveryTagCount=0;
    if (!isCheck)  //取消全选  选中的selectOrderList 置空
    {
      selectOrderList = [];
      for (let i = 0; i < list.length; i++) {
        $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
      }
    } else {
      for (let i = 0; i < list.length; i++) {
        //退款的不选中
        if (list[i].SellerOrder.RefundStatus != "" && list[i].SellerOrder.RefundStatus != null && list[i].SellerOrder.RefundStatus != "REFUND_CLOSE")
          isRefundNumber++;
        else if (list[i].SellerOrder.IsRisk == true) {
          isRiskOrderCount++;
        }
        else  if(list[i].SellerOrder.IsOrderLogisticsTransitTag==true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))//中转地址
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isOrderLogisticsTransitCount++;
        }
        else  if(list[i].SellerOrder.IsOrderKsLogisticsTransitTag==true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))//中转地址
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isOrderLogisticsTransitCount++;
        }
        else  if(list[i].SellerOrder.IsOrderKsShunfengTag==true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))//中转地址
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isOrderShunfengCount++;
        }
        else  if(list[i].SellerOrder.IsPddHomeDeliveryDoorTag==true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))//送货上门
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isPddHomeDeliveryDoorTagCount++;
        }
        else  if(list[i].SellerOrder.IsXiaoHongShuHomeDeliveryTag==true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))//送货上门
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isXiaoHongShuHomeDeliveryTagCount++;
        }
        else  if(list[i].SellerOrder.IsTouTiaoRiskTag==true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))//送货上门
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isTouTiaoRiskTagCount++;
        }
        else  if(list[i].SellerOrder.IsKuaiShouRiskTag==true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))//送货上门
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isKuaiShouRiskTagCount++;
        }
        else  if(list[i].SellerOrder.IsTouTiaoChooseDeliveryTag==true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))//送货上门
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isTouTiaoChooseDeliveryTagCount++;
        }
        else  if(list[i].SellerOrder.IsPddLocalDepotTag==true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))//送货上门
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isPddLocalDepotTagCount++;
        }
        else  if(list[i].SellerOrder.IsWxVideoChangeSkuTag==true && this.state.orderStatusIndex==0 && (this.state.purchaseOrderStatusIndex ==0 || this.state.purchaseOrderStatusIndex ==1))//换款
        {
          $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
          isWxVideoChangeSkuTagCount++;
        }
        else {
          if (this.state.orderStatusIndex == 2 && list[i].SellerOrder.OrderItems.filter(item => item.IsSendFaild).length == 0)//待发货下只选择发货失败的
          {
            var len = list[i].SellerOrder.OrderItems.filter(item => item.IsSendFaild).length;
            if (len > 0) {
              selectOrderList.push(list[i].SellerOrder.OrderCode);
            } else {
              $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", false);
            }
          } else {
            selectOrderList.push(list[i].SellerOrder.OrderCode);
            $("#" + list[i].SellerOrder.OrderCode + "_Id").prop("checked", isCheck);
          }
        }
      }
      selectOrderList = [...new Set(selectOrderList)];//数组去重
    }

    var titles = "全选的订单中,有" + isRefundNumber + "个订单包含退款，不默认选中，请单选！";
    if (isRefundNumber > 0)
      messageShow(titles, "warning");
    else if (isRiskOrderCount > 0)
      messageShow("选择的订单中包含平台风控订单，默认不选中；（平台标记去除前不支持处理此类订单）", "warning");
    else if(isOrderLogisticsTransitCount>0)
      messageShow("选择的订单中包含了中转订单，默认不选中，请确认后点击【确认采购单】单独进行下单", "warning");
    else if(isOrderShunfengCount>0)
      messageShow("选择的订单中包含了顺丰包邮，默认不选中，请确认后点击【确认采购单】单独进行下单", "warning");
    else if(isPddHomeDeliveryDoorTagCount>0)
      messageShow("选择的订单中包含了送货上门订单，默认不选中，请确认后点击【确认采购单】单独进行下单", "warning");
    else if(isTouTiaoChooseDeliveryTagCount>0)
      messageShow("选择的订单中包含自选快递服务订单，默认不选中，请确认后点击【确认采购单】单独进行下单", "warning");
    else if(isTouTiaoRiskTagCount>0)
      messageShow("选择的订单中包含风控订单，默认不选中，请确认后点击【确认采购单】单独进行下单", "warning");
    else if(isKuaiShouRiskTagCount>0)
      messageShow("选择的订单中包含风控订单，默认不选中，请确认后点击【确认采购单】单独进行下单", "warning");
    else if(isPddLocalDepotTagCount>0)
      messageShow("选择的订单中包含拼多多本地仓订单，默认不选中，此类订单不支持采购下单！", "warning");
    else if(isWxVideoChangeSkuTagCount>0)
      messageShow("选择的订单中包含微信换款订单，默认不选中，请确认后点击【确认采购单】单独进行下单！", "warning");
    else if(isXiaoHongShuHomeDeliveryTagCount>0)
      messageShow("选择的订单中包含了送货上门订单，默认不选中，请确认后点击【确认采购单】单独进行下单", "warning");

      


    var buyerIdList = this.getListPurchaseOrderCode(selectOrderList, false);

    this.setState({ selectOrderList: selectOrderList, orderList: list, isAllChange: isCheck, selectPurchaseOrderList: buyerIdList });

    $("#allCheck_id_Below").prop("checked", isCheck);//上面的按钮点击，下面的全选跟着变化
    $("#allCheck_id_Above").prop("checked", isCheck);//下面的按钮点击，上面的全选跟着变化
  }


  //获取采购单  订单Code数组List
  getListPurchaseOrderCode(selectOrderList, isFiltrPany) {
    var orderList = this.state.orderList;

    var idList = [];
    if (selectOrderList == null || selectOrderList == undefined)
      idList = this.state.selectOrderList;
    else
      idList = selectOrderList;

    var purchaseOrderIdList = [];
    for (let i = 0; i < orderList.length; i++) {

      for (let j = 0; j < idList.length; j++) {
        if (idList[j] == orderList[i].SellerOrder.OrderCode) {
          var buyerOrdersList = orderList[i].BuyerOrders;
          for (let k = 0; k < buyerOrdersList.length; k++) {
            if (buyerOrdersList[k].BuyerOrder != null) {
              if (isFiltrPany && buyerOrdersList[k].BuyerOrder.ExtField1 != "Success"
                && buyerOrdersList[k].BuyerOrder.ExtField1 != "Paying"
                && buyerOrdersList[k].BuyerOrder.PlatformStatus == "waitbuyerpay")
                purchaseOrderIdList.push(buyerOrdersList[k].BuyerOrder.OrderCode)
            }
          }
          break;
        }
      }
    }

    return purchaseOrderIdList;
  }

  //#endregion


  //#region 店铺维度同步订单 （折叠）
  syncOrder() {
    // this.setState({  //开启加载动画
    //   isSyncLoading: true
    // })
    var shopId = this.state.selectShopId;
    if (!shopId) {
      return;
    }
    var shopByLists = [];
    shopByLists.push(shopId);
    var data = {
      FromSyncBtn:true,
      SyncSids: shopByLists
    }

    this.setState({ sysncOrderStatusTaskProgress: 0 });
    var that = this;
    requests({
      url: "/Order/TriggerSync",
      data: data,
      success: function (res) {
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        {
          that.setState({ isSyncLoading: false });
          that.setState({ sysncOrderStatusTaskProgress: 0 });
          return;
        }

        if (res.Success) {
          that.syncOrderByStatus();

          //   setTimeout(() => {
          //     that.setState({
          //       isSyncLoading: false
          //     })
          //   }, 3000)
        } else {
          messageShow("同步错误：" + res.Message, "error");
          that.setState({ isSyncLoading: false });
          that.setState({ sysncOrderStatusTaskProgress: 0 });
        }
      },
    });

    //开发时删除 模拟调接口 成功了关闭加载动画
    // setTimeout(() => {
    //     this.setState({
    //         isSyncLoading: false
    //     })
    // }, 5000)

  }
  syncOrderByStatus = () => {

    var shopid = this.state.selectShopId;
    var platformType = this.state.selectPlatformType;

    if (!shopid)
      return;
    var sid_pt = [];
    sid_pt.push({ Key: shopid, Value: platformType });


    var that = this;
    requests({
      url: "/Order/GetSyncStatus",
      data: { Sid_PlatformType: sid_pt },
      success: function (res) {
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        {
          that.setState({ isSyncLoading: false });
          that.setState({ sysncOrderStatusTaskProgress: 100 });
          return;
        }

        if (res.Success) {
          if (res.Data == 100) {
            that.setState({ sysncOrderStatusTaskProgress: res.Data });
            that.shopLastSyncTime(shopid, platformType);


            //开始检测
            that.orderToNotProductSync(shopid);
          } else {
            that.setState({ sysncOrderStatusTaskProgress: res.Data });

            //同步状态太近会影响关联商品修改
            setTimeout(() => {
              that.syncOrderByStatus();
            }, 5000);
          }


        } else {
          that.setState({ sysncOrderStatusTaskProgress: 100 });
        }

      },
    });

  }

  //获取最后同步的时间
  shopLastSyncTime(shopId, platformType) {
    var obj = {
      ShopIds: [shopId],
      SyncType: 1,
      PlatformType: platformType
    }
    var that = this;
    getLastSyncTime(obj).then(res => {
      if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        return;

      if (res.Success) {
        var lastSyncTime = res.Data;
        that.setState({ lastSyncTimeByShop: lastSyncTime });
      } else {
        messageShow("获取最后同步时间，错误信息：" + res.Message, "error");
      }
    });
  }

 //按订单检测一次
 orderToNotProductSync(shopId) {
  requests({
    url: "/Product/OrderToNotProductSync",
    data: { ShopId: shopId },
    success: function (res) {

    },
  });
}


  //#endregion




  //公共的关闭模板弹窗
  closeModal = (modalName) => {
    if(modalName=="isShowCommonError")
    {
       this.loadList();
    }
    this.setState({
      [modalName]: false
    })
  }

  

  //#region 支付相关的 （折叠）
  //==============================================支付相关的==============================================================


   //采购单支付请求
   orderPayment = (orderCode,confirm) => {
    otherClickExposureReport(this.state.alibabaPageKey,'dgj_action_supplier_order_pay');
    var selectOrderList = [];
    if (orderCode == null || orderCode == undefined || orderCode == "")
      selectOrderList = this.state.selectOrderList;
    else
      selectOrderList.push(orderCode);


    if (selectOrderList.length == 0) {
      messageShow("请选择订单", "warning");
      return;
    }

    var buyerCodeList = this.getListPurchaseOrderCode(selectOrderList, true);
    if(buyerCodeList.length > 0)
    {
      var orderList = this.state.orderList.map(x => x.BuyerOrders).flat().filter(x => x && x.BuyerOrder && x.BuyerOrder.OrderTags);

      let findChangeAddressOrders = [];
      for (let index = 0; index < buyerCodeList.length; index++) {
        const buyerCode = buyerCodeList[index];
        const item = orderList.find(x => x.BuyerOrder.OrderCode == buyerCode);
        if(!item) continue;
        
        let changeAddressTag = item.BuyerOrder.OrderTags.find(x => x.Tag == 'OrderAddressUpdate' || x.Tag == 'OrderReceiverUpdate');
        if(changeAddressTag)
          findChangeAddressOrders.push(buyerCode);
      }

      if(findChangeAddressOrders.length > 0 && findChangeAddressOrders.length == buyerCodeList.length && !confirm)
      {
        this.setState({ 'allOrderPayChangeAddressDialog':true})
        return;
      }
      else if(findChangeAddressOrders.length > 0 && !confirm)
      {
        this.setState({ 'orderPayChangeAddressDialog':true})
        return;
      }
      buyerCodeList = buyerCodeList.filter(x => !findChangeAddressOrders.includes(x))
    }
    
    var buyerOrders = this.state.orderList.map(s => s.BuyerOrders.map(x => x.BuyerOrder)).flat().filter(x => x)
    buyerOrders = buyerOrders.filter(x => buyerCodeList.includes(x.OrderCode))

    // const hasAlibabaOrder = buyerOrders.findIndex(x => x.PlatformType == "AlibabaZhuKe") > -1
    // const hasTaoteOrder = buyerOrders.findIndex(x => x.PlatformType == "TaoteZhuKe") > -1

    if (buyerCodeList.length == 0) {
      messageShow("选择的订单没有待付款的采购单！","warning");
      return;
    }

    var alibabaOrderList=buyerOrders.filter(x => x.PlatformType == "AlibabaZhuKe") ;
    var taoTeOrderList=buyerOrders.filter(x => x.PlatformType == "TaoteZhuKe") ;

    if(taoTeOrderList.length > 40){
      messageShow("淘特批量手动付款最多只支持一次40笔，请减少数量","warning");
      return;
    }
    if(alibabaOrderList.length>0 && taoTeOrderList.length>0){
      var buyerCodeListByAli=[];
      var buyerCodeListByTaote=[];
      alibabaOrderList.forEach(f=>{
        buyerCodeListByAli.push(f.OrderCode);
      });
      taoTeOrderList.forEach(f=>{
        buyerCodeListByTaote.push(f.OrderCode);
      });
      
      this.setState({
        isShowMoreTypePay:true,
        aliPayOrderCodeList:buyerCodeListByAli,
        taoTePayOrderCodeList:buyerCodeListByTaote,
        selectPurchaseOrderList:buyerCodeListByAli
      })
      //messageShow('多个采购平台订单无法一起支付! 请选择采购平台后分别支付!','info');
      return;
    }else{
      if(taoTeOrderList.length>0)
      {
        this.taotePayUrl(buyerCodeList);//buyerCodeList 都是淘特的buyercode
        return;
      }

      //buyerCodeList 都是阿里的buyercode
      this.setState({ selectOrderList: selectOrderList, selectPurchaseOrderList: buyerCodeList });
      if (buyerCodeList.length > 50 && this.state.isRemindThirty) {
        this.setState({ isShowModalByBatchOpen: true });
        return;
      }
  
      if (buyerCodeList.length == 0) {
        messageShow("选择的订单没有待付款的采购单！", "warning");
        return;
      }
  
      if (buyerCodeList.length > 50) {
        this.protocalPayOpenConfirm(true);
      } else {
        setTimeout(() => {
          this.getOrderPayType();
        }, 0);
      }
    }
  }


  
  
  //多货源时，选择了淘特支付。回来原来的支付方式taotePayUrl
  moreTypePayByTaoteButton=()=>{
    this.taotePayUrl(this.state.taoTePayOrderCodeList);
  }
  

  

  //淘特支付
  async taotePayUrl(orderCodes)
  {
    this.setState({ isLoading: true, loadingTitle: '获取支付二维码中...' });
    const data = {  OrderCodes : orderCodes}
    const res = await GetPayUrlRequest(data);
    this.setState({ isLoading: false, loadingTitle: '' });
    if(!res.Success){
      messageShow("获取支付二维码异常：" + res.Message,'error')
      return;
    }
    if(!res.Data && res.Data.PayUrlMap && res.Data.PayUrlMap['TaoteZhuKe'])
    {
      messageShow("获取支付二维码",'error')
      return;
    }
    const payModel = res.Data.PayUrlMap['TaoteZhuKe'];
    this.state.payModel.PayUrl = payModel.PayUrl
    this.state.payModel.Code = payModel.Code
    this.state.payModel.ExpireTime = payModel.ExpireTime
    this.state.payModel.qrcodeShow = true;
    this.state.payModel.OrderCodes = orderCodes;
    this.setState({ },()=>{
      var authTimeSpan = (payModel.ExpireTime - new Date().valueOf() - 1000) / 1000 ;
      authTimeSpan = Math.floor(authTimeSpan);
      
      this.qrCountDown(authTimeSpan);
      setTimeout(()=>{
        this.getPayReusltPoll();
      },3000)
    })
  }
  //关闭支付二维码
  closeQrCodeInfo(){
    this.state.payModel.PayUrl = ''
    this.state.payModel.Code = ''
    this.state.payModel.ExpireTime = ''
    this.state.payModel.qrcodeShow = false;
    this.setState({ })
  }
  //二维码有效期倒计时
  qrCountDown(timespan)
  {
    $("#authTimespan").text(timespan);
    this.state.payModel.timespan = timespan
    if(timespan == 0 || !this.state.payModel.PayUrl){
      this.closeQrCodeInfo();return;
    }
    this.setState({ })
    timespan = timespan - 1;
    setTimeout(()=>{ this.qrCountDown(timespan); },1000)
  }
  //
  async getPayReusltPoll()
  {
    if(this.state.payModel.qrcodeShow == false || this.state.payModel.timespan < 1)
      return

    const data = {
      OrderCodes : this.state.payModel.OrderCodes,
      Code : this.state.payModel.Code
    }
    var res = await GetPayResultRequest(data);
    if(res.Success){
      if(res.Data.PaySuccess == true)
      {
        this.closeQrCodeInfo();
        messageShow('支付成功','success');
        this.state.orderStatusIndex = 2;
        const orderStatus = this.state.orderStatus.find(x => x.title == "待发货")
        this.setState({})
        setTimeout(()=>{ this.changeNav(orderStatus)},2500)
      }
      else if(res.Data.PayFail == true)
      {
        this.closeQrCodeInfo();
        messageShow('支付失败','info');
      }
      else if(res.Data.PayStatus == 'process' || res.Data.PayStatus == 'init')
      {
        setTimeout(()=>{ this.getPayReusltPoll() },2000);
      }else
      {
        messageShow('支付失败','error');
        this.closeQrCodeInfo();
      }
    }else
    {
      setTimeout(()=>{ this.getPayReusltPoll() },1500);
    }
  }



  //是否开通（自动代扣）  --请求接口
  protocalPayOpenConfirm = (isPay) => {

    this.setState({ isLoading: true, loadingTitle: '获取开通信息...' });

    var that = this;
    requests({
      url: "/PurchaseOrder/ProtocalPayOpenConfirm",
      data: {},
      success: function (res) {
        //关闭动画
        that.setState({ isLoading: false });

        if (res.Success) {
          var isOpen = res.Data;
          that.setState({ isShowModalByVerifyOpen: false });
          if (isOpen) {
            if (isPay == true)
              that.getOrderPayType();
            else
              messageShow("已开通。", "notice");
          }
          else {
            if (isPay == true)
              that.setState({ isShowModalByNotOpen: true });
            else
              messageShow("开通失败");
          }

        } else {
          messageShow("获取开通信息错误：" + res.Message, "error");
        }
      },
    });
  }

  //验证是否能支持
  checkOrderPay=(orderCode,platformOrderId)=>{
    var that=this;
    if(that.state.selectPlatformType=="WxVideo")
    {
       //判断是否存在标签
       requests({
         url: "/Order/CheckOrderStatus",
         data: {OrderCode:orderCode,ShopId:that.state.selectShopId,PlatformOrderId:platformOrderId},
         success: function (res) {
           //关闭动画
           if (res.Success) {
            that.orderPayment(orderCode);
   
           } else {
              if(res.ErrorCode=="CHANGE_SKU")
              {
                 messageShow(res.Message, "error");
   
              }else if(res.ErrorCode=="CHANGE_SKU_SUCCESS")
              {
                that.setState({
                     isShowModalChangeSku:true,
                     changeSkuOrderCode:orderCode
   
                 });
              }else{
                messageShow(res.Message, "error");
              }
           }
         },
       });
    }else{
      this.orderPayment(orderCode);
    } 
  }



  //获取【支付方式】  --请求接口
  getOrderPayType = () => {
    var buyerIdList = this.state.selectPurchaseOrderList;

    var data = {
      BuyerOrderCodes: buyerIdList
    }

    this.setState({ isLoading: true, loadingTitle: '获取支付方式中...' });
    var that = this;
    requests({
      url: "/PurchaseOrder/GetOrderPayType",
      data: data,
      success: function (res) {
        //关闭动画
        that.setState({ isLoading: false });

        if (res.Success) {

          var faildOrderIds = res.Data.PayTypeQueryFaildOrderIds == undefined ? [] : res.Data.PayTypeQueryFaildOrderIds;//获取支付渠道失败的订单
          var isOpenButton = res.Data.ProtocolPayIsOpen == undefined ? false : res.Data.ProtocolPayIsOpen;//是否显示自动代付按钮
          var notWaitPayIds = res.Data.NotWaitPayIds == undefined ? [] : res.Data.NotWaitPayIds;
          var payChannels = res.Data.PayChannels == undefined ? [] : res.Data.PayChannels;//后台预留的数组。也是获取失败的。
          var paymentMoney = res.Data.PaymentMoney;//后台预留的数组。也是获取失败的。

          if (faildOrderIds.length > 0 || payChannels.length > 0 || notWaitPayIds.length > 0) {
            //获取错误列表   --提示框
            that.setState({
              getPaymentErrorFaildOrderList: faildOrderIds,
              getPaymentErrorNotWaitPayIds: notWaitPayIds,
              getPaymentErrorPayChannelsList: payChannels,
              isShowModalBySelectPaymentError: true,
            })
          } else {
            that.setState({
              isShowAutoPayButton: isOpenButton,
              isShowModalBySelectPayment: true,
              showModalByPaymentPaymentMoney: paymentMoney,
            });
          }

        } else
          messageShow("错误信息：" + res.Message, "error");
      },
    });
  }



   //选择付款方式，弹框 --手动支付
   selectPaymentShowModalByManual = () => {

    var buyerIdList = this.state.selectPurchaseOrderList;
    if (buyerIdList.length > 50) {
      messageShow("手动支付，不能超过50个订单", "notice");
      return;
    }

    this.setState({ isShowModalBySelectPayment: false });
    this.getOrderPayUrl();//获取支付链接
  }

  //选择付款方式，弹框 --自动支付
  selectPaymentShowModalByConfirm = () => {
    this.autoPaying();
  }


   //手动支付跳转后 弹框--确认按钮
   payUrlShowModalByConfirm = () => {
    this.setState({ isShowModalByPayUrl: false, isLoading: true });

    this.loadList();
  }

  selectPaymentShowModalByClose = () => {
    this.setState({ isShowModalBySelectPayment: false });
  }

  //自动代扣  --请求接口
  autoPaying = () => {
    var buyerIdList = this.state.selectPurchaseOrderList;
    var data = {
      BuyerOrderCodes: buyerIdList
    }

    this.setState({ isLoading: true, loadingTitle: '正在发起自动代扣...' });
    var that = this;
    requests({
      url: "/PurchaseOrder/AutoPay",
      data: data,
      success: function (res) {

        //关闭动画
        that.setState({ isLoading: false, isShowModalBySelectPayment: false });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          return;

        if (res.Success) {
          var autoPaymentSuccessPayingOrderIds = res.Data.PayingOrderIds;
          var autoPaymentSuccessNotWaitPayIds = res.Data.NotWaitPayIds;
          var autoPaymentSuccessFaildOrderIds = res.Data.PayTypeQueryFaildOrderIds;

          if (autoPaymentSuccessPayingOrderIds.length == 0) {
            that.setState({ isShowModalByAutoPaymentError: true });
          } else {
            that.setState({
              isShowModalByAutoPaymentSuccess: true,
              autoPaymentSuccessPayingOrderIds: autoPaymentSuccessPayingOrderIds,
              autoPaymentSuccessNotWaitPayIds: autoPaymentSuccessNotWaitPayIds,
              autoPaymentSuccessFaildOrderIds: autoPaymentSuccessFaildOrderIds
            });
          }

        } else
          messageShow("错误信息：" + res.Message, "error");
      },
    });
  }

  //自动代扣失败，弹框 --关闭
  autoPaymentErrorShowModalByClose = () => {
    this.setState({ isShowModalByAutoPaymentError: false });
  }

  //自动代扣失败，弹框 --确认  --转手动支付
  autoPaymentErrorShowModalByConfirm = () => {
    var buyerIdList = this.state.selectPurchaseOrderList;
    if (buyerIdList.length > 50) {
      messageShow("手动支付，不能超过50个订单", "notice");
      return;
    }
    this.setState({ isShowModalByAutoPaymentError: false });//关闭失败的弹框

    //自动代扣失败后，可以选择手动支付
    //获取支付链接
    this.getOrderPayUrl();
  }

  //自动代扣成功，弹框 --确认 
  autoPaymentSuccessShowModalByConfirm = () => {
    this.setState({ isShowModalByAutoPaymentSuccess: false, isLoading: true });

    this.loadList();
  }



   //获取订单的【支付链接】  --请求接口
   getOrderPayUrl = () => {
    var buyerIdList = this.state.selectPurchaseOrderList;
    var data = {
      BuyerOrderCodes: buyerIdList,
      SystemVersions: 'pc'
    }

    this.setState({ isLoading: true, loadingTitle: '获取支付链接中...' });
    var that = this;
    requests({
      url: "/PurchaseOrder/getOrderPayUrl",
      data: data,
      success: function (res) {

        //关闭动画
        that.setState({ isLoading: false });

        if (res.Success) {
          var payUrl = res.Data.PayUrl;
          var faildOrderIds = res.Data.PayUrlQueryFaildOrderIds;//链接获取失败的订单
          var notSameOrderIds = res.Data.PayChannelNotSameOrderIds;//支付渠道不一致的订单
          if (faildOrderIds.length > 0 || notSameOrderIds.length > 0) {
            //获取错误列表   --提示框
            that.setState({
              getPayUrlErrorFaildOrderList: faildOrderIds,
              getPayUrlErrorPayChannelsList: notSameOrderIds,
              isShowModalByPayUrlError: true,
            })
          } else {
            var url = decodeURIComponent(payUrl);
            window.open(url);

            setTimeout(() => {
              that.setState({ isShowModalByPayUrl: true });
            }, 1000);
          }

        } else
          messageShow("错误信息：" + res.Message, "error");

      },
    });

  }


  // 批量开启时，弹框 --关闭（不再提醒）
  batchOpenShowModalByClose = () => {
    //关闭弹框，并且后续不提醒
    this.setState({ isShowModalByBatchOpen: false, isRemindThirty: false });
  }

  // 批量开启时，弹框 --确认
  batchOpenShowModalByConfirm = () => {

    this.setState({ isRemindThirty: false, isShowModalByBatchOpen: false });
    setTimeout(() => {
      this.orderPayment();
    }, 0);

    setTimeout(() => {
      this.setState({ isRemindThirty: true });
    }, 1000);
  }

  //==============================================支付相关的  end==============================================================
  //#endregion



  //#region 采购单模块 （折叠）
  closeChangeProductsModule = (e) => {
    this.setState({
      isChangeProductsModule: false,
      changeProductsModuleAction:null,
      isTempRelevanceProduct:null,
      isChangeSp: false
    })
  }
  sureChangeProductsModule = (obj) => {
    this.setState({
        isChangeProductsModule:false,
        changeProductsModuleAction:null,
        isTempRelevanceProduct:null,
        skuMappingsModuleDailog: false,
    })
    if(obj && obj.isOnlyOrder){
      this.UpdateSingleOrder(obj.selectProduct.PlatformId)
    }else
      this.loadList()
  }

  //relateType 1 更换货源， 2，更换规格 3，去匹配
  relevanceProduct = (item,relateType,order) => {
    if(relateType == 1){
      this.setState({
        isChangeProductsModule: true,
        selectProductId: item.ProductID,
        selectedShopProductImgSrc: item.ProductImgUrl,
        selectProductSkuId:item.SkuID,
        changeSearchNavsType:1,//图搜
        isTempRelevanceProduct:1,
        tempPlatformOrderId: order.SellerOrder.PlatformOrderId,
        tempOrderCode: order.SellerOrder.OrderCode,
        tempOrderItemCode: item.OrderItemCode,
        changeProductsModuleAction:relateType,
        skuMappingsModuleRelationData:null,
        isReturnSelectSupplierProduct:0,
      })
    }else if(relateType == 2){
      this.setState({
        isChangeProductsModule: true,
        selectProductId: item.ProductID,
        selectedShopProductImgSrc: item.ProductImgUrl,
        selectProductSkuId:item.SkuID,
        changeSearchNavsType:0,//链接搜
        isTempRelevanceProduct:1,
        tempPlatformOrderId: order.SellerOrder.PlatformOrderId,
        tempOrderCode: order.SellerOrder.OrderCode,
        tempOrderItemCode: item.OrderItemCode,
        changeProductsModuleAction:relateType,
        skuMappingsModuleRelationData:null,
        isReturnSelectSupplierProduct:0,
      })
    }else{
      this.setState({
        isChangeProductsModule: true,
        selectProductId: item.ProductID,
        selectedShopProductImgSrc: item.ProductImgUrl,
        selectProductSkuId:item.SkuID,
        isTempRelevanceProduct:0,
        skuMappingsModuleRelationData:null,
        isReturnSelectSupplierProduct:0,
        tempOrderItemCode: item.OrderItemCode,
        tempOrderCode:item.OrderCode,
      })
    }
    
  }

  relevanceProductRender = (orderItems) => {
    return (
      <table class="orderTables table-style02">
        <tr>
          <td class="orderTables-headerTd">
            <div class="orderTables-header" style={{ backgroundColor: "#f6f9fd" }}>
              <div class="orderTables-header-left">采购订单：确认后生成</div>
            </div>
          </td>
        </tr>
        {
          orderItems.filter(item => item.IsFenXiao != true).map((item, index) =>
            <tr style={{ height: '80px' }}  className={index > 1 ? "hideTr tr" + index : "tr" + index}>
              <td>
                <div className='relevanceProductWrap'>
                  <Button type="primary" onClick={() => this.relevanceProduct(item,3)}>
                    <i className='iconfont icon-jia-copy1'></i>
                    <span>关联货源</span>
                  </Button>
                  <div className='relevanceProductWrap-right'>
                    <span>1.暂无相关信息,请先<i className='dangerColor'>关联货源并匹配规格</i></span>
                    <span>2.<i className='dangerColor'>仅需添加一次</i>，完成后该sku的全部订单自动匹配货源sku</span>
                  </div>
                </div>
              </td>
            </tr>
          )
        }
        {
          orderItems.length > 2 ?
              <tr><td colspan="2"><div><span className="moreShowBtn" onClick={(e) => this.moreShowProduct(e, orderItems.length)}><i className="iconfont icon-down"></i><s>展开更多</s></span></div></td></tr> : null
        }
        {/* <tr>
          <td ></td>
        </tr> */}
      </table>
    )
  }

  moreBuyerListReader(item,itemBuyList,buyerOrderIndex){
    let buyerItemsLength = itemBuyList.BuyerOrder ? itemBuyList.BuyerOrder.OrderItems.length : 0;
    let sellerOrderLength = item.SellerOrder.OrderItems.filter(item => item.IsFenXiao != true).length;
    let len = buyerOrderIndex == item.BuyerOrders.length - 1 ? 
                buyerItemsLength + sellerOrderLength
                : buyerItemsLength ;
    return len > 2 ?
    (<tr><td colspan="2"><div><span className="moreShowBtn" onClick={(e) => this.moreShowProduct(e, itemBuyList.BuyerOrder.OrderItems.length )}><i className="iconfont icon-down"></i><s>展开更多</s></span></div></td></tr>) : null
  }

  //未匹配规格，新的弹窗（有部分映射了）--继续下单（已匹配规格）
  sectorMapByShowModalByOk =()=>{
    this.setState({isShowModalBynotCategoryDouble:false});
    var mapListByOrderList= this.state.mapListByOrderList;
    var selectOrderList=[];
    if(mapListByOrderList.length==0)
     {
      messageShow('所选的订单都没有包含关联并映射，请重新勾选再下单！','notice')
      return;
     }

     var orderList=this.state.orderList;
     for (let i = 0; i < orderList.length; i++) {
      var isE=false;
      for (let j = 0; j < mapListByOrderList.length; j++) 
      {
        if(orderList[i].SellerOrder.OrderCode == mapListByOrderList[j]) 
           isE=true;
      }
      $("#" + orderList[i].SellerOrder.OrderCode + "_Id").prop("checked", isE);

      if(isE)
        selectOrderList.push(orderList[i].SellerOrder.OrderCode);
     }

     if(selectOrderList.length==0)
     {
      messageShow('过滤后没有需要下单的订单，请刷新重试！','notice')
      return;
     }
     $("#allCheck_id_Below").prop("checked", false);//上面的按钮点击，下面的全选跟着变化
     $("#allCheck_id_Above").prop("checked", false);//下面的按钮点击，上面的全选跟着变化
     this.setState({
      selectOrderList:selectOrderList
     },()=>{
      this.createPurchaseOrder();
     })
     

  }



  //关联sku对话框关闭
  // matchSkuDailogClose = ()=>{
  //   this.setState({
  //     matchDailogShow:false,
  //     matchSelectedOrder:null,
  //     matchSelectedSupplier:null,
  //     supplierProductSkuList:[],
  //     selectProduct:null
  //   })
  // }
  
  //#endregion

  //#region 查看发货错误情况 折叠）
  //查看发货错误情况
  onlineSendErrorMsg = (platformOrderId, orderItemCode) => {

    var data = {
      ShopId: this.state.selectShopId,
      SalesOrderCode: platformOrderId,
      SalesOrderItemCode: orderItemCode
    };
    var that = this;
    that.setState({ isLoading: true });
    requests({
      url: "/PurchaseOrder/GetOnlineSendErrorMsg",
      data: data,
      success: function (res) {
        that.setState({ isLoading: false });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          return;


        if (res.Success) {
          var message = res.Data.ErrorMessage
          MessageBox.alert(message,{title:'发货失败原因'})
        } else {
          that.setState({ isLoading: false });
          messageShow("查看原因报错：" + res.Message,'error');
        }
      },
    });

  }
 //#endregion

  //#region 重新发货任务 （折叠）
  /*
  *重新发货任务
  */
  reOnlineSend = (salesOrderCode,platformOrderId, purchaseOrderCode, buyerPlatformOrderId,buyerOrder) => {
    var data = {
      SalesOrderCode: salesOrderCode,
      PurchaseOrderCode: purchaseOrderCode,
      PurchaseOrderId: buyerPlatformOrderId,
      ShopId: this.state.selectShopId,
      BuyerShopId:buyerOrder.ShopId,
    }

    var orderList = this.state.orderList.map(x => x.BuyerOrders).flat().filter(x => x && x.BuyerOrder && x.BuyerOrder.OrderTags) ;
    const item = orderList.find(x => x.BuyerOrder.OrderCode == purchaseOrderCode);
    if(item){
      let changeAddressTag = item.BuyerOrder.OrderTags.find(x => x.Tag == 'OrderAddressUpdate'  || x.Tag == 'OrderReceiverUpdate');
      if(changeAddressTag)
      {
        this.setState({ allOrderSendChangeAddressDialog:true})
        return;
      }
    }
    this.setState({ isLoading: true, loadingTitle: '重新发货...',detailsPlatformOrderId:platformOrderId});
    var that = this;
    requests({
      url: "/PurchaseOrder/ReOnlineSend",
      data: data,
      success: function (res) {
        //关闭动画
        that.setState({ isLoading: false });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          return;

        if (res.Success) {
          messageShow("重新发货成功。", 'success');
          
          that.syncOneOrder("seller", "reOnlineSendButton");//同步并查询一次
        } else
          messageShow( "错误信息：" + res.Message,'error');
      },
    });
  }
  reOnlineSendTask = (confirm)=>{
    var orderList = this.state.orderList;
    var shopId = this.state.selectShopId;
    var selectShopPlatformType = this.state.selectPlatformType;

    var selectOrderList = this.state.selectOrderList;
    if(selectOrderList.length > 0)
    {
      var tempOrderList = this.state.orderList.map(x => x.SellerOrder).filter(x => x.OrderTags);

      let findChangeAddressOrders = [];
      for (let index = 0; index < selectOrderList.length; index++) {
        const orderCode = selectOrderList[index];
        const item = tempOrderList.find(x => x.OrderCode == orderCode);
        if(!item) continue;
        
        let changeAddressTag = item.OrderTags.find(x => x.Tag == 'OrderAddressUpdate' || x.Tag == 'OrderReceiverUpdate');
        if(changeAddressTag)
          findChangeAddressOrders.push(orderCode);
      }

      if(findChangeAddressOrders.length > 0 && findChangeAddressOrders.length == selectOrderList.length && !confirm)
      {
        this.setState({ allOrderSendChangeAddressDialog:true})
        return;
      }
      else if(findChangeAddressOrders.length > 0 && !confirm)
      {
        this.setState({ orderSendChangeAddressDialog:true})
        return;
      }
      selectOrderList = selectOrderList.filter(x => !findChangeAddressOrders.includes(x))
    }

    //若未选择订单，择提示【请选择订单】
    if(selectOrderList.length == 0){
      messageShow("请先选择自动发货失败订单!",'info')
      return;
    }

    /**
     * 组装采购单、平台单数据
     */
     let purchaseOrderIds = [];
     let salesOrderCodes = [];
     let purchaseOrders = [];
     
     selectOrderList.forEach(purchaseOrderId =>{
      let order = orderList.find(o => o.SellerOrder.OrderCode == purchaseOrderId);
      if(order)
      {
        salesOrderCodes.push(order.SellerOrder.OrderCode);//平台单
        if(order.BuyerOrders && order.BuyerOrders.length > 0)
        {
          for (let index = 0; index < order.BuyerOrders.length; index++) {
            const ele= order.BuyerOrders[index];
            if(ele.BuyerOrder.PlatformOrderId)
            {
              purchaseOrderIds.push(ele.BuyerOrder.PlatformOrderId);
              purchaseOrders.push({ ShopId: ele.BuyerOrder.ShopId,PlatformOrderId:ele.BuyerOrder.PlatformOrderId})
            }
          }
        } 
      }
     })
     let apiData = {
      SalesOrderCode:salesOrderCodes,
      PurchaseOrderIds:purchaseOrderIds,
      ShopId:shopId,
      PlatformType:selectShopPlatformType,
      PurchaseOrders: purchaseOrders,
     }

     //提示加载项 【重新发货中...】
    this.setState({ isLoading: true, loadingTitle: '重新发货中...'})
    const that = this;
    
    setTimeout(() =>{
      const url = '/PurchaseOrder/ReOnlineSendTask';
      requests({
        url:url,
        data:apiData,
        success:(res) => { 
          if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          {
            that.setState({ isLoading: false });
            return;
          }

          if (res.Success) {
            const taskCode = res.Data.TaskCode;
            that.reOnlineSendTaskPoll(taskCode);
          } else{
            this.setState({ isLoading: false, loadingTitle: '重新发货中...'})
            messageShow("错误信息：" + res.Message,'error');
          }}
      });
    },0)
  }
  //轮询查询任务结果
  reOnlineSendTaskPoll(taskCode)
  {
    var that = this;
    requests({
      url: "/Common/GetZhuKeReqTask",
      data: { TaskCode: taskCode },
      success: function (res) {
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        {
          that.setState({ isLoading: false });
          return;
        }

        if (res.Success) {
          var dates = res.Data;
          if (dates.FinishedTime) 
          {
            that.setState({ isLoading: false});
            if (dates.Status == "Error" && dates.ErrorMsg)
                that.setState({isShowCommonError:true,showCommonErrorMessage:dates.ErrorMsg});//统一用弹窗
            else if (dates.Status == "Error" && dates.RspContent == null) {
              messageShow("任务发生了异常，失败原因:RspConten is null", 'error');
            } else {
              var rspContentJson = JSON.parse(dates.RspContent);
              let msg = rspContentJson.msg;
              messageShow( msg, 'success');
              //that.syncOneOrder("seller", "reOnlineSendButton");//同步并查询一次 
              var shopId = that.state.selectShopId;
              setTimeout(()=>{
                that.setState({ isLoading: true,orderList:[], current: 1 }, () => {
                  that.orderListCheckboxClose();
                  that.loadList(shopId);
                })
              },3000);
              
            }
          } else {
            //任务未执行完，继续轮训
            setTimeout(() => {
              that.reOnlineSendTaskPoll(taskCode);
            }, 1000);
          }
        }
      },
    });
  }
  //#endregion

  //#region 导出发货失败 （折叠）

   //导出发货失败的订单
   exportSendErrorOrder = (e) => {
    //this.state.selectShopId
    this.setState({ isShowModalByExportSelet: true }, () => {
      $("input[name='exportSeletName']:eq(0)").attr("checked", 'checked');
    });
  }


  //导出，按类型来导出
  exportSendErrorOrderByType = () => {
    var types = $("input[name='exportSeletName']:checked").val();
    
      this.setState({ isLoading: true, loadingTitle: "导出中...", isShowModalByExportSelet: false });
      var that = this;
    
      requests({
        url: "/PurchaseOrder/GetSendErrorOrderExcel",
        data: { ShopId: this.state.selectShopId},
        success: function (res) {
          //关闭动画
          that.setState({ isLoading: false });
          if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
            return;
  
          if (res.Success) {
            var listData = res.Data;
            if (listData == null || listData == undefined)
              listData = [];

            if (listData.length == 0)
               messageShow( "没有查询到可导出的数据！",'error');
            else{
              if (types == "csv") {
                that.exprortExcelBySendErrorAndCsv(listData);
              }else{  //Excel导出
                that.exprortExcelBySendErrorAndExcel(listData);
              }
            }
          } else
            messageShow( "错误信息：" + res.Message,'error');
        },
      });
    
  }


  //csv格式
  exprortExcelBySendErrorAndCsv = (jsonData) => {
    //直接导出
    let str = `订单号,快递公司（必填）,快递单号,1、单次批量发货请勿超出5000条记录，如超出5000条，请拆分文件后分别上传\n`;
    str += `order_sn,shipping_name,shipping_sn,2、请不要删除第二行，否则会造成发货上传失败\n`;
    //增加\t为了不让表格显示科学计数法或者其他格式
    for (let i = 0; i < jsonData.length; i++) {
      for (let item in jsonData[i]) {
        str += `${jsonData[i][item] + '\t'},`;
      }
      str += '\n';
    }
    //encodeURIComponent解决中文乱码
    let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
    //var uri = "data:text/csv;charset=utf-8,\uFEFF" + encodeURI(str);

    //通过创建a标签实现
    var link = document.createElement("a");
    link.href = uri;
    //对下载的文件命名
    link.download = "发货失败的销售单.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  exprortExcelBySendErrorAndExcel=(listData)=>{

    const workbook = new Workbook;
    const sheet = workbook.addWorksheet('Sheet1', { properties: { defaultRowHeight: 23 } });
    sheet.pageSetup.horizontalCentered = true;
    sheet.pageSetup.verticalCentered = true;
    sheet.columns = [  //表头
      { header: '订单号', key: 'title1', width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: '快递公司（必填）', key: 'title2', width: 22, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: '快递单号', key: 'title3', width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
      { header: '1、单次批量发货请勿超出5000条记录，如超出5000条，请拆分文件后分别上传', key: 'title4', width: 90, style: { alignment: { vertical: 'middle', horizontal: 'left',tabColor:"#ff0000" } ,font:{color:	{ argb: 'ff511c'}} } },
    ];
    sheet.addRow({
      title1: "order_sn",
      title2:"shipping_name",
      title3: "shipping_sn",
      title4:"2、请不要删除第二行，否则会造成发货上传失败"
    });
    listData.forEach((item,index)=>{
      sheet.addRow({
        title1: item.order_sn,
        title2: item.shipping_name,
        title3: item.shipping_sn,
      });

    })
    workbook.xlsx.writeBuffer().then((buffer) => {
      undefined
      writeFile('发货失败的销售单Excel表格.xlsx', buffer);
    });
    const writeFile = (fileName, content) => {
      undefined
      let a = document.createElement("a");
      let blob = new Blob([content], { type: "text/plain" });
      a.download = fileName;
      a.href = URL.createObjectURL(blob);
      a.click();
    };

  }

  //#endregion

  //#region 订单标签 （折叠）
  //加载订单标签
  loadOrderTags = async (orders,shopId) =>
  {
    if(!orders || orders.length == 0)
      return;

    const oiCodes = [];
    orders.forEach(order =>{
      oiCodes.push(order.SellerOrder.OrderCode);
    })
    const data = {
      ShopId : shopId,
      OiCodes : oiCodes
    }
    
    const res = await purchaseOrderRequest.OrderTagsList(data);
    if(res.Success)
    {
      const orderTags = res.Data || [];
      var index = 0;
      orders.forEach(order =>{
        const tags = orderTags.filter(e => e.OiCode == order.SellerOrder.OrderCode);
        if(order.SellerOrder.IsShipHold == true)
        {
          tags.push({
            OiCode:order.SellerOrder.OrderCode,
            Platform:order.SellerOrder.PlatformType,
            Tag:'PddShipHold'
          });
        }
        //模拟订单标签
        // if(index == 0)
        // tags.push({
        //   OiCode:order.SellerOrder.OrderCode,
        //   Platform:order.SellerOrder.PlatformType,
        //   Tag:'OrderAddressUpdate'
        // });
        // index++;

        //抖音中转
        const touTiaoLogisticsTransitTag = tags.find(x => x.Tag == 'TouTiaoLogisticsTransitTag' );
        if(touTiaoLogisticsTransitTag)
              order.SellerOrder.IsOrderLogisticsTransitTag=true;
        
        //快手中转
        const ksLogisticsTransitTag = tags.find(x => x.Tag == 'KsLogisticsTransitTag' );
        if(ksLogisticsTransitTag)
              order.SellerOrder.IsOrderKsLogisticsTransitTag=true;


        //快手顺丰
        const ksShunfengTag = tags.find(x => x.Tag == 'KsShunfengTag' );
        if(ksShunfengTag)
              order.SellerOrder.IsOrderKsShunfengTag=true;

        //拼多多送货上门
        const pddHomeDeliveryDoorTag = tags.find(x => x.Tag == 'PddHomeDeliveryDoorTag' );
        if(pddHomeDeliveryDoorTag)
              order.SellerOrder.IsPddHomeDeliveryDoorTag=true;
        //小红书送货上门
        const xiaoHongShuHomeDeliveryTag = tags.find(x => x.Tag == 'XiaoHongShuHomeDeliveryTag' );
        if(xiaoHongShuHomeDeliveryTag)
              order.SellerOrder.IsXiaoHongShuHomeDeliveryTag=true;


        const touTiaoChooseDeliveryTag = tags.find(x => x.Tag == 'TouTiaoChooseDeliveryTag' );
        if(touTiaoChooseDeliveryTag)
              order.SellerOrder.IsTouTiaoChooseDeliveryTag=true;

        const touTiaoRiskTag = tags.find(x => x.Tag == 'TouTiaoRiskTag' );
        if(touTiaoRiskTag)
              order.SellerOrder.IsTouTiaoRiskTag=true;

        const kuaiShouRiskTag = tags.find(x => x.Tag == 'KuaiShouRiskTag' );
        if(kuaiShouRiskTag)
              order.SellerOrder.IsKuaiShouRiskTag=true;


        const pddLocalDepotTag = tags.find(x => x.Tag == 'PddLocalDepotTag' );
        if(pddLocalDepotTag)
              order.SellerOrder.IsPddLocalDepotTag=true;

        const wxVideoChangeSkuTag = tags.find(x => x.Tag == 'WxVideoChangeSkuTag' );
        if(wxVideoChangeSkuTag)
              order.SellerOrder.IsWxVideoChangeSkuTag=true;
        const ksAddressUpdateTag = tags.find(x => x.Tag == 'OrderAddressUpdate' ||  x.Tag == 'OrderReceiverUpdate')
        if(ksAddressUpdateTag && order.BuyerOrders && order.BuyerOrders.length > 0){
          order.BuyerOrders.filter(item => item.BuyerOrder).forEach(item => {
            if(item.BuyerOrder.PlatformStatus == 'waitsellersend' || item.BuyerOrder.PlatformStatus == 'waitbuyerpay')
            {
              item.BuyerOrder.OrderTags = [ksAddressUpdateTag];
            }
          });
        }

        order.SellerOrder.OrderTags=tags;
      })

      this.setState({})
    }

  }
 
  ksRiskOrderTagClickContent(order){
    const element = 
      <div class="btrigger" style={{width:"270px"}}>
        <span>该订单存在骗运费风险，48小时内平台会返回结果;</span>
        <div style={{"display":"flex","alignItems":"center"}}>
          <svg t="1656401688180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" data-spm-anchor-id="a313x.7781069.0.i1" width="20" height="20"><path d="M512 178.176C327.68 178.176 178.176 327.68 178.176 512S327.68 845.824 512 845.824s333.824-149.504 333.824-333.824S696.32 178.176 512 178.176z m0 560.128c-124.928 0-226.304-101.376-226.304-226.304S387.072 285.696 512 285.696c124.928 0 226.304 101.376 226.304 226.304s-101.376 226.304-226.304 226.304z m0-345.088c-65.536 0-118.784 53.248-118.784 118.784 0 65.536 53.248 118.784 118.784 118.784 65.536 0 118.784-53.248 118.784-118.784 0-65.536-53.248-118.784-118.784-118.784z" fill="#2c2c2c" p-id="2250" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"></path></svg>
          <span>没问题，清除风控标记，正常显示收件人信息</span>
        </div>
        <div style={{"display":"flex","alignItems":"center"}}>
          <svg t="1656401688180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" data-spm-anchor-id="a313x.7781069.0.i1" width="20" height="20"><path d="M512 178.176C327.68 178.176 178.176 327.68 178.176 512S327.68 845.824 512 845.824s333.824-149.504 333.824-333.824S696.32 178.176 512 178.176z m0 560.128c-124.928 0-226.304-101.376-226.304-226.304S387.072 285.696 512 285.696c124.928 0 226.304 101.376 226.304 226.304s-101.376 226.304-226.304 226.304z m0-345.088c-65.536 0-118.784 53.248-118.784 118.784 0 65.536 53.248 118.784 118.784 118.784 65.536 0 118.784-53.248 118.784-118.784 0-65.536-53.248-118.784-118.784-118.784z" fill="#2c2c2c" p-id="2250" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"></path></svg>
        <span>有问题，保留标记，并关闭订单</span>
        </div>
      </div>
    return element
  }
  pddRiskOrderTagClickContent(order){
    const element = 
      <div class="btrigger" style={{width:"270px"}}>
        <span>该订单存在骗运费风险，48小时内平台会返回结果;</span>
        <div style={{"display":"flex","alignItems":"center"}}>
          <svg t="1656401688180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" data-spm-anchor-id="a313x.7781069.0.i1" width="20" height="20"><path d="M512 178.176C327.68 178.176 178.176 327.68 178.176 512S327.68 845.824 512 845.824s333.824-149.504 333.824-333.824S696.32 178.176 512 178.176z m0 560.128c-124.928 0-226.304-101.376-226.304-226.304S387.072 285.696 512 285.696c124.928 0 226.304 101.376 226.304 226.304s-101.376 226.304-226.304 226.304z m0-345.088c-65.536 0-118.784 53.248-118.784 118.784 0 65.536 53.248 118.784 118.784 118.784 65.536 0 118.784-53.248 118.784-118.784 0-65.536-53.248-118.784-118.784-118.784z" fill="#2c2c2c" p-id="2250" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"></path></svg>
          <span>没问题，清除风控标记，正常显示收件人信息</span>
        </div>
        <div style={{"display":"flex","alignItems":"center"}}>
          <svg t="1656401688180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" data-spm-anchor-id="a313x.7781069.0.i1" width="20" height="20"><path d="M512 178.176C327.68 178.176 178.176 327.68 178.176 512S327.68 845.824 512 845.824s333.824-149.504 333.824-333.824S696.32 178.176 512 178.176z m0 560.128c-124.928 0-226.304-101.376-226.304-226.304S387.072 285.696 512 285.696c124.928 0 226.304 101.376 226.304 226.304s-101.376 226.304-226.304 226.304z m0-345.088c-65.536 0-118.784 53.248-118.784 118.784 0 65.536 53.248 118.784 118.784 118.784 65.536 0 118.784-53.248 118.784-118.784 0-65.536-53.248-118.784-118.784-118.784z" fill="#2c2c2c" p-id="2250" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"></path></svg>
        <span>有问题，保留标记，并关闭订单</span>
        </div>
      </div>
    return element
  }
  touTiaoRiskOrderTagClickContent(order){
    const element = 
      <div class="btrigger" style={{width:"270px"}}>
        <span>该订单已被平台标记为风险订单，暂不能被采购下单，24小时内平台将会返回风控结果:</span>
        <div style={{"display":"flex","alignItems":"center"}}> 
          <span>-没问题:清除风控标记，可正常被采购下单。</span>
        </div>
        <div style={{"display":"flex","alignItems":"center"}}>         
          <span>-有问题:保留标记，并关闭订单。</span>
        </div>
        <div>      
           <a href={'https://op.jinritemai.com/docs/question-docs/89/4125'} target="_blank" style={{"fontSize":"12px","color":"#0071f2"}}>什么是风控订单？</a>
        </div>
      </div>
    return element
  }
  kuaiShouRiskOrderTagClickContent(order){
    const element = 
      <div class="btrigger" style={{width:"270px"}}>
        <span>该订单暂被平台标记为风控订单，无法正常显示收货信息和采购下单，48小时内平台会返回风控结果:</span>
        <div style={{"display":"flex","alignItems":"center"}}> 
          <span>风控通过:清除风控标记，正常显示收货信息，可正常采购下单;</span>
        </div>
        <div style={{"display":"flex","alignItems":"center"}}>         
          <span>风控不通过:保留风控标记，平台关闭订单;</span>
        </div>
      </div>
    return element
  }
  touTiaoRiskNoPassOrderTagClickContent(order){
    const element = 
    <div>
    <p>该订单已被平台标记为风险订单且未通过平台风控检测，该订单已被平台关闭。</p>
    <div>
      温馨提示:风控不通过的订单会被平台自动关闭。
      <a href={'https://op.jinritemai.com/docs/question-docs/89/4125'} target="_blank" style={{"fontSize":"12px","color":"#0071f2"}}>查看官方公告</a>
    </div>
    </div>
    return element
  }
  kuaiShouRiskNoPassOrderTagClickContent(order){
    const element = 
    <div>
    <p>该订单已被平台标记为风险订单且未通过平台风控检测，该订单已被平台关闭。</p>
    <div>
      温馨提示:风控不通过的订单会被平台自动关闭,且无法正常显示收货信息。 
    </div>
    </div>
    return element
  }
  pddShipHoldTagClickContent(order){
    const element = 
    <div>
      <p>该订单因发货地疫情影响，暂不支持发货，当疫情限制解除时，订单将重启承诺发货时间倒计时并支持发货</p>
      <div>
        前往拼多多后台查看订单详情
        <a href={'https://mms.pinduoduo.com/orders/detail?type=4399&sn=' + order.SellerOrder.PlatformOrderId } target="_blank">查看订单详情链接</a>
      </div>
    </div>
    return element
  }
  ksAddressUpdate(order,tag){
    const element = 
    <div>
      <div style={{fontWeight:"800",marginLeft:"16px"}}>
        <p style={{fontWeight:"800"}}>有什么影响?</p>
        <div>
          平台为避免由于下单收货人信息和实际收货信息不一致的问题带来的消费者客诉，发货前对该类订单做拦截校验。
        </div>
      </div>

      <div style={{marginTop:"24px"}}>
        <p style={{fontWeight:"800",marginLeft:"16px"}}>怎么解决?</p>
        <div>
          <div>
          
            <span><i className="dot-ZT"></i></span>【待付款】的采购单，请点击采购单右侧 <span style={{fontWeight:"800"}}>【取消订单】</span>进行关闭采购单后再重新下单
          </div>
          <div>
            <span><i className="dot-ZT"></i></span>【待发货】的采购单，请点击采购单右侧<span style={{fontWeight:"800"}}>【订单详情】</span> 进行申请采购单退款并且退款成功后再重新下单商
          </div>
          <div>
            <span><i className="dot-ZT"></i></span>【已发货】的采购单，请与供应商协商，然后点击采购单右侧<span style={{fontWeight:"800"}}>【订单详情】</span>申请采购单退款并且退款成功后再重新下单
          </div>
        </div>
      </div>
    </div>
    return element
  }

  //中转的标签提示
  orderLogisticsTransit(order,tag){
    const element = 
    <div>
      <div style={{marginTop:"24px"}}>
        <p style={{fontWeight:"800",marginLeft:"16px"}}>什么是中转订单?</p>
        <div>
          <div>
            <i className="dot-ZT"></i>平台目前推出偏远地区中转服务，
            商家仅需将包裹邮寄至中转仓即可，无需将包裹邮寄至消费者地址。平台在西安建立中<br/>转仓，即将新疆
            的物流包裹分为2段，A段：发货地--西安中转仓，B段：西安中转仓--商家收货地址。
          </div>
        </div>
      </div>

      <div style={{marginTop:"24px"}}>
        <p style={{fontWeight:"800",marginLeft:"16px"}}>有什么影响?</p>
        <div>
          <div>
            <span><i className="dot-ZT"></i></span>中转订单不支持合并下单，仅显示中转仓地址，如需查看完整地址或是物流详情，请
            至店铺后台查看   <a  href={'https://fxg.jinritemai.com/ffa/morder/order/detail?id='+order.SellerOrder.PlatformOrderId}  target='_blank' style={{"fontSize":"12px","color":"#0071f2"}}>订单详情</a>
          </div>
          <div>
            <span><i className="dot-ZT"></i></span>中转订单下单只能使用中转地址，请确保供应商使用抖音电子面单进行打印发货，<span style={{color:"red"}}>否则会造成买家收不到货而产生纠纷</span>
          </div>
        </div>
      </div>

      <div style={{marginTop:"24px"}}>
        <p style={{fontWeight:"800",marginLeft:"16px"}}>怎么解决?</p>
        <div>
          <div>
            <i className="dot-ZT"></i>更换货源为支持使用抖音电子面单进行打印发货的1688货源供应商
          </div>
        </div>
      </div>

    </div>
    return element
  }


  //(快手)中转的标签提示
  orderKsLogisticsTransit(order, tag) {
    const element =
      <div>
        <div style={{ marginTop: "24px" }}>
          <p style={{ fontWeight: "800", marginLeft: "16px" }}>什么是中转订单?</p>
          <div>
            <div>
              <i className="dot-ZT"></i>为了提升西北地区消费者的购物体验，平台推出了西北地区的订单中转服务，西北收货地址将先发往西北中转仓，再由官方中转仓发送到消费者地址
            </div>
          </div>
        </div>

        <div style={{ marginTop: "24px" }}>
          <p style={{ fontWeight: "800", marginLeft: "16px" }}>有什么影响?</p>
          <div>
            <div>
              <span><i className="dot-ZT"></i></span>中转订单不支持合并下单，仅显示中转仓地址，如需查看完整地址或是物流详情，请至店铺后台查看<a  style={{ color: "blue" }} href={'https://s.kwaixiaodian.com/zone/order/detail?id=' + order.SellerOrder.PlatformOrderId} target='_blank'>订单详情</a>
            </div>
            <div>
              <span><i className="dot-ZT"></i></span>中转订单下单只能使用密文下单，请确保供应商使用快手电子面单进行打印发货，<span style={{ color: "red" }}>否则会造成买家收不到货而产生纠纷</span>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "24px" }}>
          <p style={{ fontWeight: "800", marginLeft: "16px" }}>怎么解决?</p>
          <div>
            <div>
              <i className="dot-ZT"></i>更换货源为支持使用快手电子面单进行打印发货的1688货源供应商
            </div>
          </div>
        </div>

      </div>
    return element
  }


    //(快手)中转的标签提示
    orderKsShunfeng(order, tag) {
      const element =
        <div>

  
          <div style={{ marginTop: "24px" }}>
            <p style={{ fontWeight: "800", marginLeft: "16px" }}>有什么影响?</p>
            <div>
              <div>
                <span><i className="dot-ZT"></i></span>商家已选择本商品承诺顺丰包邮。为保障消费者体验，本商品请选择顺丰快递发货否则会产生发货违规，平台将扣除商家的保证金或货款，以10元/单的无门槛优惠券赔付给消费者。
              </div>
             
            </div>
          </div>
  
          <div style={{ marginTop: "24px" }}>
            <p style={{ fontWeight: "800", marginLeft: "16px" }}>怎么解决?</p>
            <div>
              <div>
                <i className="dot-ZT"></i>请确保供应商会使用顺丰快递发货后，再进行下单
              </div>
            </div>
          </div>
  
        </div>
      return element
    }
     //(快手)推荐顺丰包邮
    orderKsRecommonedShunfeng(order, tag) {
      const element =
        <div>

  
          <div style={{ marginTop: "24px" }}>
            <p style={{ fontWeight: "800", marginLeft: "16px" }}>什么是推荐使用顺丰发货</p>
            <div>
              <div>
                <span><i className="dot-ZT"></i></span>平台推荐商家针对这类订单使用顺丰发货，保障消费者的发货和物流配送体验，商家可以选择非顺丰的快递发货，不会产生发货违约
              </div>
             
            </div>
          </div>
        </div>
      return element
    }
  //拼多多 送货上门标签
  orderPddHomeDeliveryDoor(order, tag) {
    const element =
      <div>
        <div style={{ marginTop: "24px" }}>
          <p style={{ fontWeight: "800", marginLeft: "16px" }}>有什么影响?</p>
          <div>
            <div>
              <span><i className="dot-ZT"></i></span>商家应按照承诺提供送货上门服务，如商家未履行承诺，需向用户支付消费者赔付金，并将以无门槛平台优惠劵的形式发放给用户。<a  style={{ color: "blue" }} href={'https://mms.pinduoduo.com/other/rule?listId=&id=1483'} target='_blank'>查看平台规则</a>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "24px" }}>
          <p style={{ fontWeight: "800", marginLeft: "16px" }}>怎么解决?</p>
          <div>
            <div>
              <i className="dot-ZT"></i>请确保供应商发的快递会提供送货上门服务，再进行单独下单
            </div>
          </div>
        </div>

      </div>
    return element
  }
    //小红书 送货上门标签
    orderXiaoHongShuHomeDelivery(order, tag) {
      const element =
        <div>
          <div style={{ marginTop: "24px" }}>
            <p style={{ fontWeight: "800", marginLeft: "16px" }}>有什么影响?</p>
            <div>
              <div>
                <span><i className="dot-ZT"></i></span>送货上门订单需按产品规则进行发货，若未按规则发货，将赔付10元。<a style={{ color: "blue" }}  href={'https://school.xiaohongshu.com/lesson/normal/c2019bf866fd4ef6b6209fc85d834bdd?jumpFrom=ark&from=ark-login'} target='_blank'>查看平台规则</a>
              </div>
            </div>
          </div>
  
          <div style={{ marginTop: "24px" }}>
            <p style={{ fontWeight: "800", marginLeft: "16px" }}>怎么解决?</p>
            <div>
            <div>
                <i className="dot-ZT"></i>请使用密文下单，确保供应商使用小红书电子面单进行打印发货
              </div>
              <div>
                <i className="dot-ZT"></i>供应商发货使用快递:顺丰速运、京东物流，其余快递在陆续接入中
              </div>
              <div>
                <i className="dot-ZT"></i>确认符合要求后，再进行单独下单
              </div>
            </div>
          </div>
  
        </div>
      return element
    }

      //头条 自选快递标签
      orderTouTiaoChooseDelivery(order, tag) {
        var tagval=JSON.parse(tag.TagValue);
        console.log(tagval);
        const element =
          <div>
            <div style={{ marginTop: "24px" }}>
              <p style={{ fontWeight: "800", marginLeft: "16px" }}>有什么影响?</p>
              <div>
                <div>
                  <span><i className="dot-ZT"></i></span>该订单为买家自选{tagval.Expresscompany}快递订单,自选快递金额{tagval.Amount}
                </div>
                <div>
                  <span><i className="dot-ZT"></i></span>自选快递订单下单只能使用密文下单,请确保1688供应商使用抖音电子面单进行打印货。
                </div>
                <div>
                  <span><i className="dot-ZT"></i></span>请按照消费者的诉求使用相应的快递服务商取号发货，否则发货失败。
                </div>
              </div>
            </div>
    
            <div style={{ marginTop: "24px" }}>
              <p style={{ fontWeight: "800", marginLeft: "16px" }}>怎么解决?</p>
              <div>
              <div>
                  <i className="dot-ZT"></i>更换货源为支持使用抖音电子面单的1688货源供应商,并且确保供应商使用买家自选的{tagval.Expresscompany}快递进行发货
                </div>
              </div>
            </div>
    
          </div>
        return element
      }




  //拼多多直邮到家活动
  orderPddDirectMailActivity(order, tag) {
    const href='https://mms.pinduoduo.com/orders/detail?type=4399&from=list&sn='+order.SellerOrder.PlatformOrderId;
    console.log(href);
    const element =
      <div>
        <div>
          <div>
            <div>
              <span>针对该订单的运费，平台会为您补贴广告红包，具体请至拼多多商家后台<a style={{ color: "blue" }} href={href} target='_blank'>订单详情</a>页查看。</span>
            </div>
          </div>
        </div>
      </div>
    return element
  }


    //拼多多本地仓标签
    orderPddLocalDepotActivity(order, tag) {
      const element =
        <div>
          <div>
            <div>
              <div>
                <span>本地仓订单平台无需商家发货，且无订单收件地址，不支持采购下单。具体请至拼多多<a style={{color:"blue"}} href='https://mms.pinduoduo.com/' target='_blank'>商家后台</a>进行查询。</span>
              </div>
            </div>
          </div>
        </div>
      return element
    }

      //微信礼品换sku
      orderWeixinPresentChangeSku(order, tag) {
        const element =
        <div>
        <div>
          <p style={{ fontWeight: "800", marginLeft: "16px" }}>有什么影响?</p>
          <div>
            <div>
              <span><i className="dot-ZT"></i></span>换款中订单需前往店铺后台同意或拒绝后再操作。<a style={{color:"blue"}}  href={'https://store.weixin.qq.com/chengzhang/webdoc/wiki/7486/54a3e53bcac7e2c3/growth_center_manual_for_store' } target="_blank">查看换款服务使用指南</a>
            </div>
          </div>
        </div>

        <div>
          <p style={{ fontWeight: "800", marginLeft: "16px" }}>同意换款后怎么处理?</p>
          <div>
           <div>
              <i className="dot-ZT"></i>【待付款】的采购单，请点击采购单右侧
              【取消订单】进行关闭采购单后重新下单 或者联系供应商<br/>改规格并确保供应商会按换款后的规格发货后再点击点击采购单【向供应商付款】进行支付
            </div>
            <div>
              <i className="dot-ZT"></i>【待发货】的采购单，请点击采购单右侧【订单详情】申请采购单退款并且退款成功后再重新下单<br/>
               或者联系供应商确保供应商会按换货后的规格发货后再点击点击采购单【重新回传】或手动回传单号
            </div>
          </div>
        </div>

      </div>
        return element
      }

      //微信礼品
      orderWeixinPresent(order, tag) {
        const element =
          <div>
            <div>
              <div>
                <div>
                  <span>该订单为微信礼物订单，请仔细确认后再进行下单采购</span>
                </div>
              </div>
            </div>
          </div>
        return element
      }

  //#endregion
  

  //#region 更换货源
  //更换货源弹窗
  showChangeProductV2 = async (buyerOrderItem,sellerOrder) =>{
    const sellerOrderItemCode = buyerOrderItem.OrderItemCodeBySales;
    const sellerOrderItem = sellerOrder.OrderItems.find(x => x.OrderItemCode == sellerOrderItemCode)
    if(!sellerOrderItem) return;
    //console.log('sellerOrderItem =>',sellerOrderItem)
    //console.log('buyerOrderItem =>',buyerOrderItem)
    buyerOrderItem.ProductId = buyerOrderItem.ProductID
    this.setState({
      isChangeProductsModule: true,
      selectProductId: sellerOrderItem.ProductID,
      selectProductSkuId:sellerOrderItem.SkuID,
      selectedShopProductImgSrc: sellerOrderItem.ProductImgUrl,
      changeSearchNavsType:0,//链接搜
      isTempRelevanceProduct:1,
      tempSellerOrderItem:sellerOrderItem,
      changeSupplierProduct:buyerOrderItem,
      skuMappingsModuleRelationData:null,
    })
  }
  //更换货源保存
  saveSureChangeProduct = (item) =>{
    //console.log('saveSureChangeProduct =>',item);
    
    item.SourcePlatform = item.SourcePlatform ? item.SourcePlatform : 'AlibabaZhuKe';
    item.Skus = item.Skus || [];
      for (let sku of item.Skus) {
        sku.lable = sku.Color + sku.Size
        sku.SourcePlatform = item.SourcePlatform
      }
    this.setState({
      isChangeProductsModule:false,
    })
  }
  //#endregion
  
  //#region 单选规格弹窗
  //单选规格弹窗
  showEditSkuMapping = async (buyerOrderItem,sellerOrder) =>{
    const sellerOrderItemCode = buyerOrderItem.OrderItemCodeBySales;
    const sellerOrderItem = sellerOrder.OrderItems.find(x => x.OrderItemCode == sellerOrderItemCode)
    if(!sellerOrderItem) return

    let supplierProduct = buyerOrderItem.SupplierProduct;
    if(!buyerOrderItem.SupplierProduct){
      const data = { SupplierProductId:buyerOrderItem.ProductID,SourcePlatform:buyerOrderItem.SourcePlatform }
      this.setState({isLoading:true})
      const res = await productRequest.LoadSupplierProduct(data)
      this.setState({isLoading:false})
      if(!res.Success){
        messageShow(res.Message,'error')
        return
      }
      supplierProduct = res.Data.AlibabaProduct
      buyerOrderItem.SupplierProduct = supplierProduct
    }
    
    this.setState({
        singleCheckSkuModuleDailog: true,
        singleCheckSkuData:{buyerOrderItem,sellerOrderItem},
        singleCheckSkuSelectSupplierProduct:supplierProduct,
    })
  }
  //单选规格弹窗仅订单、所有订单提示
  saveEditSkuMappingConfirm = (singleCheckSku)=>{
    const singleCheckSkuData = this.state.singleCheckSkuData;
    const buyerOrderItem = singleCheckSkuData.buyerOrderItem;
    const sellerOrderItem = singleCheckSkuData.sellerOrderItem;

    if(singleCheckSku.SupplierProductId == buyerOrderItem.SupplierProduct)
    console.log('sellerOrderItem =>',sellerOrderItem)
    console.log('buyerOrderItem =>',buyerOrderItem)
    const data = { };
    data.OrderCode = sellerOrderItem.OrderCode;
    data.OrderItemCode = sellerOrderItem.OrderItemCode;
    data.PlatformOrderId = sellerOrderItem.PlatformOrderId;
    data.SubItemId = sellerOrderItem.SubItemID;
    data.PreviewCode = buyerOrderItem.PreviewCode;
    data.ShopId = sellerOrderItem.ShopId;
    data.SupplierProductId = buyerOrderItem.ProductID;
    data.SourcePlatform = buyerOrderItem.SourcePlatform;
    data.SupplierProductSkuId = buyerOrderItem.SkuID;
    data.SupplierProductSkuCode = buyerOrderItem.SkuCode;
    data.PlatformType = sellerOrderItem.PlatformType;
    data.Relations = [
      {
        ProductId:sellerOrderItem.ProductID,
        SupplierProductId:singleCheckSku.ProductId,
        SourcePlatform:singleCheckSku.SourcePlatform,
        SkuMappings:[{
          SkuId: sellerOrderItem.SkuID,
          SupplierSkuId: singleCheckSku.SkuId,
          MappingCount: singleCheckSku.mappingCount,
        }],
      }
    ];
    this.state.tempSkuMappingData = data;
    // this.state.isOnlyOrderDialog = true;
    
    // this.setState({},()=>{
    //   $('input[name=only_order][value=1]').prop('checked',true);
    // })
    this.saveEditSkuMapping();
  }
  //单选规格弹窗保存
  saveEditSkuMapping = async ()=>{
    const isOnlyOrder = $('input[name=only_order]:checked').val()
    const tempSkuMapping = this.state.tempSkuMappingData;
    tempSkuMapping.RelateDistributor = "1";
    // tempSkuMapping.RelateDistributor = isOnlyOrder;
    this.state.isOnlyOrderDialog = false;
    this.setState({ isLoading:true });
    const res = await purchaseOrderRequest.RelateTemporaryProductV2(tempSkuMapping);
    this.setState({ isLoading:false });
    
    if(!res.Success){
      messageShow(res.Message,'error');
      return;
    }

    messageShow('保存成功','success')
    this.state.singleCheckSkuModuleDailog = false;
    //console.log('tempSkuMapping =>',tempSkuMapping)
    this.setState({});
    this.loadList();
  }
  //单选规格弹窗关闭
  closeEditSkuMapping = () =>{
    this.setState({
      singleCheckSkuModuleDailog: false,
    })
  }
  //#endregion 
  //#region 去匹配、更换货源规格相关
  //弹窗关闭
  closeSkuMappingsModule = () => {
      this.setState({
          skuMappingsModuleDailog: false,
          skuMappingSelectProduct: null,
      })
  }
  onChangeSupplierProduct = (data) => {
    this.setState({
        isChangeSp: true,
        isChangeProductsModule: true,
        changeSearchNavsType: 1,
        changeSupplierProduct: data.changeSupplierProduct,
        selectedShopProductImgSrc: data.changeSupplierProduct.PicURI,
        selectProductId: data.selectProductId,
        selectProductSkuId: this.state.skuMappingSelectProduct.SkuID
    })
  }
  //去匹配、更换规格展示规格映射弹窗
  showSkuMapping = (product,showAddSupplierProduct) =>{
    this.setState({
        skuMappingsModuleDailog: true,
        skuMappingSelectProduct: product,
        skuMappingShowAddSupplierProduct: showAddSupplierProduct,
        skuMappingsModuleRelationData:null,
        skuMappingsTitle:showAddSupplierProduct?'更换货源规格':'匹配规格'
    })
  }
  //去匹配、更换规格展示规格映射弹窗保存
  skuMappingSaveSure = (relations)=>{
    const selectOrderItem = this.state.skuMappingSelectProduct
    const skuId = selectOrderItem.SkuID
    const productId = selectOrderItem.ProductID

    const data = { }
    data.TargetShopId = selectOrderItem.ShopId
    data.OrderCode = selectOrderItem.OrderCode
    data.Relations = []
    data.TargetShopPt = selectOrderItem.PlatformType
    for(const relation of relations.Relations){
      // const mappings = relation.SkuMappings.filter(x => x.SkuId == skuId)
      // if(mappings.length == 0)
      //   continue;
      const mappings = relation.SkuMappings;
      data.Relations.push({
        ProductId:productId,
        SupplierProductId:relation.SupplierProductId,
        SourcePlatform:relation.SourcePlatform,
        SkuMappings:mappings,
      })
    }
    if(data.Relations.length == 0){
      messageShow('请选择规格！','error')
      return
    }
    this.saveOrderSkuMapping(data)
  }
  //去匹配、更换规格展示规格映射弹窗保存
  saveOrderSkuMapping = async (data) =>{
    this.setState({isLoading : true})
    const res = await batchDistributionRequest.RelateProductV2(data)
    this.setState({isLoading : false})

    if(res.Success == true)
    {
      this.setState({ isLoading: true});
      this.closeSkuMappingsModule()
      this.loadList();
      messageShow('保存成功！','info');
    }else
    {
      messageShow(res.Message,'error');
    }
  }
  //更换货源规格点击添加货源
  skuMappingShowAddSupplierProduct = (data)=>{
    const item = data.ProductFx;
    this.setState({
      isChangeProductsModule: true,
      selectProductId: item.PlatformId,
      selectedShopProductImgSrc: item.ImageUrl,
      isTempRelevanceProduct:0,
      skuMappingsModuleRelationData:data,
      isReturnSelectSupplierProduct:1,
    })
  }
  //#endregion

  //#region 获取物流信息
  getLogisticsInfo = async (orders) => {

    if(!orders || orders.length == 0)
      return;

    const oiCodes = [];
    const queryBuyerOrder = [];
    orders.forEach(order =>{
      if(order.BuyerOrders && order.BuyerOrders.length > 0){
        queryBuyerOrder.push(...order.BuyerOrders.filter(x => x.BuyerOrder && x.BuyerOrder.PlatformOrderId))
      }
    })
    oiCodes.push(...queryBuyerOrder.map(x => x.BuyerOrder.OrderCode))
    if(oiCodes.length == 0)
      return;
    
    const data = {
      OrderCode : oiCodes
    }
    
    const res = await purchaseOrderRequest.GetBuyerOrderLogisticsInfo(data);
    if(res.Success)
    {
      const logisticsInfos = (res.Data && res.Data.List) || [];
      queryBuyerOrder.forEach(order =>{
        const logiticsInfo = logisticsInfos.find(x => x.OrderCode == order.BuyerOrder.OrderCode);
        if(logiticsInfo != null){
          order.LogisticsInfo = logiticsInfo.LogisticsInfo;
        }
      })
      this.setState({})
    }
  }
  //#endregion
  tohuoyuanLink = (orderItem,order)=>{
    if(orderItem.IsMapping == false && !order.BuyerOrder.PlatformOrderId){
      return;
    }
    huoyuanLinkReport({ProductId:orderItem.ProductID,SourcePlatform:orderItem.SourcePlatform},this.state.alibabaPageKey);
  }
  render() {
    let selectSourcePlatform = this.state.sourcePlatformList.find(x => x.active == true);
    return (
      <div className='wrap'>
        <HeaderMenu />
        <main>
          <div className='wrap-left scroll-x' >
            <NavMenu changeNav={this.changeLeftNav} defaultActive={"/orderList"} />
          </div>
          <div className="wrap-right procurementOrder">
          <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav} 
                                    from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' :null} 
                                    alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()}/>
             
             {/*this.state.platformType == "KuaiShou" ?
              <div className='tagDanger' style={{ marginBottom: "5px", padding: '8px' }}>
                <div>
                  <span>官方公告:延迟发货、虚假发货、虚假轨迹专项治理，请各位商家立即开展相关自査整改工作。<a className='defColor' href="https://edu.kwaixiaodian.com/rule/web/detail?id=R9DP9fGJS9" target='_blank'>了解详情</a></span>
                </div>

              </div> : null
            */}
      
             <div id="notic_show" ></div>
            <div className='searchWrap mywrap'>
             
              

               <select id="selectChooseDateId" style={{marginRight:'10px'}}>
                  <option value="7">7天</option>
                  <option value="15">15天</option>
                  <option value="30" selected >30天</option>
                  <option value="60">60天</option>
                  <option value="90">90天</option>
                </select>
              
              <Select  id='orderBySortId' onChange={this.changeSelect.bind(this, "orderBySort")} value={this.state.orderBySort} clearable={true} style={{ width: "192px", marginRight: "10px" }}	>
                <Select.Option key="asc" label="最新订单在后" value="asc" />
                <Select.Option key="desc" label="最新订单在前" value="desc" />
              </Select>
              <label>
                <input style={{ marginTop: 0 }} type="text" id="orderListInputOrderId" onChange={this.orderInputOnClick} placeholder="多个平台订单编号(，)分隔" />
              </label>
              <label style={{ marginLeft: "10px" }}>
                <input style={{ marginTop: 0 }} type="text" id="supplierWangWangInputId" placeholder="供应商旺旺" />
              </label>
              <label style={{ marginLeft: "10px" }}>
                <Select onChange={this.changeSelect.bind(this, "orderProductByType")} value={this.state.orderProductByType} clearable={true} style={{ width: "192px", marginRight: "10px" }}	>
                  <Select.Option key="ProductID" label="商品ID" value="ProductID" />
                  <Select.Option key="ProductSubject" label="商品标题" value="ProductSubject" />
                </Select>
                <input style={{ marginTop: 0 }} type="text" id="orderProductByTypeInputeId" placeholder="输入值" />
              </label>
              <Button style={{ marginLeft: "10px" }} type="primary" onClick={() => this.queryButton(true)}>查询</Button>
            </div>

            <div className='mywrap'>
              <div className="NavChangeAndSyncOrderBtn">
                <TableNavChange distributionStatus={this.state.orderStatus} changeNav={this.changeNav} />
                <div className="progress-wrap">
                  <Progress
                    percentage={this.state.sysncOrderStatusTaskProgress}
                    type="circle"
                    width="40"
                    strokeWidth="3"
                    style={{ marginRight: "15px" }}
                  />
                  {
                    this.state.sysncOrderStatusTaskProgress == 100 || this.state.sysncOrderStatusTaskProgress == "100" ?
                      <span className="syncOrderBtn-span" onClick={() => this.syncOrder()}>同步订单</span>
                      : <span style={{ color: "#999" }}>正在同步中...</span>
                  }
                  <span className="warnColor" style={{ marginLeft: "10px" }}>上次同步时间:{this.state.lastSyncTimeByShop}</span>
                </div>
              </div>
              {/* 交易关闭的状态下，显示 */}
              <div className='searchWarn' id="searchWarn" style={{ height: "15px" }}>
                <span>店铺订单已退款但采购单：</span>
                <span onClick={(e) => this.searchTradingclose(e, "noRefund")} className={this.state.refundType == "noRefund" ? "searchBtn active" : "searchBtn"}>未申请退款</span>
                <span onClick={(e) => this.searchTradingclose(e, "refund")} className={this.state.refundType == "refund" ? "searchBtn active" : "searchBtn"}>退款中</span>

                <span className='defColor hover'>友情提示
                  <ul className='searchWarn-title'>
                    <li>1. 此功能针对开通极速退款的商家。</li>
                    <li>2. 厂家还未发货，但买家申请退款，店铺已完成极速退款；商家需及时申请采购单退款。</li>
                    <li>3. 未申请退款状态：店铺订单已完成退款，采购单已付款且未申请退款。</li>
                    <li>4. 退款中状态：店铺订单完成退款，采购单已付款且属于退款中状态。</li>
                  </ul>
                </span>
              </div>

              

              

              {/* 待发货的状态下，显示 */}
              <div className='operate-wrap' id="waitingSendExportId"  style={{ justifyContent: 'flex-start' }}>

                <div className='SourcePlatformNav' id='SourcePlatformNav'>
                    {
                      this.state.orderStatusIndex==0?
                      <ul className='SourcePlatformNavWrap'>
                        { 
                          this.state.purchaseOrderStatusList.map(ele =>{ 
                            if(ele.isHide == true)
                              return null;
                            return <li className={ele.active?"active SourcePlatformNavWrap-item":"SourcePlatformNavWrap-item"} key={ele.id} onClick={()=>{ this.changePurchaseOrderStatus(ele)}}>
                              {ele.title}
                              {ele.number != -1 ? <span style={{ color: "#77bf04" }}>({ele.number})</span> : null}
                            </li> 
                          })
                        }
                      </ul>:null
                    }
                </div>

                <div className='operate-left' >
                  <label>
                    <input type="checkbox" value="sendOverdue"
                      id="sendOverdue_checkboxId"
                      name="checkboxNameByOrderStatus"
                      onClick={() => this.substateByCheckbox('sendOverdue')} />
                    <span>已逾期发货</span>
                  </label>
                  <label>
                    <input type="checkbox" value="twelveDelivery"
                      id="twelveDelivery_checkboxId"
                      name="checkboxNameByOrderStatus"
                      onClick={() => this.substateByCheckbox('twelveDelivery')} />
                    <span>12小时内需发货</span>
                  </label>
                  {/* 后台查询逻辑上，不好查，先隐藏 */}
                  {/* <label id="mergeOrderByLeftId">
                    <input type="checkbox" value="canMergeOrder"  
                     id="canMergeOrder_checkboxId"
                     name="checkboxNameByOrderStatus" 
                     onClick={()=>this.substateByCheckbox('canMergeOrder')}/>
                    <span>可合并下单</span>
                  </label> */}
                  <label id="sendErrorByLeftId" >
                    <input type="checkbox" value="autoSendError"
                      id="autoSendError_checkboxId"          
                      name="checkboxNameByOrderStatus"
                      onClick={() => this.substateByCheckbox('autoSendError')} />
                    <span>自动发货失败</span>
                  </label>
                  <div className='waitingSendExportWrap' id="exportByRightId">
                  <div onClick={(e) => this.exportSendErrorOrder(e)} className={"operateBtn"}>
                    <span className="iconfont icon-xiazai"></span>
                    <span className="operateBtn-title">导出发货失败订单</span>
                  </div>
                  <span className='defColor hover'>友情提示
                    <ul className='waitingSendExport-title'>
                      <li>1. 拼多多店铺订单进行发货时，官方会检测<span style={{ color: "red" }}>是否使用了拼多多电子面单</span>获取快递单号</li>
                      <li>
                        2. 如果未使用拼多多电子面单获取单号，则会<span style={{ color: "red" }}>有几率发货失败</span>。对发货失败的订单，系统会自动重试20次。如20次还未成功，则不会自动发货，需要用户手动到拼多多店铺后台发货。
                      </li>
                      <li>
                        3. 通过工具向1688下采购单时，会<span style={{ color: "red" }}>自动备注</span>
                        【请使用拼多多电子面单发货】。但厂家是1688商家，大部分使用的是菜鸟电子面单，有条件的用户，可与厂家沟通要求使用拼多多电子面单。
                      </li>
                      <li>
                        4. 如有订单发货失败，可直接<span style={{ color: "red" }}>导出</span>发货失败订单及对应快递单号，到拼多多<span style={{ color: "red" }}>店铺后台</span>
                        使用<span style={{ color: "red" }}>表格批量导入发货</span>(<span style={{ color: "red" }}>请勿修改表格内容</span>)
                      </li>
                    </ul>
                  </span>
                </div>
                </div>
            
                
                
              </div>

              <div className='tableWrap'>
                <table class="table-style01 orderList" id="orderList_table">
                  <thead>
                    <tr style={{backgroundColor:'#f8f8f8'}}>
                      {/* <th style={{ width: "30px" }}><input type="checkbox" id="allCheck_id_Above" onClick={() => this.allCheckbox("above")} /></th>
                      <th style={{ width: "570px" }}>平台订单信息</th>
                      <th style={{ width: "570px" }}>采购订单信息</th> */}

                      <th colspan="20" style={{padding:"8px 0"}}>
                        <div className='tableWrap-header'>
                          <label style={{ width: "80px" }}>
                            <input type="checkbox" id="allCheck_id_Above" onClick={() => this.allCheckbox("above")} />
                            <i>全选本页</i>  
                          </label>
                          <div className='tableWrap-header-right'>
                            <div className='tableWrap-header-right-title' style={{width:'320px'}}>平台订单信息</div>
                            <div className='tableWrap-header-right-ul'>
                            {
                              this.state.orderStatusIndex ==0 ?
                              <ul className='bleWrap-header-ul'>
                                { 
                                  this.state.sourcePlatformList.map(ele =>{ 
                                    if(ele.isHide !=true){
                                      return <li className={ele.active?"active bleWrap-header-ul-item":"bleWrap-header-ul-item"} key={ele.id} onClick={()=>{ this.changeSourcePlatform(ele)}}>
                                      {ele.title}   
                                      {/* {ele.number !="" ? <span style={{color:"#77bf04"}}>({ele.number})</span>  :null} */}
                                      </li> 
                                    }
                                  })
                                }
                              </ul>:null
                            }            
                            </div>
                            <div className='tableWrap-header-right-title' style={{textAlign:'left'}}>采购订单信息</div>
                          </div>
                        </div>


                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.isNotList == true && this.state.isAuthShop != true ?
                        <tr>
                          <td className="noneData" colSpan="20">
                            <div className="noneData-wrap">
                              <i className="iconfont icon-wushuju"></i>
                              <span className="noneData-title">暂无数据！</span>
                            </div>
                          </td>
                        </tr> : null
                    }
                    {
                      this.state.isAuthShop == true ?
                        <tr>
                          <td className="noneData" colSpan="20">
                            <div className="noneData-wrap">
                              <i className="iconfont icon-wushuju"></i>
                              <span className="noneData-title" style={{ color: "red" }}>店铺授权已失效，请前往【我的店铺】页面重新授权店铺</span>
                            </div>
                          </td>
                        </tr> : null
                    }
                    {
                      this.state.orderList.map((item) =>
                        <tr>
                          <td>
                            <div className="inputWrap">
                              <input type="checkbox" Id={item.SellerOrder.OrderCode + "_Id"} onChange={(e) => this.orderChange(e, item.SellerOrder.OrderCode)} />
                            </div>
                          </td>
                          <td valign="top">
                            <table className="orderTables table-style02">
                              <tr>
                                <td colspan="2" className="orderTables-headerTd">
                                  <div className="orderTables-header" style={{ backgroundColor: "#fff9f0" }}>
                                    <div className="orderTables-header-left">
                                      <div className="orderTables-header-left-item">
                                        {/* <span className='iconfont icon-fuzhi1' onClick={() => this.copyPlatformOrderId(item.SellerOrder.PlatformOrderId)}></span> */}
                                        <span>订单编号：<i className="mainColor" id={"Order" + item.SellerOrder.PlatformOrderId}>{item.SellerOrder.PlatformOrderId}</i></span>
                                        <span className="mL15 orderTables-header-left-timeWrap">付款时间：<i className="mainColor">{item.SellerOrder.PayTime}</i></span>
                                      </div>
                                      <div className="orderTables-header-left-item">
                                        <span>买家昵称：<i className="mainColor">{item.SellerOrder.BuyerWangWang}</i></span>
                                        {
                                          item.SellerOrder.LastShipTimeIsRed == true && item.SellerOrder.LastShipTimeValue != "" && item.SellerOrder.IsShipHold != true && this.state.orderStatusIndex==0 ?
                                            <div className='lastShipTimeWrap orderTables-header-left-timeWrap'>
                                              <i className='iconfont icon-jishi' style={{ color: "#ff511c" }}></i>
                                              <span className='lastShipTimeValue' style={{ color: "#ff511c" }}>{item.SellerOrder.LastShipTimeValue}</span>
                                              {item.SellerOrder.LastShipTimeIsEnd != true ? <span>后将逾期发货</span> : null}
                                            </div>
                                            : null
                                        }
                                        {
                                          item.SellerOrder.LastShipTimeIsRed != true && item.SellerOrder.LastShipTimeValue != "" && item.SellerOrder.IsShipHold != true && this.state.orderStatusIndex==0?
                                            <div className='lastShipTimeWrap orderTables-header-left-timeWrap'>
                                              <span className='lastShipTimeValue'>{item.SellerOrder.LastShipTimeValue}</span>
                                              {item.SellerOrder.LastShipTimeIsEnd != true ? <span>后将逾期发货</span> : null}
                                            </div>
                                            : null
                                        }
                                      </div>
                                    </div>
                                    <div class="orderTables-header-right">
                                      <PlatformName platformType={item.SellerOrder.PlatformType} isHidePatformName={true} />
                                      <span class="mainColor" style={{ marginLeft: "3px" }}>{item.ShopName}</span>
                                    </div>

                                  </div>
                                </td>
                              </tr>
                              {/*平台订单-- 商品列表 */}
                              {
                                item.SellerOrder.OrderItems.map((itemSellerSkuList, index) =>
                                  this.renderSellerOrderTr(item, itemSellerSkuList, index, item.SellerOrder.OrderItems.length)
                                )
                              }
                              {

                                item.SellerOrder.OrderItems.length > 2 ?
                                  <tr><td colspan="2"><div><span className="moreShowBtn" onClick={(e) => this.moreShowProduct(e, item.SellerOrder.OrderItems.length)}><i className="iconfont icon-down-fill"></i><s>展开更多</s></span></div></td></tr> : null
                              }
                              {/*平台订单-- 地址信息 */}
                              <tr>
                                <td colspan="2">
                                  收货地址：<i class="mainColor">{item.SellerOrder.ToName}，{item.SellerOrder.ToMobile}，{item.SellerOrder.ToFullAddress}</i>
                                  {/* {
                                    item.SellerOrder.IsRisk && item.SellerOrder.IsRisk == true ?
                                      <div class="riskOrder">
                                        {
                                          item.SellerOrder.RiskShow == true ?
                                            <div class="riskOrderRemarkText">
                                              <span>该订单存在骗运费风险，48小时内平台会返回结果;</span>
                                              <div>
                                                <svg t="1656401688180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" data-spm-anchor-id="a313x.7781069.0.i1" width="20" height="20"><path d="M512 178.176C327.68 178.176 178.176 327.68 178.176 512S327.68 845.824 512 845.824s333.824-149.504 333.824-333.824S696.32 178.176 512 178.176z m0 560.128c-124.928 0-226.304-101.376-226.304-226.304S387.072 285.696 512 285.696c124.928 0 226.304 101.376 226.304 226.304s-101.376 226.304-226.304 226.304z m0-345.088c-65.536 0-118.784 53.248-118.784 118.784 0 65.536 53.248 118.784 118.784 118.784 65.536 0 118.784-53.248 118.784-118.784 0-65.536-53.248-118.784-118.784-118.784z" fill="#2c2c2c" p-id="2250" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"></path></svg>
                                                <span>没问题，清除风控标记，正常显示收件人信息</span>
                                              </div>
                                              <div>
                                                <svg t="1656401688180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" data-spm-anchor-id="a313x.7781069.0.i1" width="20" height="20"><path d="M512 178.176C327.68 178.176 178.176 327.68 178.176 512S327.68 845.824 512 845.824s333.824-149.504 333.824-333.824S696.32 178.176 512 178.176z m0 560.128c-124.928 0-226.304-101.376-226.304-226.304S387.072 285.696 512 285.696c124.928 0 226.304 101.376 226.304 226.304s-101.376 226.304-226.304 226.304z m0-345.088c-65.536 0-118.784 53.248-118.784 118.784 0 65.536 53.248 118.784 118.784 118.784 65.536 0 118.784-53.248 118.784-118.784 0-65.536-53.248-118.784-118.784-118.784z" fill="#2c2c2c" p-id="2250" data-spm-anchor-id="a313x.7781069.0.i0" class="selected"></path></svg>
                                                <span>有问题，保留标记，并关闭订单</span>
                                              </div>
                                            </div> : null
                                        }
                                        <span class='smaDarBtn'
                                          onMouseOver={() => { this.setRiskShow(true, item.SellerOrder.OrderCode) }}
                                          onMouseLeave={() => { this.setRiskShow(false, item.SellerOrder.OrderCode) }} >风控订单
                                        </span>
                                      </div> : null
                                  } */}
                                  <div style={{display:"inline-block",lineHeight:"20px"}}>
                                  {
                                    item.SellerOrder.OrderTags?
                                      item.SellerOrder.OrderTags.map(tag =>{
                                        const tempTag = this.state.tagEnum[tag.Tag];
                                        if(!tempTag)
                                          return null;
                                        if(tempTag.predicate && tempTag.predicate(item,tag) == false)
                                          return null;

                                        if(!tempTag.clickContent)
                                          return <span className={tempTag.tagClass} style={{marginLeft:"4px"}}>{tempTag.tagName}</span>

                                        return <Popover placement="top" trigger="hover" width={ tempTag.width || "200px" } content={ tempTag.clickContent(item,tag) }>
                                                  <span className={tempTag.tagClass} style={{marginLeft:"4px"}}>{tempTag.tagName}</span>
                                                </Popover>
                                      }):null
                                  }
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td valign="top">
                            {/*============ 采购单============  */}
                            {
                              item.BuyerOrders == null || item.BuyerOrders.length == 0 ?
                                this.relevanceProductRender(item.SellerOrder.OrderItems)
                                :
                                item.BuyerOrders.map((itemBuyList,buyerOrderIndex) =>
                                  <table class="orderTables table-style02">
                                    <tr>
                                      <td colspan="2" class="orderTables-headerTd">
                                        <div class="orderTables-header" style={{ backgroundColor: "#f6f9fd" }}>
                                          <div class="orderTables-header-left">
                                            <div>
                                              <div className='orderTables-header-left-item'>
                                                <span style={{ display: "flex" ,alignItems: 'center' }}>
                                                  <PlatformName platformType={itemBuyList.BuyerOrder.PlatformType != null ? itemBuyList.BuyerOrder.PlatformType : 'AlibabaZhuKe'} isHidePatformName={true} />
                                                  {/* <span style={{ marginLeft: '3px' }}>
                                                    订单号:
                                                    {itemBuyList.BuyerOrder == null || (itemBuyList.BuyerOrder != null && (itemBuyList.BuyerOrder.PlatformOrderId == ""
                                                      || itemBuyList.BuyerOrder.PlatformOrderId == null))
                                                      ? "确认后生成"
                                                      : itemBuyList.BuyerOrder.PlatformOrderId
                                                    }
                                                  </span> */}
                                                  {
                                                      itemBuyList.BuyerOrder && itemBuyList.BuyerOrder.OrderItems 
                                                      && itemBuyList.BuyerOrder.OrderItems.length > 0 && itemBuyList.BuyerOrder.OrderItems[0].PreviewError == true ?
                                                      // <div style={{marginLeft:'10px',display:'flex',gap:'10px'}}>
                                                      //   <span className='dangerColor hover' title={itemBuyList.BuyerOrder.OrderItems[0].PreviewErrorMessage} style={{'whiteSpace':'nowrap','overflow':'hidden','textOverflow':'ellipsis','width':'200px'}}>下单失败：{itemBuyList.BuyerOrder.OrderItems[0].PreviewErrorMessage}</span>
                                                      //   <a className='defColor hover' target='_blank' href='https://detail.1688.com/offer/692018195736.html?sk=consign'>查看帮助&gt;&gt;</a>
                                                      // </div>
                                                      this.renderOrderErrorMessageDialog(itemBuyList.BuyerOrder.OrderItems[0].PreviewErrorMessage)
                                                      :
                                                      itemBuyList.BuyerOrder == null || (itemBuyList.BuyerOrder != null && (itemBuyList.BuyerOrder.PlatformOrderId == ""
                                                      || itemBuyList.BuyerOrder.PlatformOrderId == null))
                                                      ? isNotNull(itemBuyList.BuyerOrder.CreateOrderErrorMessage)?
                                                        this.renderOrderErrorMessageDialog(itemBuyList.BuyerOrder.CreateOrderErrorMessage):<div>订单号:确认后生成</div>
                                                      :<div> 订单号:{itemBuyList.BuyerOrder.PlatformOrderId}</div> 
                                                    }
                                                </span>
                                                {
                                                  itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != '' && itemBuyList.BuyerOrder.PlatformStatus != null ?
                                                    <span className="mL15">创建时间：{itemBuyList.BuyerOrder.CreateTime}</span>
                                                    : null
                                                }
                                              </div>

                                              {
                                                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.ExtField1 == "Paying" ?
                                                  <text className="defBackColor" style={{ color: "#fff" }}>免密支付中</text>
                                                  : null
                                              }
                                              {
                                                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.ExtField1 == "Faild" ?
                                                  <text className="warnBackColor" style={{ color: "#fff", backgroundColor: "#fe6f4f" }}>免密支付失败，请手动支付</text>
                                                  : null
                                              }
                                              {
                                                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.TradeType == "Alipay" && itemBuyList.BuyerOrder.ExtField1 == "Success" ?
                                                  <text className="defBackColor" style={{ color: "#fff" }}>支付宝</text>
                                                  : null
                                              }
                                              {
                                                itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.TradeType == "Epay" && itemBuyList.BuyerOrder.ExtField1 == "Success" ?
                                                  <text className="defBackColor" style={{ color: "#fff" }}>诚E赊</text>
                                                  : null
                                              }
                                            </div>
                                          </div>
                                        {
                                          itemBuyList.BuyerOrder.PlatformType != "TaoteZhuKe" && itemBuyList.BuyerOrder.OrderItems.length > 0 && (itemBuyList.BuyerOrder.OrderItems[0].IsMapping || itemBuyList.BuyerOrder.OrderItems[0].PlatformOrderId) ?
                                          <div class="orderTables-header-right">
                                              <span>{itemBuyList.SupplierLoginId}</span>
                                              <a href={"https://amos.alicdn.com/getcid.aw?v=3&groupid=0&s=1&charset=utf-8&uid=" + itemBuyList.SupplierLoginId + "&site=cnalichn"} target="_blank"> <i className="iconfont icon-wangwang"></i></a>
                                            </div>
                                          :null
                                        }
                                        {/* {
                                          itemBuyList.BuyerOrder.PlatformType == "TaoteZhuKe" ?
                                          <div class="orderTables-header-right">
                                              <i className="iconfont icon-wangwang" onClick={()=>{ this.syncSingleOrder(itemBuyList.BuyerOrder)}}></i>
                                          </div>
                                          :null
                                        } */}
                                        </div>
                                    </td>
                                  </tr>
                                  {/* 采购单-商品列表 */}
                                  {
                                    itemBuyList.BuyerOrder != null ?
                                      itemBuyList.BuyerOrder.OrderItems.map((itemBuySkuList, index) =>
                                        this.renderBuyerOrderTr(itemBuyList, itemBuySkuList, index, itemBuyList.BuyerOrder.OrderItems.length, item)
                                      ) : null
                                  }
                                  {
                                    buyerOrderIndex == item.BuyerOrders.length - 1?
                                      item.SellerOrder.OrderItems.filter(item => item.IsFenXiao != true).map((item, index) =>
                                        <tr style={{ height: '80px' }} className={(itemBuyList.BuyerOrder.OrderItems.length + index + 1) > 2 ? "hideTr tr" + (itemBuyList.BuyerOrder.OrderItems.length + index + 1) : "tr" + (itemBuyList.BuyerOrder.OrderItems.length + index + 1) }>
                                          <td colspan='2'>
                                            <div className='relevanceProductWrap'>
                                              <Button type="primary" onClick={() => this.relevanceProduct(item,0)}>
                                                <i className='iconfont icon-jia-copy1'></i>
                                                <span>关联货源</span>
                                              </Button>
                                              <div className='relevanceProductWrap-right'>
                                                <span>1.暂无相关信息,请先<i className='dangerColor'>关联货源并匹配规格</i></span>
                                                <span>2.<i className='dangerColor'>仅需添加一次</i>，完成后该sku的全部订单自动匹配货源sku</span>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      ):null
                                  }
                                  
                                  {
                                    this.moreBuyerListReader(item,itemBuyList,buyerOrderIndex)
                                  }
                                  {/* {

                                    itemBuyList.BuyerOrder != null ?
                                      itemBuyList.BuyerOrder.OrderItems.length > 2 ?
                                        <tr><td colspan="2"><div><span className="moreShowBtn" onClick={(e) => this.moreShowProduct(e, itemBuyList.BuyerOrder.OrderItems.length)}><i className="iconfont icon-down"></i><s>展开更多</s></span></div></td></tr> : null : null
                                  } */}
                                  {/* 采购单 --显示物流 */}
                                  {
                                    itemBuyList.BuyerOrder != null && (itemBuyList.BuyerOrder.PlatformStatus == "waitbuyerreceive" || itemBuyList.BuyerOrder.PlatformStatus == "waitsellersend") ?
                                      <tr>
                                        <td colspan="2">
                                          <div className="expressWrap" style={{ paddingTop: 0 }}><span>物流公司:</span><span className="mainColor">{itemBuyList.LogisticsInfo.ExpressName}</span></div>
                                          <div className="expressWrap"><span>物流单号:</span><span className="mainColor">{itemBuyList.LogisticsInfo.LogisticsBillNo}</span></div>
                                          <div style={{ padding: "5px 5px 0 5px" }}><span>物流状态:</span><span className="mainColor">{itemBuyList.LogisticsInfo.TraceInfo}</span></div>
                                        </td>
                                      </tr>
                                      : null
                                  }
                                  {/* 采购单 --地址信息 */}
                                  {
                                    itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.PlatformStatus != null && itemBuyList.BuyerOrder.PlatformStatus != "" ?
                                      <tr>
                                        <td colspan="2">
                                          收货地址：<i class="mainColor">{itemBuyList.BuyerOrder.ToName}，{itemBuyList.BuyerOrder.ToMobile}，{itemBuyList.BuyerOrder.ToFullAddress}</i>
                                          {
                                            itemBuyList.BuyerOrder.IsEncryptCreateOrder == "1" ? 
                                              <Button type="warning" size="mini" style={{"borderRadius":"12px"}}>密</Button>:null
                                          }
                                          {
                                            itemBuyList.BuyerOrder.IsPifatuan? 
                                              <Button type="warning" size="mini" style={{"borderRadius":"12px"}}>精选</Button>:null
                                          }

                                          <div style={{display:"inline-block",lineHeight:"20px"}}>
                                          {
                                            itemBuyList.BuyerOrder.OrderTags?
                                            itemBuyList.BuyerOrder.OrderTags.map(tag =>{
                                                const tempTag = this.state.purchaseTagEnum[tag.Tag];
                                                if(!tempTag)
                                                  return null;
                                                if(tempTag.predicate && tempTag.predicate(item,tag) == false)
                                                  return null;

                                                if(!tempTag.clickContent)
                                                  return <span className={tempTag.tagClass} style={{marginLeft:"4px"}}>{tempTag.tagName}</span>

                                                return <Popover placement="top" trigger="hover" width={ tempTag.width || "200px" } content={ tempTag.clickContent(item,tag) }>
                                                          <span className={tempTag.tagClass} style={{marginLeft:"4px"}}>{tempTag.tagName}</span>
                                                        </Popover>
                                              }):null
                                          }
                                          </div>
                                        </td>
                                      </tr>
                                      : null
                                  }
                                  {/* 采购单 --地址信息 */}
                                  {
                                    itemBuyList.BuyerOrder != null && itemBuyList.BuyerOrder.AutoCreateOrderErrorMessage != null && itemBuyList.BuyerOrder.AutoCreateOrderErrorMessage != "" ?
                                      <tr>
                                        <td colspan="2">
                                          自动下采购单失败: <i style={{ color: 'red' }}>{itemBuyList.BuyerOrder.AutoCreateOrderErrorMessage}</i>
                                        </td>
                                      </tr>
                                      : null
                                  }
                                </table>
                              )
                            }
                          </td>
                        </tr>
                      )
                    }
                  </tbody>
                </table>
                <div className='paginationwrap'>
                  <Pagination onCurrentChange={this.changeCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.totals} pageSize={this.state.pagesize} currentPage={this.state.current} pageSizes={[10, 30, 50]} />
                </div>
              </div>

            </div>


            {/* 商品规格映射 */}
            {/* {this.productMappingRender()} */}
          </div>
        </main>



        <div className="zk-footer">
          {
            this.state.purchaseOrderStatusIndex == 1 && this.state.selectPurchaseOrderList.length > 50 ?
              <div className="zk-footer-wran warn-wrap">
                <i className="icon">!</i>
                <s style={{ padding: "0 5px 0 0" }}>
                  当前选择<em style={{ fontSize: "16px", color: "#ff511c" }}>{this.state.selectPurchaseOrderList.length}</em>采购单超过
                  <s style={{ fontSize: "16px", color: "#ff511c" }}>50</s>
                  笔,无法使用手动支付,建议开通自动代扣,
                </s>
                <s class="defColor hover" onClick={() => this.notOpenShowModalByConfirm(true)}>去开通》</s>
              </div>
              : null
          }

          <input type="checkbox" id="allCheck_id_Below" onClick={() => this.allCheckbox('below')} />
          <span>已勾选{this.state.selectOrderList.length}个订单</span>
          {
             this.state.orderStatusIndex == 0 &&  this.state.purchaseOrderStatusIndex == 1 && this.state.sourcePlatformIndex != 4 ?
              <Button style={{ marginLeft: "10px" }} type="primary" onClick={() => this.confirmOrder()}>批量采购</Button> : null
          }
          {
             this.state.orderStatusIndex == 0 && this.state.purchaseOrderStatusIndex == 2 ?
              <Button style={{ marginLeft: "10px" }} type="primary" onClick={() => this.orderPayment()}>批量付款</Button> : null
          }
          {
             this.state.orderStatusIndex == 0 && this.state.purchaseOrderStatusIndex == 1?
              <Button style={{ marginLeft: "10px" }} type="warning" onClick={() => this.ignoreOrder(1)}>批量忽略</Button> : null
          }
          {
              this.state.orderStatusIndex == 5 ?
              <Button style={{ marginLeft: "10px" }} type="warning" onClick={() => this.ignoreOrder(0)}>取消忽略</Button> : null
          }
          {
           this.state.orderStatusIndex == 0 &&  this.state.purchaseOrderStatusIndex == 3 ?
            <Button style={{ marginLeft: "10px" }} type="primary" onClick={() => this.reOnlineSendTask()}>重新发货</Button> : null
          }
        </div>

        <ShowModal 
          titleName={'确定是否更换'}
          showLeftTopBtn={true}
          width={500}
          showModal={this.state.isOnlyOrderDialog}
          skin={"isOnlyOrderDialog"}
          hideBtn={true}
          zIndex={1001}
          className={'isOnlyOrderDialogWarp'}
          cancelDailog={() => this.closeModal('isOnlyOrderDialog')} >
            <div className='isOnlyOrderDialogRadio showModalWrap-box-commonContent'>
              <div className='isOnlyOrderDialogRadioItem'>
                <input type="radio" name='only_order' value='1'/>
                <span>仅针对这笔订单</span>
                <div>
                  <span>不保存关联关系，下次下单还是使用原货源规格</span>
                </div>
              </div>
              {/* <div className='isOnlyOrderDialogRadioItem'>
                <input type="radio" name='only_order' value='0'/>
                <span>此店铺商品产生的订单全部更换为新货源</span>
                <div>
                  <span>保存关联关系，下次下单全部使用新货源</span>
                </div>
              </div> */}
            </div>
            <div className="showModalWrap-box-commonfooter">
                  <span onClick={() => this.saveEditSkuMapping()} style={{ display: 'flex' }}
                    className="showModalWrap-box-footer-btn">确定关联</span>
                  <span onClick={() => this.setState({isOnlyOrderDialog:false})} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
            </div>
        </ShowModal>
       
        <SkuMappingsModule
            showModal={this.state.skuMappingsModuleDailog}
            shopId={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.ShopId}
            productId={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.ProductID}
            platformType={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.PlatformType}
            selectProductSkuId={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.SkuID}
            selectOrderCode={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.OrderCode}
            orderItemCode={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.OrderItemCode}
            relationData={this.state.skuMappingsModuleRelationData}
            saveSure={this.skuMappingSaveSure}
            closeSkuMappingsModule={this.closeSkuMappingsModule}
            onChangeSupplierProduct={this.onChangeSupplierProduct}
            isShowAddSupplierProduct={this.state.skuMappingShowAddSupplierProduct}
            showAddSupplierProduct={this.skuMappingShowAddSupplierProduct}
            isShowDelSupplierProduct={this.state.skuMappingShowAddSupplierProduct}
            skuMappingsTitle={this.state.skuMappingsTitle}
            isOrderListOpen={true}
        ></SkuMappingsModule>
        <ChangeProductsModuleV2
          selectProductId={this.state.selectProductId}
          selectProductSkuId={this.state.selectProductSkuId}
          orderItemCode={this.state.tempOrderItemCode}
          orderCode={this.state.tempOrderCode}
          selectedShopProductImgSrc={this.state.selectedShopProductImgSrc}
          title={this.state.changeSupplierProduct && this.state.isChangeSp ? "同款货源替换":"关联货源"}
          isChangeSp={this.state.isChangeSp}
          showModal={this.state.isChangeProductsModule}
          activeSearchNavId={this.state.changeSearchNavsType}
          isTempRelevanceProduct={this.state.isTempRelevanceProduct}
          changeProductsModuleAction ={this.state.changeProductsModuleAction}
          changeSupplierProduct={this.state.changeSupplierProduct}
          closeChangeProductsModule={this.closeChangeProductsModule}
          sureRelevanceRequest={this.sureChangeProductsModule}
          saveSureSupplierProduct={this.saveSureChangeProduct}
          relationData={this.state.skuMappingsModuleRelationData}
          isReturnSelectSupplierProduct={this.state.isReturnSelectSupplierProduct}
        />
        <SingleCheckSkuModule 
          showModal={this.state.singleCheckSkuModuleDailog} 
          title={'编辑采购单规格'}
          selectProduct={this.state.singleCheckSkuSelectSupplierProduct}
          selectSupplierProductId={this.state.singleCheckSkuSelectSupplierProductId}
          selectSupplierProductSourcePlatform={this.state.singleCheckSkuSelectSupplierProductSourcePlatform}
          selectedSkuId={this.state.singleCheckSkuData && this.state.singleCheckSkuData.buyerOrderItem && this.state.singleCheckSkuData.buyerOrderItem.SkuID}
          mappingCount={this.state.singleCheckSkuData && this.state.singleCheckSkuData.buyerOrderItem && this.state.singleCheckSkuData.buyerOrderItem.Count}
          saveSure={this.saveEditSkuMappingConfirm}
          closeShowModal={this.closeEditSkuMapping}
        />
        {/* 确认采购订单，有失败的，会弹这个框  New */}
        <ShowModal showModal={this.state.isShowModalByCreateOrderError} hideBtn={true} titleName={'采购单生成错误'} >
          <div className="showModalWrap-box-commonContent orderError-wrap" style={{ padding: "15px", fontSize: "16px" }}>
            {
              this.state.createOrderError.map((item) =>

                <div className="newDialog-content-tr">
                  {/* 第一列 */}
                  <div className="newDialog-content-td">
                    {
                      item.SalesOrderIds.map((itemOrderList) =>
                        <span className="fS10">{itemOrderList}</span>
                      )
                    }
                  </div>
                  {/* 第二列 */}
                  <div className="newDialog-content-td">
                    <span className="fS10">{item.BuyerOrderId}</span>
                  </div>
                  {/* 第三列 */}
                  <div className="newDialog-content-td">
                    <span className="fS10">{item.ErrorMessage}</span>
                  </div>
                </div>

              )
            }
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.createOrderErrorShowModalByConfirm()}>确认关闭</span>
          </div>
        </ShowModal>
     
      {/* 提示未映射 */}
      <ShowModal showModal={this.state.isShowModalBynotCategory} titleName={"提示"} hideBtn={false}
          cancelDailog={this.cancelNotCategoryByShowModal} sureDailog={this.notCategoryByShowModalByOk}>
          <div className="showModalWrap-box-commonContent notCategory-wrap">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px 20px 0 20px", fontSize: "16px" }}>
              <i className="iconfont icon-gantan icofontStatus"></i>
              <span>有订单商品未匹配规格，前往匹配规格：</span>
            </div>
            <div className="showModalWrap-commonContent-item notCategory">
              {this.state.notCategoryListTitle}
            </div>
          </div>
        </ShowModal>



        {/* 提示未映射2(New)，包含已映射的，可以忽略 */}
        <ShowModal width={"500px"} showModal={this.state.isShowModalBynotCategoryDouble} hideBtn={true} showRightTopBtn={true} cancelDailog={()=>{ this.closeModal("isShowModalBynotCategoryDouble")}} titleName={"商品未匹配规格提示"}>
          <div className="showModalWrap-box-commonContent" style={{ fontSize: "16px", padding: "20px" }}>

             <div style={{marginBottom: "10px", marginTop: "30px" }}>检测到有订单商品未匹配规格，是否继续下单</div>

          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn cancleBtn" style={{border: "1px solid #b9ceff" }} onClick={() => this.sectorMapByShowModalByOk()}>继续下单（已匹配规格）</span>
            <span className="showModalWrap-box-footer-btn" style={{marginLeft: "10px" }} onClick={() => this.notCategoryByShowModalByOk()}>去匹配规格</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowModalBynotCategoryDouble")}>关闭</span>
          </div>
        </ShowModal>

        {/* 统一的错误弹窗 */}
        <ShowModal width={"500px"} showModal={this.state.isShowCommonError} hideBtn={true} >
          <div className="showModalWrap-box-commonContent" style={{ fontSize: "16px", padding: "10px" }}>
            <div style={{ paddingLeft: "16px", marginBottom: "10px", marginTop: "10px" }}>
              {this.state.showCommonErrorMessage}
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowCommonError")}>关闭</span>
          </div>
        </ShowModal>

        <ShowModal width={"540px"} showModal={this.state.encryFialdDialog} hideBtn={true} titleName={'确认'} >
          <div className="showModalWrap-box-commonContent" style={{ "fontSize": "14px", "marginLeft": "30px", "marginTop": "10px" }}>
            <div>
              {/* 订单{ this.state.encryFaildPlatformOrderId }, */}
              解密失败：{this.state.encryErrorMessage}
            </div>
            <p></p>
            <div>
              <span>订单密文下单，不消耗店铺解密额度。</span>
              <a href="https://docs.qq.com/doc/DYkFjV3R2TFZKUnZn" target="_blank" style={{ "fontSize": "12px" ,"color":"#0071f2"}}> 点击了解详情</a>
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => { this.props.history.push("/supplierMarke") }}>去打标</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => { this.closeModal("encryFialdDialog") }}>关闭</span>
          </div>
        </ShowModal>

        {/* 下单时，检测中转订单 */}
        <ShowModal width={"540px"} showModal={this.state.encryFialdDialogByZhongZhuan} hideBtn={true} titleName={'确认'} >
          <div className="showModalWrap-box-commonContent" style={{ "fontSize": "14px", "marginLeft": "30px", "marginTop": "10px" }}>
          <div>
            检测到当前中转订单未使用密文下单。<span style={{"color":"red"}}>由于中转订单下单只能使用中转地址，供应商必须使用{this.state.selectPlatformType =="TouTiao"?<span>抖音</span>:this.state.selectPlatformType =="KuaiShou"?<span>快手</span>:null}电子面单进行打印，否则会造成买家收不到货而产生纠纷。</span>
            </div>
            <div>
            如确认供应商已支持使用{this.state.selectPlatformType =="TouTiao"?<span>抖音</span>:this.state.selectPlatformType =="KuaiShou"?<span>快手</span>:null}电子面单进行打印，请前往【订单管理】》【下单设置】中对供应商进行标记使用密文下单 
            </div>
            <div>
              <a href="https://docs.qq.com/doc/DYkFjV3R2TFZKUnZn" target="_blank" style={{"fontSize":"12px","color":"#0071f2"}}> 点击了解密文详情</a>
            </div>  
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => { this.props.history.push("/supplierMarke") }}>前往设置</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => { this.closeModal("encryFialdDialogByZhongZhuan") }}>关闭</span>
          </div>
        </ShowModal>

        {/* 限制明文下单，提示指引 */}
        <ShowModal width={"540px"} showModal={this.state.noEncryptErrorDialog} hideBtn={true} titleName={'提示'} >
          <div className="showModalWrap-box-commonContent" style={{ "fontSize": "14px", "marginLeft": "30px", "marginTop": "10px" }}>
            <div>
            {this.state.encryErrorMessage}
            </div>
            <p></p>
            <div>
              <span>订单密文下单，不消耗店铺解密额度。</span>
              <a href="https://docs.qq.com/doc/DYkFjV3R2TFZKUnZn" target="_blank" style={{ "fontSize": "12px" ,"color":"#0071f2"}}> 点击了解详情</a>
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            {
              this.state.selectPlatformType !="XiaoHongShu"?
                <span>
                  <label>
   <input type="checkbox" 
           id="no_encrypt_error_check"
           name="no_encrypt_error_check_name"
            />
                  <span>不再提示</span>
                  </label>
                </span>
                :null
            }
            {
              this.state.selectPlatformType !="XiaoHongShu"?
              <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.confirmOrderByContinue()}>继续解密采购</span>:null
            }
            <span className="showModalWrap-box-footer-btn" style={{"marginLeft": "5px"}} onClick={() => { this.props.history.push("/supplierMarke") }}>密文下单设置</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => { this.closeModal("noEncryptErrorDialog") }}>关闭</span>
          </div>
        </ShowModal>


         {/* 限制密文下单逻辑，提示指引 */}
        <ShowModal width={"540px"} showModal={this.state.existPurchaseEncryptionProductDialog} hideBtn={true} titleName={'提示'} >
          <div className="showModalWrap-box-commonContent" style={{ "fontSize": "14px", "marginLeft": "30px", "marginTop": "10px" }}>
            <div>
              <span>订单中存在供应商末开通该商品淘宝密文服务，存在密文订单无法发货风险，请谨慎下单，如有需要，请点击更换货源规格进行替换货源。</span>
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.confirmOrderByExistEncryptionProduct(2)}>所有订单密文采购</span>
            <span className="showModalWrap-box-footer-btn" style={{"marginLeft": "5px"}} onClick={() => { this.confirmOrderByExistEncryptionProduct(1) }}>仅采购支持密文服务订单</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => { this.closeModal("existPurchaseEncryptionProductDialog") }}>关闭</span>
          </div>
        </ShowModal>

        
        
        
        {/* 选择付款方式，提示 */}
        <ShowModal showModal={this.state.isShowModalBySelectPayment} hideBtn={true} titleName={'待付款金额' + this.state.showModalByPaymentPaymentMoney + '元'} >
          <div className="showModalWrap-box-commonContent">
            {
              this.state.isShowAutoPayButton == true ?
                <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
                  <i className="iconfont icon-gantan icofontStatus"></i>
                  <span>免密支付优先使用诚e赊代扣,若失败则使用支付宝代扣</span>
                </div>
                :
                <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
                  <i className="iconfont icon-wenhao icofontStatus"></i>
                  <span>是否使用手动支付？</span>
                </div>
            }
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" style={{ marginLeft: "5px" }} onClick={() => this.selectPaymentShowModalByManual()}>手动支付</span>
            {
              this.state.isShowAutoPayButton == true ?
                <span className="showModalWrap-box-footer-btn" style={{ marginLeft: "5px" }} onClick={() => this.selectPaymentShowModalByConfirm()}>免密支付</span>
                : null
            }
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.selectPaymentShowModalByClose()}>关闭</span>
          </div>
        </ShowModal>

          {/* 获取支付链接（手动支付的方式），有错误的 提示弹框，提示 */}
          <ShowModal showModal={this.state.isShowModalByPayUrl} hideBtn={true} titleName={'提示'} >
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <i className="iconfont icon-gantan icofontStatus"></i>
              <span>是否已手动支付成功？</span>
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.payUrlShowModalByConfirm()}>已支付并刷新</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowModalByPayUrl")}>关闭</span>
          </div>
        </ShowModal>

         {/* 自动代扣失败，提示 */}
         <ShowModal showModal={this.state.isShowModalByAutoPaymentError} hideBtn={true} titleName={'提示'} >
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <i className="iconfont icon-add-fill-hover-copy icofontStatus"></i>
              <span>自动代扣失败，请使用手动支付</span>
            </div>

          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.autoPaymentErrorShowModalByConfirm()}>手动支付</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.autoPaymentErrorShowModalByClose()}>关闭</span>
          </div>
        </ShowModal>


        {/* 自动代扣成功，提示 */}
        <ShowModal showModal={this.state.isShowModalByAutoPaymentSuccess} hideBtn={true} titleName={'提示'} >
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px 20px 0 20px", fontSize: "16px" }}>
              <span>已对{this.state.autoPaymentSuccessPayingOrderIds.length}笔采购单发起免密支付</span>
            </div>
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px 20px 0 20px", fontSize: "16px" }}>
              {this.state.autoPaymentSuccessNotWaitPayIds.length > 0 ? <span>有{this.state.autoPaymentSuccessNotWaitPayIds.length}个订单不属于待付款！</span> : null}
              {this.state.autoPaymentSuccessFaildOrderIds.length > 0 ? <span>有{this.state.autoPaymentSuccessFaildOrderIds.length}个订单发起失败！</span> : null}
              <span> 请耐心等待支付结果</span>
            </div>
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <span style={{ color: "#f7941f" }}>温馨提示：可到个人中心设置开通。</span>
            </div>
          </div>

          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.autoPaymentSuccessShowModalByConfirm()}>关闭</span>
          </div>
        </ShowModal>

          {/* 检测没开启自动代扣，勾选超过数量时，提示（超过显示数据就不提示） */}
          <ShowModal showModal={this.state.isShowModalByBatchOpen} hideBtn={true} titleName={'提示'} >
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <i className="iconfont icon-gantan icofontStatus"></i>
              <span>批量手动付款最多只支持50笔。</span>
              <span style={{ color: "#000" }}>自动代扣不限制。</span>
            </div>
          </div>

          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.batchOpenShowModalByConfirm()}>确定</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.batchOpenShowModalByClose()}>不在提示</span>

          </div>
        </ShowModal>

        <ShowModal width={"520px"} showModal={this.state.allOrderSendChangeAddressDialog} hideBtn={true} showRightTopBtn={true} cancelDailog={() => this.closeModal("allOrderSendChangeAddressDialog")}>
            <div className="showModalWrap-box-commonContent" style={{ fontSize: "14px", padding: "10px",lineHeight:"26px"}}>
                <div style={{ paddingLeft: "16px", marginBottom: "10px"}}>
                  {
                    getLoginShopInfo().loginShopPlatformType == "TouTiao"?
                    <div>
                      <div>因抖音平台要求</div>
                      <div>发货使用的买家电话、地址信息必须与订单实际最新电话、地址信息一致</div>
                      <div>系统识别到您选择的订单中包含收件人信息已变更订单</div>
                      <div>请点击采购单右侧<span style={{fontWeight:"800"}}>【取消订单】</span>进行申请采购单退款并且退款成功后再重新下单</div>
                    </div>:
                    <div>
                      <div>因快手平台要求</div>
                      <div>发货使用的买家地址信息必须与订单实际最新地址信息一致</div>
                      <div>系统识别到您选择的订单中包含买家已变更地址订单</div>
                      <div>请点击采购单右侧<span style={{fontWeight:"800"}}>【取消订单】</span>进行申请采购单退款并且退款成功后再重新下单</div>
                    </div>
                  }
                </div>
            </div>
            <div className="showModalWrap-box-commonfooter">
                <span className="showModalWrap-box-footer-btn" onClick={() => this.closeModal("allOrderSendChangeAddressDialog")}>我知道了</span>
            </div>
        </ShowModal>

        <ShowModal width={"480px"} titleName={"提示"} showModal={this.state.pddLocalDepotTagDailog} hideBtn={true} showRightTopBtn={true} cancelDailog={() => this.closeModal("pddLocalDepotTagDailog")}>
          <div className="showModalWrap-box-commonContent" style={{ fontSize: "14px", padding: "10px" }}>
            <div>本地仓订单平台无需商家发货，且无订单收件地址，不支持采购下单。具体请至拼多多<a style={{color:"blue"}} href='https://mms.pinduoduo.com/' target='_blank'>商家后台</a>进行查询。</div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.closeModal("pddLocalDepotTagDailog")}>我知道了</span>
          </div>
        </ShowModal>

        {/* 多货源支付时，弹窗选择，提示 */}
        <ShowModal showModal={this.state.isShowMoreTypePay} hideBtn={true} titleName={'待支付'} >
          <div className="showModalWrap-box-commonContent">
              <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
                  <i className="iconfont icon-gantan icofontStatus"></i>
                  <span>待支付笔数：{this.state.aliPayOrderCodeList.length}</span>
                  <button onClick={() =>{this.closeModal("isShowMoreTypePay"); this.getOrderPayType()}}>支持阿里支付</button>
              </div>
              <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
                  <i className="iconfont icon-gantan icofontStatus"></i>
                  <span>待支付笔数：{this.state.taoTePayOrderCodeList.length}</span>
                  <button  onClick={() => this.moreTypePayByTaoteButton()}>支持淘特支付</button>
              </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowMoreTypePay")}>关闭</span>
          </div>
        </ShowModal>

        {/* 弹窗---发货失败导出 */}
        <ShowModal width={550} showModal={this.state.isShowModalByExportSelet} hideBtn={true} titleName={'请选择导出格式'} >
          <div className="showModalWrap-box-commonContent" style={{ padding: "20px" }}>
            <div className="showModalWrap-commonContent-item" style={{ marginBottom: "20px" }}>
              <label style={{ marginRight: "50px" }}>
                <input type="radio" name='exportSeletName' value="csv" style={{ marginRight: "3px" }} />CSV
              </label>
              {/* 店铺版本还需要修复Excel，才可以放开 */}
              <label>
                <input type="radio" name='exportSeletName' value="excel" style={{ marginRight: "3px" }} />Excel
              </label>
            </div>

            <div className="showModalWrap-commonContent-item" style={{ lineHeight: "22px" }}>
              <span>温馨提示：选择CSV格式导出后，<span style={{ color: "red" }}>请勿编辑</span>改格式的内容。可直接到平台店铺的后台<span style={{ color: "red" }}>批量导入发货</span></span>
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.exportSendErrorOrderByType()}>确定导出</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.closeModal("isShowModalByExportSelet")}>关闭</span>
          </div>
        </ShowModal>

         {/* 取消订单，点击后一秒弹出 */}
         <ShowModal showModal={this.state.isShowModalByCancelExamine} hideBtn={true} titleName={'提示'}>
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <i className="iconfont icon-wenhao icofontStatus"></i>
              <span>是否已成功取消了订单？</span>
            </div>

          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.cancelExamineShowModalByConfirm()}>已取消并刷新</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelExamineShowModalByClose()}>关闭</span>
          </div>
        </ShowModal>


        {/* 换款提醒弹窗 */}
        <ShowModal showModal={this.state.isShowModalChangeSku} hideBtn={true} titleName={'提示'}>
          <div className="showModalWrap-box-commonContent">
            <div className="showModalWrap-commonContent-item" style={{ padding: "20px", fontSize: "16px" }}>
              <i className="iconfont icon-wenhao icofontStatus"></i>
              <span>有已换款订单，确认已联系供应商沟通后可继续支付？</span>
            </div>

          </div>
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => this.changeSKUShowModalByConfirm()}>确认支付</span>
            <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.changeSKUShowModalByClose()}>关闭</span>
          </div>
        </ShowModal>



        {/* 取消订单，点击后一秒弹出 */}
        <ShowModal showModal={this.state.createOrderResultDailog} hideBtn={true} titleName={'订单支付结果'} width={'520px'} 
        showTitleClose={true} cancelDailog={() => this.closeModal("createOrderResultDailog")}>
          <div style={{height:'80px',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px'}}>
            <div style={{width:'470px'}}>
              成功<span className='defColor'>{this.state.createOrderResult && this.state.createOrderResult.successList && this.state.createOrderResult.successList.length }</span>笔，
              失败<span className='dangerColor'>{this.state.createOrderResult && this.state.createOrderResult.errorList && this.state.createOrderResult.errorList.length }</span>笔。
              失败的可在订单列表查看原因，然后单独确认采购单
            </div>
          </div>
          
          <div className="showModalWrap-box-commonfooter">
            <span className="showModalWrap-box-footer-btn" onClick={() => { this.setState({ createOrderResultDailog:false})}}>确定</span>
          </div>
        </ShowModal>

        {/* 付款二维码*/}
        <Dialog
          size="tiny"
          visible={this.state.payModel.qrcodeShow}
          onCancel={() => { this.closeQrCodeInfo() }}
          lockScroll={false}
          closeOnClickModal={false}
          closeOnPressEscape={false}
          style={{width:"350px"}}
          customClass="authorizationDialogWrap"
          className="taoteDailog"
        >
          <Dialog.Body>
            <div className='qrcodewarp'>
              <div>
                <h4>使用手机版淘特APP扫码付款</h4>
              </div>
              <div>
                {
                  this.state.payModel.PayUrl ?
                  <div style={{"marginLeft":"10px"}}> 
                    <QRCode
                        id="bill_qr_code_url"
                        value={this.state.payModel.PayUrl} //value参数为生成二维码的链接 我这里是由后端返回
                        size={200} //二维码的宽高尺寸
                        fgColor="#000000"  //二维码的颜色
                    />
                  </div>: null
                }
                <div>二维码过期时间倒计时： { 
                  this.state.payModel.timespan == 0 ?
                  <span style={{"color":"red"}}>已过期</span>:
                  <span><span id='authTimespan'></span>秒</span>
                }</div>
              </div>
            </div>
            <div className='hint'>
              提示:若出现未找到订单的情况，可能是因为当前扫码账号和绑定的采购账号不一致，请登录采购账号后再扫码。
            </div>
          </Dialog.Body>
        </Dialog>

        <MultiProductSkuMappingModule
          showDialog={this.state.multiProductSkuMappingModuleDailog}
          closeProductMapping={this.closeProductMapping}
          saveSure={this.multiProductSkuMappingSaveSure}
          products={this.state.multiProductSkuMappingModuleList}
        />
        <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} title={this.state.loadingTitle}/>
        <NewUserGuide></NewUserGuide>
      </div>

    )
  }
}

export default orderList;


// WEBPACK FOOTER //
// ./src/pages/orderList/orderList.jsx